var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _path44, _g3, _path45, _path46, _g4, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g5, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _g6, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _g7, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _g8, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _g9, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _g0, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _g1, _path382, _g10, _path383, _path384, _path385, _path386, _path387, _g11, _path388, _path389, _path390, _path391, _g12, _path392, _path393, _g13, _path394, _g14, _path395, _g15, _path396, _path397, _path398, _path399, _g16, _path400, _g17, _path401, _path402, _path403, _path404, _path405, _path406, _g18, _path407, _path408, _g19, _path409, _path410, _path411, _path412, _path413, _g20, _path414, _g21, _path415, _path416, _path417, _path418, _g22, _path419, _path420, _g23, _path421, _path422, _path423, _path424, _g24, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _g25, _path435, _path436, _path437, _path438, _g26, _path439, _g27, _path440, _path441, _path442, _g28, _path443, _path444, _path445, _path446, _path447, _g29, _path448, _g30, _path449, _g31, _path450, _path451, _g32, _path452, _g33, _path453, _path454, _g34, _path455, _g35, _path456, _path457, _g36, _path458, _path459, _g37, _path460, _path461, _g38, _path462, _path463, _path464, _path465, _path466, _path467, _g39, _path468, _path469, _g40, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _g41, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _g42, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _g43, _path568, _g44, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _g45, _path660, _path661, _g46, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _g47, _path672, _path673, _path674, _path675, _path676, _path677, _g48, _path678, _g49, _path679, _path680, _path681, _path682, _g50, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _g51, _path721, _path722, _path723, _g52, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _g53, _path743, _g54, _path744, _g55, _g56, _g57, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsCountries(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 111,
    viewBox: "0 0 192 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_183857)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.663 10.677L135.505 10.8688L135.797 11.2185L135.522 11.3425L135.556 11.7543L135.876 11.6246H136.196L136.168 11.8671L135.915 12.2224L136.393 12.3634C136.393 12.3634 136.387 12.5496 136.331 12.5665C136.28 12.5834 135.5 12.7018 135.46 12.7075L135.135 12.95L135.427 13.0797L135.865 12.9613L136.241 13.0854L136.735 13.1023L137.943 13.1192L138.549 13.3223L138.903 13.4689L140.33 13.8976L140.745 13.9201L141.228 14.4052L141.161 14.6026L140.745 14.3883L140.425 14.3601L140.863 14.7323L140.56 14.9523L139.959 15.2569L140.285 15.6912L140.302 15.9055L139.499 15.9732L139.246 16.0578L139.65 16.1932L139.684 16.43L139.167 16.5429L139.712 16.7515L139.499 16.8249L138.954 16.8531L138.628 16.9715L139.083 17.1746L139.807 17.3156L139.965 17.7217L139.723 17.7555L139.162 17.9078L138.695 17.8514L138.117 17.654L137.786 17.8796L137.151 17.7555L137.28 17.2874L137.067 17.0618L136.954 16.2665L137.488 15.9168L137.752 15.7532L138.325 15.522L138.078 15.3697L138.033 15.1384L137.493 15.0933L137.14 14.9636L137.325 14.7549L137.859 14.8846L138.05 14.6872L137.92 14.3319L137.611 14.0047L136.943 13.7622L136.235 13.7114L135.539 13.2038L135.595 13.5592C135.561 13.5592 134.888 13.4689 134.775 13.4971C134.663 13.531 134.152 13.4238 134.124 13.4238L133.534 13.1136L133.792 12.9218L133.073 12.668H132.36L132.091 12.5834L132.399 12.2901L133.337 12.307L133.888 12.1547L134.287 12.104L134.691 11.7994L134.809 11.6866L135.241 11.7599L135.163 11.5964L134.994 11.4497L135.196 11.2523L134.888 10.9026L134.966 10.8293L135.028 10.739L135.32 10.6093L135.646 10.677H135.663Z",
    fill: "#7F8DC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3309 19.0189L97.9153 19.222L97.9041 18.8723L98.3309 19.0189Z",
    fill: "#7F8DC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.068 21.9349L150.787 22.6343L150.984 23.1306L150.602 23.5198L149.557 23.6834L148.777 23.2604L148.103 23.3732L147.974 23.8695L147.592 24.112L147.03 23.8639L147.373 23.2209L148.007 22.7584L148.052 22.2395L147.277 22.3015L147.036 22.8204L146.457 23.0235L145.862 22.8204L145.064 22.9896L144.183 22.5328L143.497 22.6399L143.554 23.2716L144.143 23.6495L144.576 24.3546L144.261 25.0032L143.846 25.0483L143.368 24.6986L143.548 24.0049L143.301 23.7003L142.812 22.9671L142.234 22.4256L141.655 22.0195L141.049 22.2508L139.779 21.9575L140.06 21.6021L138.92 21.3596L138.342 20.8576C138.386 20.8351 139.251 20.3556 139.532 20.4233C139.819 20.491 139.779 20.3669 139.774 20.3613L140.65 20.3444L141.52 20.9027L141.29 21.2355L142.144 21.6755L142.728 21.5627L143.57 21.0945L144.222 20.8689L145.036 21.3765L145.744 20.9591L145.71 21.1002L146.749 21.3483L147.249 21.5739L148.097 21.6134L148.889 21.918L150.057 21.9462L150.068 21.9349Z",
    fill: "#7F8DC8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.264 24.5633L153.618 25.1724L153.056 25.8154L151.647 26.5261L152.607 26.4076L153.461 25.9056L154.404 26.1256L153.747 26.7066L155.118 27.2593L156.044 27.1296L156.735 27.5018L156.567 27.9812L155.836 28.1223L155.044 27.9023L154.337 27.9192L155.224 28.6186L154.803 29.0473L153.904 28.4607L153.607 28.5622L152.304 28.2576L151.461 27.4229L150.945 26.9434L150.316 26.825L150.068 27.2593L150.843 27.609L151.18 28.6919L151.972 29.3969L151.383 30.0005L150.602 29.8369L149.524 30.7506L148.979 30.666L148.243 31.168L146.828 30.9931L145.918 30.5081L144.166 30.2035L143.537 29.2898L144.84 29.2052L145.053 28.3761L145.137 26.9434L144.75 26.7009L145.075 26.4358L144.497 25.5108L145.317 25.257L145.935 25.4544L147.58 25.2909L148.035 25.4544L147.665 25.9959L148.254 26.6219L149.209 26.4527L150.068 26.4809L150.815 26.0354L151.461 25.9L152.725 25.1104L152.556 24.5294L153.264 24.5633Z",
    fill: "#7F8DC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2968 28.1956L79.9598 28.5453L79.2634 29.2052L78.9152 29.7635L78.2862 30.4347L78.8478 30.9254L79.7633 30.8126L80.8641 30.7337L80.2631 30.8916L79.5835 31.3992L78.5108 31.6135L78.0222 31.9125L77.5897 31.9012L77.1966 31.1341L76.8877 30.6885L77.2022 30.1866L77.6571 29.6113L78.6119 28.9852L79.0051 28.5396L79.6004 28.1674L80.2968 28.1956Z",
    fill: "#7F8DC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5108 31.6135L78.5558 33.3846L78.2356 33.4579L78.1458 33.142L78.0615 33.159L78.0222 31.9125L78.5108 31.6135Z",
    fill: "#7F8DC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7132 33.9091L77.6458 34.2814L77.3313 34.5634L77.2022 34.4619L77.1853 33.8414L77.7132 33.9091Z",
    fill: "#7F8DC8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.962 37.4625L111.007 39.2053L110.973 39.1376L109.822 39.0079L108.62 39.3519L108.609 38.8951L110.962 37.4625Z",
    fill: "#7F8DC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.133 34.0389L158.179 34.7213L158.319 35.4264L157.819 35.9001L157.246 35.7648L157.285 35.2064L157.01 34.789L156.466 35.5166L155.309 36.3401L156.173 36.357L156.471 36.5093L155.859 36.9436H154.494L153.231 37.3948L152.568 37.8911L151.753 38.2183L150.119 39.0305L148.9 39.2053L147.884 39.8596L146.693 40.057L146.334 40.1303L145.418 40.3108L145.328 40.1247L144.885 40.277L143.829 40.2318L141.975 40.3334L140.953 40.26L140.296 40.2431L140.891 40.6323C140.891 40.6323 140.347 40.6774 140.234 40.6661C140.122 40.6605 138.858 40.6492 138.791 40.6492L137.213 40.2206L136.814 39.7975L136.016 39.6001L135.831 39.8088L135.359 39.7863L135.101 39.555L134.365 39.4986L133.787 39.7299L131.81 39.5268L131.838 39.194L132.63 39.1207L133.22 38.7767L134.562 38.8218L135.556 38.6582L137.185 38.7428L137.505 38.5736L138.785 38.4834L139.757 38.3536L140.178 38.5229L141.195 38.5623L141.852 38.5736L142.026 38.286L142.706 38.269L143.745 38.3706L143.992 38.1393L144.671 37.9363L144.834 38.0152L144.486 38.5059L144.003 38.5285L143.902 39.1997L144.89 39.7806L145.171 39.4366L147.283 39.1433L147.861 38.6751L148.075 38.2239L148.676 38.269L149.619 37.8968L150.574 37.4907L150.523 37.6937L151.029 37.6091L152.141 37.2989L152.871 36.9549L152.781 36.7011L153.73 36.3514L154.567 35.9622L155.69 35.3192L156.398 34.6085L157.156 34.4337L157.606 34.0163L158.364 33.644L159.122 34.0389H159.133Z",
    fill: "#7F8DC8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8326 42.8095L73.0405 42.9617L73.0461 43.1028L72.6529 43.1761L72.2822 42.7305L72.1812 42.7249L72.1643 42.1326L73.0292 42.3808L72.8326 42.8095Z",
    fill: "#7F8DC8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6978 43.8642L72.2598 44.0729L72.2485 43.7175L72.6978 43.8642Z",
    fill: "#7F8DC8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2092 43.7062L72.2485 43.7175L72.2598 44.0672L72.2205 44.0898L72.2092 43.7062Z",
    fill: "#7F8DC8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6935 49.2167C68.7272 49.2337 68.7496 49.2619 68.7665 49.2844L69.0698 49.8372L69.0978 49.871L69.5359 50.2997C69.5865 50.3504 69.5921 50.4181 69.5359 50.4689L68.935 51.1006C68.935 51.1006 68.9069 51.1288 68.89 51.1401L67.6881 51.8507C67.6376 51.8789 67.6095 51.9184 67.6039 51.9579L67.5646 52.3584C67.5646 52.3978 67.5309 52.4373 67.4803 52.4655L66.7278 52.9111C66.6941 52.9337 66.6716 52.9562 66.6547 52.9844L66.3402 53.6556C66.3009 53.7402 66.1437 53.7966 65.992 53.7741L65.8685 53.7571C65.8123 53.7515 65.7674 53.7346 65.728 53.712C65.6719 53.6782 65.6382 53.6331 65.6438 53.5879L65.6719 52.9167C65.6719 52.8716 65.6382 52.8265 65.582 52.7927C65.5539 52.7757 65.5202 52.7645 65.4809 52.7532L65.0429 52.6517C65.0035 52.6404 64.9698 52.6291 64.9418 52.6122C64.8968 52.584 64.8631 52.5501 64.8575 52.5106C64.8519 52.4712 64.8182 52.4373 64.7733 52.4091C64.734 52.3866 64.6834 52.3696 64.6216 52.364L64.0993 52.3076C64.0431 52.302 63.987 52.285 63.9477 52.2568C63.9308 52.2456 63.9196 52.2399 63.9084 52.2286L63.3018 51.6533C63.2288 51.5856 63.2512 51.4898 63.3579 51.439L63.8859 51.1683C63.9982 51.1119 64.0151 51.0103 63.9252 50.937L63.5938 50.6889C63.5938 50.6889 63.577 50.6776 63.5658 50.6719C63.504 50.6381 63.4141 50.6155 63.3243 50.6268L62.83 50.6663C62.7345 50.6719 62.6503 50.7114 62.6054 50.7622L62.2515 51.1852C62.2122 51.236 62.2122 51.2924 62.2628 51.3431L62.7514 51.8451L63.8016 52.6573C63.9196 52.7475 63.8578 52.8773 63.6781 52.9167L63.431 52.9731C63.3804 52.9844 63.3411 53.0013 63.3074 53.0295L62.5548 53.5936C62.5548 53.5936 62.5267 53.6218 62.5155 53.6387L61.6787 54.919C61.6337 54.9924 61.5046 55.0375 61.3698 55.0262L61.0103 54.998C60.9429 54.998 60.8868 54.9754 60.8418 54.9472C60.8194 54.936 60.8025 54.9247 60.7913 54.9078L60.3195 54.3832L59.8421 53.8756C59.8421 53.8756 59.8084 53.8474 59.7916 53.8361C59.7691 53.8248 59.741 53.8135 59.7129 53.8023L58.9828 53.5992C58.9491 53.5879 58.9267 53.5767 58.8986 53.5654C58.7806 53.4977 58.7806 53.3849 58.9154 53.3172L59.4771 53.0408C59.5445 53.007 59.5838 52.9562 59.5782 52.9055L59.5669 52.7475V52.7081L59.7017 52.2738C59.713 52.2512 59.7298 52.223 59.7579 52.2004L60.4936 51.6364C60.5835 51.5631 60.561 51.4672 60.4655 51.4108C60.4318 51.3882 60.3869 51.377 60.3307 51.3657L59.6512 51.2642C59.595 51.2585 59.5501 51.2416 59.5108 51.219L58.8031 50.7847L58.7638 50.7622L57.9887 50.4238C57.9887 50.4238 57.9663 50.4125 57.955 50.4068C57.8933 50.373 57.8596 50.3166 57.8708 50.2658L57.9326 49.9387C57.955 49.8203 58.1685 49.7582 58.3482 49.8033L58.4605 49.8372C58.6964 49.8992 58.9491 49.7695 58.8593 49.6285L58.8143 49.5552C58.775 49.4931 58.8031 49.4254 58.8817 49.3803L59.1625 49.2111L59.1962 49.1885L59.9151 48.5681C59.9769 48.5117 59.9825 48.444 59.9208 48.3876L59.6175 48.0943C59.5613 48.0379 59.5613 47.9703 59.6175 47.9195L59.668 47.8687C59.7691 47.7672 59.9994 47.7616 60.1286 47.8349C60.151 47.8462 60.1735 47.8687 60.1903 47.8856L60.4655 48.241L60.5049 48.2861C60.5049 48.2861 60.5386 48.3199 60.561 48.3369C60.6846 48.4102 60.898 48.4046 61.0047 48.3143L61.19 48.1564C61.2743 48.0831 61.4372 48.0661 61.572 48.1056L62.3077 48.3481C62.3077 48.3481 62.3526 48.3651 62.3695 48.3763C62.42 48.4045 62.4481 48.444 62.4537 48.4892L62.4874 48.8219C62.4874 48.867 62.5267 48.9065 62.5773 48.9347C62.6054 48.9517 62.6391 48.9629 62.6728 48.9742L64.1611 49.3126C64.1948 49.3183 64.2285 49.3239 64.2622 49.3239L65.7842 49.3408C65.846 49.3408 65.9022 49.3521 65.9471 49.3747L66.5705 49.6341C66.6884 49.6792 66.8457 49.6736 66.9468 49.6172L67.778 49.1321C67.8566 49.087 67.969 49.0701 68.0701 49.0927L68.5587 49.1829C68.6036 49.1885 68.6429 49.2055 68.6766 49.2224L68.6935 49.2167Z",
    fill: "#7F8DC8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.496 10.8857C127.614 10.9533 127.727 11.0323 127.845 11.1225C127.171 11.5738 126.704 12.0757 125.856 12.1265C125.379 12.1547 124.89 12.1209 124.407 12.1152L123.75 11.8445V11.6189L122.857 11.1789L122.796 10.7108L122.127 10.66L122.335 11.2297L121.953 11.3989L121.262 11.2241L120.291 11.6414L120.751 12.1209L121.728 12.1829L120.88 12.7977L119.942 13.0402L119.521 13.6832L118.387 14.0724L117.252 14.8677L118.067 15.5107L118.302 16.1818L118.943 15.7419L119.83 15.7024L120.313 15.4204L121.936 15.082L121.61 14.9241L121.369 14.8056L122.166 14.7041L124.312 14.6533L126.485 14.5405L127.3 14.5857L126.345 14.8395L126.862 15.0594L127.569 14.9692L128.973 14.8564L128.99 15.0369L128.58 15.2286L128.625 15.5163L127.395 15.4994L126.418 15.2738C126.362 15.2681 125.317 15.144 125.267 15.1722C125.216 15.2004 123.975 15.0876 123.908 15.0876L123.879 15.3753L125.727 15.6235L126.918 16.2044L128.019 17.0335L127.772 17.919L127.047 17.9811L127.03 18.4154L127.575 18.6861L127.991 18.8835L127.766 19.2501L128.204 19.3517L129.266 19.1712L130.72 19.2219L131.911 19.5209L131.591 19.8367L131.714 20.2936L130.995 20.6771L129.872 20.2203L129.024 19.9721L128.631 20.3951L127.957 20.3838L127.232 20.0229L126.62 20.068L125.946 20.6376L125.789 21.1622L126.306 21.0437L127.249 20.8012L127.805 20.9027L127.502 21.1509L127.609 21.9236L128.109 21.7431L129.176 21.8841L130.288 21.777C130.338 21.777 131.237 21.8616 131.315 21.9011C131.389 21.9405 131.827 22.1097 131.933 22.1097C132.046 22.1097 132.422 22.1605 132.439 22.1661L133.09 22.5779L133.495 23.1306L134.416 23.3901L134.444 23.8357V24.6027L134.303 25.3754L133.978 26.0466L133.023 26.5317L133.579 26.8193L133.422 27.1239L132.916 27.186H132.164L131.658 27.5639L131.821 28.4043L132.574 28.3084L133.551 28.4776L134.758 28.3479L136.393 28.5171L137.842 29.1262L138.207 29.8876L137.948 30.3445L138.308 30.7675L137.741 31.2244L136.679 31.089L135.696 31.1905L134.354 31.0495L134 31.3203L133.231 31.2639L133.955 31.9463C133.955 31.9463 134.506 32.2678 134.444 32.3411C134.539 32.3975 135.382 32.3299 135.427 32.3299L135.82 32.5329L136.505 32.6288L137.01 32.437L138.437 32.3129L139.195 32.578L140.122 32.9898L141.492 33.0687L141.717 33.2831L141.24 33.4466L140.358 33.5538H138.982L136.022 33.0913L135.646 33.4072L134.865 33.2492L133.787 32.2847L132.074 31.7376L129.67 31.1736L129.619 32.0873L128.929 32.1945L127.496 31.591L126.12 31.5459H124.194L122.891 32.5047L123.329 32.9785L123.481 34.2137L123.784 35.0541L123.132 35.6689L124.548 36.295L125.682 37.0902L126.418 37L128.44 37.1466L129.322 37.7276L128.665 38.2916L127.586 38.2521L126.306 37.8122L126.424 38.3311L125.755 38.7203C125.424 38.6582 119.156 37.4681 119.134 37.4568C119.033 37.3892 118.943 37.3384 118.836 37.2876C118.448 37.0902 117.864 36.8026 117.831 36.7857L116.786 36.577L116.404 37.2256L114.921 37.2707L113.989 36.9549L112.063 36.9379L110.956 37.4794L108.603 38.912L107.25 39.2279L108.283 39.4648L108.614 39.3689L109.816 39.0248L110.962 39.1546L112.018 41.0102L111.349 41.969L111.518 42.6854L110.03 44.6087L109.182 45.7367L110.018 45.9623L111.209 45.3588L112.478 43.8416L113.467 44.259C113.557 44.3774 115.298 46.5828 115.331 46.6222C115.365 46.6617 115.343 48.2241 115.343 48.303L115.556 50.311L116.342 51.6759L117.241 51.9184C117.292 51.941 118.229 52.3922 118.28 52.4204C118.331 52.4486 119.162 52.5614 119.207 52.5671L121.549 53.5372L122.054 54.1463L121.818 55.5789V56.5434C121.908 56.5716 123.453 57.1582 123.599 57.2315C123.644 57.2767 124.424 57.7674 124.464 57.7899L123.711 58.636C123.745 58.6529 124.357 58.9462 124.407 58.9744C124.464 59.0082 125.233 60.187 125.272 60.2491L125.817 62.0032L125.491 62.9225L124.245 63.4866L123.492 64.3213L122.616 64.953L121.262 64.829L120.819 64.3946L117.438 63.8475L115.814 63.3625L114.523 62.7195H113.675L110.552 62.1893L108.592 60.9033L108.513 60.1814L106.413 59.1549L104.396 58.6698L102.116 58.6247L100.549 58.354L100.066 57.6207L99.308 57.0116L98.3251 56.9721L97.522 57.5248L96.8817 57.7448L95.4608 57.5079L93.9949 58.3483L93.7366 59.2846L93.4109 59.6681L91.7484 60.187L91.6249 60.7341L90.8947 61.411L87.4238 61.5294L86.4859 61.5407L85.3346 61.2192L83.4138 61.5689L82.4534 61.4617L81.9985 61.0725L81.566 60.8639L80.2911 59.6399L79.5497 59.482L79.0667 59.1323L78.3984 59.0703L77.2864 58.1453L77.4492 57.5248L76.9775 57.0341L77.0729 56.6168L76.5169 56.1373L77.1628 55.2123L76.955 54.5355L76.3147 54.3043L75.8149 53.8982L76.1743 52.7193L75.916 52.223L76.4944 51.9692L76.955 51.5913L77.5559 51.4559L77.9603 50.8073L78.404 50.0854L79.2521 49.4649L79.7912 49.2224L80.19 48.7712L80.9201 48.4948L81.0942 47.9703L81.6671 47.8518L81.639 47.4965L82.2006 47.5472L82.5489 47.8575L83.206 48.0661L83.2902 48.5907L83.762 48.6189L84.8628 48.4553L85.211 48.0492L86.1714 47.8067L86.9464 47.9985L87.4968 47.88L88.0697 47.6036L88.8223 47.519L88.9796 47.1693L88.3955 46.9268L88.1989 46.6448L88.9627 45.9398L89.5524 45.9003L90.2376 45.5788L90.8329 45.6296L92.8436 44.902L92.6751 44.4959L93.2367 44.039L94.0062 44.0221L94.8093 43.4242L93.804 42.4259L93.1076 42.0424L92.237 41.9014L92.1416 42.3413L91.6192 42.7587L90.4791 42.9335L90.6476 43.2776L90.2601 43.4919H89.8557L89.7097 43.9713L88.7942 43.9206L88.3281 43.7626L87.6597 43.8811L86.8847 43.6273L86.7049 43.3791L86.3624 43.1422L85.475 43.4693L85.7558 43.7401L85.6996 43.96L84.9302 44.0503L85.3458 44.1631L86.4466 44.1123L87.1318 44.0334L87.2441 44.4L86.7218 44.4338L86.8903 44.6482L87.5249 44.8512L86.9745 44.9471L86.9464 45.1276L86.6095 45.1727L86.1714 44.9979L85.7614 45.3645L85.4076 45.2122L85.5424 44.9697L85.1829 44.885L84.3798 45.0261L83.498 44.6989L83.1723 44.479L82.2006 44.5297L81.1841 44.9132L80.3416 44.8738L79.9934 44.7497L79.4767 45.0261L78.7522 44.9471L78.4658 45.1389L78.6904 45.2517L78.9207 45.4716L79.926 45.3193L80.2855 45.545L81.156 45.3701L81.7008 45.0712L81.7963 45.3306L82.2793 45.246L83.3071 44.964L83.6103 45.0825L83.6665 45.2742L82.8184 45.3645L82.7679 45.5788L83.2734 45.4942L83.5598 45.5562L83.7676 46.0413L83.6384 46.2443L83.6777 46.5997L84.1607 46.8253L83.8182 47.0283L83.1442 47.0735L82.4421 47.2539L82.1052 47.0453L82.2456 46.8591L82.869 46.7012L83.1161 46.4474L83.3576 46.2218L83.2284 45.9905L82.4309 45.7762L81.0212 45.9567L79.7519 46.3177H79.224L79.0499 46.4982L78.6904 46.453L78.6174 46.2725L78.3478 46.1428L78.0277 46.2725L77.4548 46.4812L77.6907 46.9607L77.3032 47.0678L77.1909 47.2539L76.0002 47.6318L75.8991 47.8969L76.6349 48.2072L76.4271 48.6189L75.9328 49.0306L76.2642 49.1716L76.3203 49.7075L76.8202 49.7187L76.9606 49.9105L76.9943 50.153L77.2358 50.373L76.8988 50.5986L76.9831 50.9088L76.5281 51.2078L76.281 51.4108L75.9946 51.6759L76.2361 51.8959L75.944 52.0651L75.4554 52.082L75.1072 51.9015L74.7534 51.9748L74.7309 52.2117L74.2928 52.3527L74.2479 52.584L73.7256 52.4261L73.4279 52.0707L73.2201 52.2004L72.8495 52.2681L72.5462 52.0876L72.5574 51.7887L72.1699 51.3544L71.6532 51.2134L71.3724 50.9709L71.0859 50.9201L70.85 50.8017L71.0578 50.5309L70.968 50.2771L71.7655 50.0684L72.827 49.5044L73.456 48.8953L72.7652 48.2072L71.6532 48.0718L70.7152 48.4722L70.1648 48.2861L70.9006 47.7729L70.8444 47.3442L71.6251 46.6786L71.6925 46.1203L71.6195 45.3814L71.7823 44.6707L71.9621 44.2421L72.2148 44.1236L72.6978 43.898L72.2485 43.7457L71.7093 43.6273L70.9287 43.2212L71.3892 42.7305L72.1755 42.753L72.6473 43.2043L73.046 43.1309L72.8326 42.8376L73.0292 42.409L72.1643 42.1608L70.9006 42.0706L71.0185 42.6177L70.3502 43.0914L69.6144 43.2494H68.918L67.688 42.6854V42.1326L68.1879 40.9369L68.0756 39.7581L67.66 39.6509L67.4409 39.2843L68.1654 38.2634L69.3392 37.1918L70.5187 36.137L72.1923 35.7197L73.0067 35.4828L73.7705 35.1274L76.4607 34.1629L76.9775 34.3209L77.1965 34.4957L77.6402 34.3152L77.7076 33.943L77.1796 33.8753L76.7528 33.6384L77.219 33.362L78.0558 33.1928L78.2299 33.4861L78.5556 33.4184L78.9039 33.3451L79.0049 33.0405L79.4093 32.2622L79.6958 31.9125L80.1395 31.6587L80.482 31.811L81.4256 30.9649L81.2122 30.6716L80.8696 30.7619L81.083 30.4799L81.6783 30.3783L82.3579 29.8764L83.8069 29.3744L83.3071 29.2446L82.8241 29.16L82.8521 28.7934L82.1052 28.5283L82.5432 28.1166L83.2284 27.9192L83.8687 27.9474L84.3742 27.9587V27.6485L83.6777 27.5977L84.1158 27.389L84.7673 27.4059L85.0537 27.3834L84.9583 27.0111L85.6435 26.8024L85.3233 26.7235L85.7333 26.1651L85.7895 25.8831L85.7502 25.4939L86.7892 24.5012L87.334 23.7398L88.2157 23.5762L88.7437 23.0517C88.7437 23.0517 88.9402 22.5835 88.9515 22.5102C88.9571 22.4369 89.4457 22.0928 89.4682 22.0759L90.7375 21.7036L91.3553 21.1565L93.3322 20.6151L93.7366 20.914L94.8992 20.632L96.2022 19.7578L97.1457 19.6224L97.9095 19.2558L98.3251 19.0527L97.8983 18.9061L98.0219 18.6918L99.0721 18.4097L99.117 18.1898L99.8359 17.9134L101.1 17.7555L101.88 17.5975L102.622 17.4171L102.56 17.1181L103.301 16.7628L104.132 16.2721L103.975 16.0521L103.694 15.8321L104.717 15.4543L105.924 14.8338L107.446 13.9652L108.339 13.8017L109.339 13.5253L109.889 12.8879L111.821 12.0081L112.647 12.0814L115.14 10.8011L114.888 10.5924L115.135 10.316L116.05 10.2934L115.921 9.9663C115.91 9.93246 117.32 9.26127 117.421 9.2105C118.179 8.83261 118.836 8.16706 119.707 8.27422C121.122 8.44907 122.52 8.72544 123.891 9.10334C124.031 9.14282 124.183 9.1823 124.306 9.25563C124.902 9.75761 124.497 10.2878 124.795 10.4626C124.885 10.5134 125.031 10.536 125.284 10.5078C126.092 10.5078 126.806 10.5247 127.474 10.9082L127.496 10.8857Z",
    fill: "#7F8DC8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.485 52.7645L188.703 55.562L188.861 58.3822L190.691 64.8402L187.984 66.5323L190.675 66.8764L191.832 68.1623L192 70.5877L191.023 71.9864L187.243 70.8584L185.828 69.0366L183.783 69.736L182.014 68.2582L177.847 69.4765L174.814 67.6491L168.49 70.3056L168.159 73.1991L165.07 74.6712L161.896 77.92L159.319 78.6137L157.476 78.4614L157.561 76.5212L152.208 74.1805L148.816 72.6858L148.153 71.1291L149.372 68.5741L152.113 65.754L150.411 64.6485L150.647 62.5108L151.377 59.6117L154.387 58.7093L153.669 57.2203L152.86 55.6354L154.365 54.513L156.572 53.8925L157.729 52.9732L158.729 52.6291L160.206 53.1198L161.054 54.1689L161.728 55.2462L164.559 54.8345L167.092 54.3494L165.923 52.6573L163.57 51.1401L162.121 50.091L162.127 49.104L162.846 48.6866L165.805 50.029L167.137 50.0572L169.647 50.2602L173.629 51.721L176.701 51.2642L179.947 52.3584L184.485 52.7645Z",
    fill: "#7F8DC8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0427 15.1215L63.9925 16.4864L62.2345 18.0544L61.9762 19.002L64.2283 19.425L63.1725 20.3838L64.5316 21.1396L65.2112 22.1154L63.5881 23.1306L63.6948 24.2587L64.3463 24.394L65.2505 25.1047L63.6555 27.953L61.8695 29.4646L59.6454 30.9762L59.8195 32.5893L57.7134 34.5352L55.568 36.3457L56.3823 37.3835L56.68 38.9233L57.3315 41.3317C57.2866 41.3655 56.3879 41.9634 56.1745 42.0085C55.9611 42.0593 54.5626 42.0649 54.4952 42.0649L52.7935 42.7756L50.6424 42.4259L45.0654 41.0328L44.515 39.6509L44.5319 38.5285L42.8133 38.7203L43.0379 37.4061L42.7964 37.2538L41.909 37.784L41.4822 36.4021L39.7748 35.2684C39.713 35.2854 38.6066 35.6576 38.4718 35.7479C38.337 35.8381 35.3941 36.9436 35.2368 37L33.2262 38.4439L31.384 38.9628L30.9628 38.3254L30.2327 38.3649V37.8122L32.4343 36.0412L33.6249 35.0203L33.1251 34.0783L35.2031 32.0986L38.0394 30.3389L40.2691 28.2407L41.7405 28.0094L41.499 27.5187L42.4931 26.9322L44.0882 26.5261L43.7568 25.8097L47.4074 23.6665L51.4849 21.275L53.9561 19.8762L58.0897 17.9924L59.4769 17.6483L61.0832 17.214L62.3019 15.9111L64.5316 15.0876L65.0483 15.1102L65.0427 15.1215Z",
    fill: "#7F8DC8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9571 48.8953L51.2492 49.3183L50.5471 49.8315L50.7381 50.1305L50.3449 50.4689L48.8173 49.9161L48.6488 50.4689L49.5755 50.6324L50.4123 50.9483L50.9796 51.6703L49.5249 51.7661L50.4685 51.9692L50.5359 52.2963L49.1655 52.4204L48.7723 52.7532L47.7333 52.7927L47.1155 52.3978L45.9417 52.5276L45.3464 52.8096L44.8072 53.2721L44.1389 52.6065L44.1557 52.5389L45.1891 52.1722L45.8069 51.9071L45.7451 51.5349L46.2169 50.8863L45.5767 50.5817L45.4082 50.8411L45.206 51.2811L44.3635 51.8677L43.639 51.5123L44.0434 50.8411L44.5713 50.4914L43.6671 50.294L43.639 51.1231L43.0718 51.1852L42.4259 51.0273L41.5217 50.9483L41.0499 51.3544L41.005 51.3882L40.6961 51.439L40.1794 51.518L39.7357 51.4672L39.6458 51.518L39.3762 51.0047L39.3875 50.4858L39.5503 50.0289L40.2299 49.6454L40.8646 49.5608L40.9713 49.7808L42.7123 49.1829L42.454 48.6302L43.6278 48.241L44.2175 48.3989L45.2734 48.4497L46.0709 48.1564L46.874 48.3143L47.5143 47.9477L48.6713 48.5681L48.5028 49.1209L49.3284 48.9911L50.9571 48.8953Z",
    fill: "#7F8DC8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9621 52.6742L32.9455 53.3849L33.4903 53.7515L33.451 54.3211L34.5462 54.3832L34.1362 55.1785L33.4285 55.5846L32.0581 55.5564L31.5639 56.2727L31.4123 56.4926L30.5417 56.8705L29.6094 57.2654L28.4805 57.5022L27.5145 57.2992L27.7055 56.6506L27.1101 56.487L26.8518 56.8705L26.3912 57.3218L25.7847 57.7448L25.5319 57.5586L24.4592 57.6489L24.8074 56.9777L25.6443 56.2896L25.5769 55.8891L26.043 55.4041L27.5033 54.8852L28.4244 54.8175L28.6265 54.9247L29.6375 54.7611L31.2269 54.2704L32.4176 53.4131L32.8613 52.7024L33.9621 52.6742Z",
    fill: "#7F8DC8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2361 57.1526L58.2639 57.8294L58.4661 59.042L60.078 58.9969L60.3812 59.6512L61.8302 60.3957L61.5045 60.9936L59.5276 60.5762L58.4268 60.8751L57.3877 61.535L56.9946 60.7003L57.0058 59.1661L55.7927 60.0686L55.5343 60.8074L54.8211 61.2135L54.5234 62.2795L56.2476 61.9637L56.6857 62.5446L54.4055 64.3495L53.7933 64.4172L53.3271 63.3174L51.7265 65.1843L51.6647 66.4026L50.109 67.9536L49.772 69.8206L49.3339 71.1686L48.396 72.2797L47.6378 74.1353L49.8618 76.0305L50.5695 75.8669L51.3614 76.053L51.85 76.758L52.2881 77.1867L51.6703 76.978L50.9795 76.3802L49.6203 76.696L49.2777 77.0175C49.1823 76.9893 47.4075 76.4986 47.2053 76.3802C47.0087 76.1884 46.829 75.3198 46.8234 75.2747C46.7223 75.2747 44.7397 75.2634 44.6274 75.2013C44.5207 75.1393 42.9874 75.771 42.9032 75.8048L42.701 76.5212L41.9877 77.0683L41.1284 76.6791L39.4155 77.0401L38.2192 78.1004L38.5393 79.6177L39.73 81.1518L40.5893 82.3137L42.2012 82.8044L43.1166 82.4603L44.5151 82.4829L44.8015 81.6369L44.0714 80.836L45.2789 80.2945L46.683 79.8602L47.4637 82.7311L49.1598 82.1388L51.4288 82.5111L52.3723 84.034L54.2482 85.0492L55.4782 84.034L57.8539 83.6617L57.545 82.9285L58.8536 81.5071L60.1117 80.819L62.5379 81.4451L67.1826 80.4468L69.2887 80.5765L71.9565 81.4902L73.4448 80.7401L76.9887 81.1969L80.6169 82.8946L82.6388 82.686L84.7842 82.9341L87.7552 82.4998L89.94 82.8552L91.945 82.4885L93.3884 83.5489L94.2814 84.8631L94.1354 87.012L96.9941 90.351C97.0334 90.4356 97.7692 92.0036 97.6793 92.1108C97.5895 92.218 95.4833 92.9061 95.3766 92.9399L93.849 94.2597L95.1857 95.619L96.0281 98.2079L95.8877 99.6969L94.2197 100.227L95.4553 101.084L96.1404 101.846L94.2084 102.968L94.6072 103.544L94.2084 104.26L95.854 105.676L95.2081 106.488L97.1345 106.572L97.7355 107.148L98.6341 107.898L98.2971 108.687L99.9539 109.376L102.728 109.263L103.857 109.68L103.256 110.667C103.071 110.684 99.5215 110.994 99.4653 111.011C99.4091 111.028 95.5732 110.233 95.371 110.193L91.8496 109.06L91.2879 108.287L89.3503 107.119L86.4803 105.738L85.9131 104.226L79.2465 101.727L76.4496 97.0686L71.496 98.1007L67.1602 96.9276L64.4081 92.6917L61.6281 93.2783L59.1063 91.7949L58.8592 88.6082L59.4433 87.2602L59.1063 85.8558L57.955 84.818L57.5281 85.3143L56.2532 86.2449L54.1471 85.7824L50.884 85.3481L49.4912 84.4119L47.6041 84.4288L45.5429 84.3893L43.448 84.1862L42.1562 84.6826L37.9889 84.8236L35.4559 84.6431L34.6416 83.6955L33.1476 82.6013L31.2605 82.1783L28.9354 81.0221H27.5088L29.8003 82.4603L31.1033 82.748L31.9682 83.4925L31.429 83.8084L29.5981 83.0074L27.565 82.6126L25.633 81.7835L26.1384 81.0446L25.0657 80.5878L24.1334 79.3977L22.6563 79.3582L20.3031 78.766L18.4272 76.5268L18.7361 73.7913L18.6799 71.9808L17.7645 71.5972L16.6188 70.8978L17.1018 70.4184L16.2537 69.5216L15.3214 69.217L15.8886 70.5087L15.2596 70.6891L14.2824 70.0631L15.0012 69.3468L14.0802 68.6699L13.6646 67.3896L11.6258 67.1132L9.21081 67.8972L6.63291 68.794L5.48718 69.2283L5.4254 70.4297C4.88062 70.6835 3.90899 71.3491 3.34174 71.3942C3.08339 71.4167 2.79695 71.3152 2.51052 71.1516C1.59506 70.6215 0.62905 69.3806 0.123579 68.8843C0.0730324 68.8279 0.0112527 68.7715 2.00744e-05 68.6925C-0.0112126 68.591 0.0561834 68.4838 0.10673 68.3823C0.27522 68.0552 0.286453 67.6998 0.381931 67.3558C0.584119 66.6451 1.07836 66.38 1.73547 66.1318C1.87026 66.0811 3.04407 65.6693 3.14517 65.7257L2.24655 64.812L8.23357 61.5914L11.6314 61.3715L16.4166 60.6608L18.2194 60.1081L22.1733 58.3088L22.617 58.4893L24.0885 57.9535L26.3856 57.852L27.2954 57.9535L28.9522 57.5587L30.1429 57.0736L31.1763 56.7859L31.4122 56.5716L32.1872 56.5603L34.7876 56.1712L35.3324 55.5225L36.1018 54.9303L37.4104 54.9923L37.1521 54.2648L38.2866 53.4413L37.7025 52.8829L38.5393 52.1327L39.6345 51.501H40.168L40.915 51.5856L41.0049 51.9466L40.7858 52.8265L41.7912 53.3172C41.7912 53.3172 42.1338 52.9111 42.2461 52.7306L42.8414 52.6291C43.4255 52.5501 44.0489 52.5501 44.0826 52.5501L44.7959 53.2608L43.8074 54.1463L43.5378 54.7442L43.8187 55.6071L41.6845 56.487L41.1284 55.7143L40.2523 56.6562L39.129 57.491L37.7699 58.4103L36.6298 59.9558L37.5452 60.9823L39.2975 60.5931L41.1284 61.0218L42.8414 60.9936L43.3806 62.601L44.8184 62.3021L44.0714 60.909L45.2901 60.4634L45.8349 59.1097L44.5432 58.4047L45.5541 57.7109L44.8465 56.6111L45.7338 55.6635L47.5872 55.3872L49.2272 55.4041L50.5246 56.5547L52.114 55.9343L52.1982 55.077L53.226 55.139L54.6582 56.6562L55.7646 56.7013L57.2249 57.1582L57.2361 57.1526Z",
    fill: "#7F8DC8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M116.062 2.02483L116.05 4.75471L115.927 4.42757L115.932 1.69769L116.062 2.02483Z",
    fill: "#050823"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.79 2.48167L122.784 5.21155L122.116 5.16079L122.122 2.43091L122.79 2.48167Z",
    fill: "#050823"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.152 2.53806L115.146 5.2623L114.894 5.05361L114.899 2.32373L115.152 2.53806Z",
    fill: "#050823"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M135.663 2.43658L135.657 5.16646L135.5 5.35823L135.505 2.63399L135.663 2.43658Z",
    fill: "#050823"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.852 2.94983L122.846 5.67407L122.784 5.21157L122.79 2.48169L122.852 2.94983Z",
    fill: "#050823"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M135.213 3.01748L135.208 5.74736L134.899 5.39766L134.905 2.66779L135.213 3.01748Z",
    fill: "#050823"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M135.797 2.98364L135.792 5.70788L135.511 5.83761L135.522 3.10773L135.797 2.98364Z",
    fill: "#050823"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M121.953 3.16978L121.948 5.89966L121.257 5.72481L121.262 2.99493L121.953 3.16978Z",
    fill: "#050823"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.335 3.00061L122.329 5.73049L121.948 5.8997L121.953 3.16982L122.335 3.00061Z",
    fill: "#050823"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M135.174 3.36155L135.168 6.09143L135.006 5.94478L135.011 3.2149L135.174 3.36155Z",
    fill: "#050823"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.739 3.38413L123.734 6.11401L122.846 5.67407L122.852 2.94983L123.739 3.38413Z",
    fill: "#1D244A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.262 2.99493L121.257 5.72481L120.285 6.14219L120.296 3.41795L121.262 2.99493Z",
    fill: "#050823"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M135.253 3.52514L135.247 6.25502L135.168 6.09145L135.174 3.36157L135.253 3.52514Z",
    fill: "#050823"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M136.196 3.39539L136.191 6.12526L136.163 6.35651L136.168 3.62664L136.196 3.39539Z",
    fill: "#050823"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M123.745 3.61534L123.739 6.33958L123.734 6.11397L123.739 3.38409L123.745 3.61534Z",
    fill: "#050823"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M124.402 3.88045L124.396 6.61033L123.739 6.33959L123.745 3.61536L124.402 3.88045Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 2,
    width: 4,
    height: 5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M127.839 2.88776V5.61763C127.154 6.06885 126.693 6.57084 125.845 6.6216C125.368 6.6498 124.879 6.61596 124.396 6.61032V3.88044C124.885 3.88044 125.373 3.91992 125.851 3.89172C126.699 3.84096 127.165 3.33898 127.839 2.88776Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.839 2.88776V5.61763C127.154 6.06885 126.693 6.57084 125.845 6.6216C125.368 6.6498 124.879 6.61596 124.396 6.61032V3.88044C124.885 3.88044 125.373 3.91992 125.851 3.89172C126.699 3.84096 127.165 3.33898 127.839 2.88776Z",
    fill: "#050823"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M136.168 3.62665L136.162 6.35653L135.904 6.7175L135.91 3.98762L136.168 3.62665Z",
    fill: "#050823"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.371 4.42195L132.366 7.15182L132.096 7.06722L132.102 4.33734L132.371 4.42195Z",
    fill: "#050823"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M133.085 4.42758L133.079 7.15181H132.366L132.371 4.42194L133.085 4.42758Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 4,
    width: 2,
    height: 4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.387 4.12866V6.85854C136.387 6.85854 136.37 7.04467 136.32 7.06159C136.269 7.07851 135.489 7.19695 135.449 7.2026V4.47272C135.494 4.46708 136.275 4.34299 136.325 4.33171C136.376 4.32043 136.382 4.13994 136.387 4.12866Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.387 4.12866V6.85854C136.387 6.85854 136.37 7.04467 136.32 7.06159C136.269 7.07851 135.489 7.19695 135.449 7.2026V4.47272C135.494 4.46708 136.275 4.34299 136.325 4.33171C136.376 4.32043 136.382 4.13994 136.387 4.12866Z",
    fill: "#050823"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.734 3.9538L121.723 6.68367L120.875 7.29846L120.88 4.56858L121.734 3.9538Z",
    fill: "#050823"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M133.804 4.67572L133.798 7.4056L133.079 7.15179L133.085 4.42755L133.804 4.67572Z",
    fill: "#050823"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M135.461 4.47272L135.449 7.2026L135.129 7.44513L135.135 4.71525L135.461 4.47272Z",
    fill: "#050823"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M120.881 4.5686L120.875 7.29848L119.937 7.53537L119.943 4.81113L120.881 4.5686Z",
    fill: "#050823"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M134.129 5.17771L134.124 7.90758L133.534 7.59737L133.545 4.86749L134.129 5.17771Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 5,
    width: 1,
    height: 3
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M134.781 5.25667V7.98655C134.663 8.02039 134.152 7.91323 134.124 7.91323V5.18335C134.157 5.18335 134.669 5.29051 134.781 5.25667Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.781 5.25667V7.98655C134.663 8.02039 134.152 7.91323 134.124 7.91323V5.18335C134.157 5.18335 134.669 5.29051 134.781 5.25667Z",
    fill: "#050823"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M136.241 5.46539L136.235 8.19526L135.539 7.68764L135.545 4.95776L136.241 5.46539Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 5,
    width: 2,
    height: 4
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.601 5.3187V8.04858C135.556 8.04858 134.887 7.95269 134.775 7.98653V5.25666C134.893 5.22281 135.567 5.31306 135.601 5.3187Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.601 5.3187V8.04858C135.556 8.04858 134.887 7.95269 134.775 7.98653V5.25666C134.893 5.22281 135.567 5.31306 135.601 5.3187Z",
    fill: "#050823"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M119.942 4.8111L119.937 7.53533L119.516 8.17832L119.521 5.44844L119.942 4.8111Z",
    fill: "#050823"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M136.949 5.5218L136.943 8.24603L136.236 8.19527L136.241 5.46539L136.949 5.5218Z",
    fill: "#050823"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M137.617 5.76432L137.611 8.4942L136.943 8.24603L136.949 5.52179L137.617 5.76432Z",
    fill: "#050823"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M119.521 5.44843L119.516 8.1783L118.381 8.56748L118.387 5.8376L119.521 5.44843Z",
    fill: "#050823"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M137.932 6.09142L137.92 8.81565L137.612 8.49416L137.617 5.76428L137.932 6.09142Z",
    fill: "#050823"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M140.757 6.15912L140.751 8.889L140.425 8.8608L140.437 6.13092L140.757 6.15912Z",
    fill: "#050823"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M141.172 6.37345L141.161 9.10333L140.751 8.889L140.757 6.15912L141.172 6.37345Z",
    fill: "#050823"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.234 6.17603L141.229 8.90026L141.161 9.10331L141.172 6.37343L141.234 6.17603Z",
    fill: "#050823"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M138.061 6.44677L138.055 9.17664L137.92 8.81567L137.932 6.09143L138.061 6.44677Z",
    fill: "#050823"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M127.3 6.3396L127.289 9.06948L126.34 9.31765L126.345 6.59341L127.3 6.3396Z",
    fill: "#050823"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.387 5.83765L118.381 8.56752L117.247 9.3628L117.258 6.63856L118.387 5.83765Z",
    fill: "#050823"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M140.875 6.50317L140.863 9.23305L140.566 9.45302L140.571 6.72314L140.875 6.50317Z",
    fill: "#050823"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M121.611 6.68369L121.599 9.41357L121.358 9.29512L121.369 6.56525L121.611 6.68369Z",
    fill: "#1D244A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M137.51 6.85287L137.505 9.58275L137.151 9.45302L137.157 6.72314L137.51 6.85287Z",
    fill: "#050823"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M121.936 6.84158L121.931 9.57146L121.599 9.41353L121.611 6.68365L121.936 6.84158Z",
    fill: "#1D244A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M138.055 6.90361L138.044 9.62784L137.505 9.58272L137.51 6.85284L138.055 6.90361Z",
    fill: "#050823"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M128.99 6.79083L128.985 9.52071L128.575 9.70684L128.58 6.9826L128.99 6.79083Z",
    fill: "#050823"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M140.571 6.72314L140.566 9.45302L139.965 9.7576L139.97 7.02772L140.571 6.72314Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 6,
    width: 4,
    height: 4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M126.424 7.02207V9.75194C126.362 9.7463 125.312 9.62222 125.261 9.65042C125.211 9.67862 123.969 9.56581 123.902 9.56581V6.83594C123.975 6.83594 125.216 6.95438 125.267 6.92054C125.317 6.89234 126.362 7.01643 126.418 7.02207H126.424Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.424 7.02207V9.75194C126.362 9.7463 125.312 9.62222 125.261 9.65042C125.211 9.67862 123.969 9.56581 123.902 9.56581V6.83594C123.975 6.83594 125.216 6.95438 125.267 6.92054C125.317 6.89234 126.362 7.01643 126.418 7.02207H126.424Z",
    fill: "#050823"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M138.1 7.13488L138.094 9.86475L138.044 9.62786L138.055 6.90363L138.1 7.13488Z",
    fill: "#050823"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M123.913 6.83594L123.902 9.56581L123.874 9.85347L123.885 7.12923L123.913 6.83594Z",
    fill: "#050823"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M127.395 7.25334L127.39 9.97758L126.413 9.75197L126.424 7.02209L127.395 7.25334Z",
    fill: "#050823"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M138.347 7.28717L138.342 10.0114L138.094 9.86477L138.1 7.13489L138.347 7.28717Z",
    fill: "#050823"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M128.631 7.26464L128.62 9.99452L127.39 9.9776L127.396 7.25336L128.631 7.26464Z",
    fill: "#050823"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M140.319 7.67633L140.313 10.4062L139.51 10.4739L139.515 7.74401L140.319 7.67633Z",
    fill: "#050823"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M139.515 7.74402L139.51 10.4739L139.257 10.5585L139.263 7.82862L139.515 7.74402Z",
    fill: "#050823"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M103.987 7.78351L103.975 10.5134L103.695 10.2934L103.706 7.56354L103.987 7.78351Z",
    fill: "#050823"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M104.138 8.00348L104.133 10.7334L103.975 10.5134L103.987 7.78351L104.138 8.00348Z",
    fill: "#050823"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M139.706 8.20654L139.695 10.9308L139.178 11.0436L139.19 8.31371L139.706 8.20654Z",
    fill: "#050823"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M139.734 8.5224L139.723 11.2523L139.51 11.32L139.521 8.59572L139.734 8.5224Z",
    fill: "#050823"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M139.521 8.5957L139.51 11.3199L138.971 11.3481L138.976 8.61826L139.521 8.5957Z",
    fill: "#050823"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M138.976 8.61829L138.971 11.3482L138.639 11.4666L138.651 8.74237L138.976 8.61829Z",
    fill: "#1D244A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M137.089 8.82134L137.084 11.5512L136.971 10.7559L136.982 8.02606L137.089 8.82134Z",
    fill: "#050823"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M137.303 9.0469L137.297 11.7768L137.083 11.5512L137.089 8.82129L137.303 9.0469Z",
    fill: "#050823"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M102.627 9.14842L102.616 11.8783L102.56 11.5794L102.566 8.84949L102.627 9.14842Z",
    fill: "#050823"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M139.987 9.48688L139.981 12.2111L139.74 12.2506L139.746 9.52072L139.987 9.48688Z",
    fill: "#050823"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M138.718 9.6166L138.707 12.3465L138.128 12.1491L138.134 9.41919L138.718 9.6166Z",
    fill: "#050823"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M137.808 9.64478L137.797 12.3747L137.162 12.2449L137.173 9.52069L137.808 9.64478Z",
    fill: "#050823"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M138.134 9.41919L138.128 12.1491L137.797 12.3747L137.808 9.6448L138.134 9.41919Z",
    fill: "#050823"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M135.663 2.43658L135.505 2.62835L135.797 2.97804L135.522 3.10213L135.556 3.51387L135.876 3.38414H136.196L136.168 3.62667L135.915 3.98201L136.393 4.12301C136.393 4.12301 136.387 4.30914 136.331 4.32606C136.275 4.34298 135.5 4.46143 135.46 4.46707L135.135 4.7096L135.427 4.83932L135.865 4.72088L136.241 4.84496L136.735 4.86188L137.943 4.8788L138.549 5.08185L138.903 5.2285L140.33 5.65716L140.745 5.67972L141.228 6.16478L141.161 6.36219L140.745 6.14786L140.425 6.11966L140.863 6.49192L140.56 6.71188L139.959 7.01646L140.285 7.45076L140.302 7.66509L139.499 7.73277L139.246 7.81737L139.65 7.95274L139.684 8.18963L139.167 8.30243L139.712 8.51112L139.499 8.58445L138.954 8.61265L138.628 8.73109L139.083 8.93414L139.807 9.07515L139.965 9.48124L139.723 9.51509L139.162 9.66737L138.695 9.61097L138.117 9.41356L137.786 9.63917L137.151 9.51509L137.28 9.04695L137.067 8.82134L136.954 8.02606L137.488 7.67637L137.752 7.5128L138.325 7.28155L138.078 7.12926L138.033 6.89801L137.493 6.85289L137.14 6.72317L137.325 6.51448L137.859 6.6442L138.05 6.44679L137.92 6.09146L137.611 5.76432L136.943 5.52179L136.235 5.47103L135.539 4.96341L135.595 5.31874C135.561 5.31874 134.888 5.22286 134.775 5.2567C134.663 5.29054 134.152 5.18338 134.124 5.18338L133.534 4.87317L133.792 4.6814L133.073 4.42759H132.36L132.091 4.34298L132.399 4.04969L133.337 4.06661L133.888 3.91432L134.287 3.86356L134.691 3.55899L134.809 3.44618L135.241 3.51951L135.163 3.35594L134.994 3.20929L135.196 3.01188L134.888 2.66219L134.966 2.58887L135.028 2.49862L135.32 2.3689L135.646 2.43658H135.663Z",
    fill: "#1D244A"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M139.184 9.67298L139.179 12.4029L138.707 12.3465L138.718 9.61658L139.184 9.67298Z",
    fill: "#050823"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M139.746 9.52069L139.74 12.2506L139.178 12.4029L139.184 9.67298L139.746 9.52069Z",
    fill: "#050823"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M128.019 8.78748L128.013 11.5174L127.766 12.4029L127.772 9.67299L128.019 8.78748Z",
    fill: "#050823"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M127.772 9.67297L127.766 12.4029L127.042 12.4593L127.047 9.73502L127.772 9.67297Z",
    fill: "#050823"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M127.047 9.73505L127.042 12.4593L127.025 12.8992L127.036 10.1693L127.047 9.73505Z",
    fill: "#050823"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3309 10.7841L98.3253 13.514L97.8984 13.3673L97.9041 10.6375L98.3309 10.7841Z",
    fill: "#050823"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M127.996 10.6375L127.991 13.3673L127.76 13.7339L127.772 11.0041L127.996 10.6375Z",
    fill: "#050823"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3309 10.7841L98.3253 13.514L97.9041 13.7114L97.9153 10.9872L98.3309 10.7841Z",
    fill: "#050823"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9153 10.9871L97.9041 13.7114L97.8984 13.3673L97.9041 10.6375L97.9153 10.9871Z",
    fill: "#050823"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3309 10.7841L97.9153 10.9871L97.9041 10.6375L98.3309 10.7841Z",
    fill: "#1D244A"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M131.911 11.2692L131.905 13.999L131.585 14.3149L131.591 11.585L131.911 11.2692Z",
    fill: "#050823"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M127.238 11.7712L127.233 14.4954L126.615 14.5405L126.626 11.8163L127.238 11.7712Z",
    fill: "#050823"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M129.872 11.9686L129.867 14.6984L129.019 14.4503L129.024 11.7204L129.872 11.9686Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 139,
    y: 12,
    width: 1,
    height: 3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M139.791 12.1378V14.8677C139.791 14.8677 139.779 14.8508 139.779 14.8451V12.1152C139.779 12.1152 139.791 12.1265 139.791 12.1378Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.791 12.1378V14.8677C139.791 14.8677 139.779 14.8508 139.779 14.8451V12.1152C139.779 12.1152 139.791 12.1265 139.791 12.1378Z",
    fill: "#050823"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M127.963 12.1322L127.957 14.8564L127.232 14.4954L127.238 11.7712L127.963 12.1322Z",
    fill: "#050823"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M129.024 11.7204L129.019 14.4503L128.625 14.8677L128.631 12.1434L129.024 11.7204Z",
    fill: "#050823"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M128.631 12.1434L128.625 14.8677L127.957 14.8564L127.963 12.1321L128.631 12.1434Z",
    fill: "#050823"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M126.626 11.8163L126.615 14.5405L125.946 15.1102L125.952 12.3859L126.626 11.8163Z",
    fill: "#050823"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M131.714 12.0419L131.703 14.7717L130.99 15.1496L130.995 12.4254L131.714 12.0419Z",
    fill: "#050823"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M130.996 12.4254L130.99 15.1497L129.867 14.6984L129.872 11.9686L130.996 12.4254Z",
    fill: "#050823"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M145.75 12.7188L145.744 15.443L145.71 15.584L145.716 12.8541L145.75 12.7188Z",
    fill: "#050823"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M127.817 12.6454L127.805 15.3696L127.502 15.6178L127.513 12.8879L127.817 12.6454Z",
    fill: "#050823"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M125.952 12.3859L125.946 15.1102L125.789 15.6347L125.795 12.9048L125.952 12.3859Z",
    fill: "#050823"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M141.532 12.6567L141.521 15.3866L141.29 15.7193L141.296 12.9895L141.532 12.6567Z",
    fill: "#050823"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M138.926 13.1136L138.92 15.8434L138.342 15.3415L138.347 12.6116L138.926 13.1136Z",
    fill: "#050823"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M140.066 13.3561L140.06 16.0859L138.92 15.8434L138.926 13.1135L140.066 13.3561Z",
    fill: "#050823"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M141.655 13.7791L141.65 16.5034L141.043 16.7346L141.054 14.0047L141.655 13.7791Z",
    fill: "#050823"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M141.054 14.0047L141.043 16.7346L139.779 16.4413L139.785 13.7114L141.054 14.0047Z",
    fill: "#050823"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M148.052 13.9991L148.047 16.729L147.266 16.791L147.277 14.0611L148.052 13.9991Z",
    fill: "#050823"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M142.234 14.1852L142.228 16.9151L141.65 16.5034L141.655 13.7791L142.234 14.1852Z",
    fill: "#050823"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M144.183 14.298L144.177 17.0279L143.486 17.135L143.497 14.4051L144.183 14.298Z",
    fill: "#050823"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M147.277 14.0611L147.266 16.791L147.024 17.3099L147.03 14.58L147.277 14.0611Z",
    fill: "#050823"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M142.812 14.7266L142.807 17.4565L142.228 16.9151L142.234 14.1852L142.812 14.7266Z",
    fill: "#050823"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M145.064 14.7492L145.053 17.4791L144.177 17.0279L144.183 14.298L145.064 14.7492Z",
    fill: "#050823"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M145.862 14.5856L145.851 17.3099L145.053 17.4791L145.064 14.7492L145.862 14.5856Z",
    fill: "#050823"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M147.03 14.58L147.025 17.3099L146.446 17.5129L146.457 14.7887L147.03 14.58Z",
    fill: "#1D244A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M146.457 14.7887L146.446 17.5129L145.851 17.3099L145.862 14.5856L146.457 14.7887Z",
    fill: "#050823"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M148.771 15.0256L148.766 17.7555L148.092 17.8626L148.103 15.1384L148.771 15.0256Z",
    fill: "#050823"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M150.984 14.8959L150.978 17.6258L150.596 18.0149L150.602 15.2851L150.984 14.8959Z",
    fill: "#050823"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M149.558 15.4486L149.546 18.1728L148.766 17.7555L148.771 15.0256L149.558 15.4486Z",
    fill: "#050823"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M150.602 15.285L150.596 18.0149L149.546 18.1728L149.557 15.4486L150.602 15.285Z",
    fill: "#050823"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M143.301 15.4599L143.29 18.1897L142.807 17.4565L142.812 14.7266L143.301 15.4599Z",
    fill: "#050823"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M148.103 15.1384L148.092 17.8626L147.962 18.3589L147.974 15.6291L148.103 15.1384Z",
    fill: "#050823"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M143.548 15.7645L143.537 18.4944L143.29 18.1898L143.301 15.4599L143.548 15.7645Z",
    fill: "#050823"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M147.974 15.6291L147.962 18.359L147.586 18.6015L147.592 15.8716L147.974 15.6291Z",
    fill: "#050823"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M147.592 15.8716L147.586 18.6015L147.024 18.3534L147.03 15.6235L147.592 15.8716Z",
    fill: "#050823"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M144.57 16.1198L144.565 18.844L144.25 19.4983L144.256 16.7684L144.57 16.1198Z",
    fill: "#050823"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M144.256 16.7684L144.25 19.4983L143.829 19.5378L143.84 16.8136L144.256 16.7684Z",
    fill: "#050823"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M143.84 16.8135L143.829 19.5378L143.357 19.1881L143.363 16.4582L143.84 16.8135Z",
    fill: "#050823"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M150.068 13.7001L150.787 14.3995L150.984 14.8959L150.602 15.2851L149.557 15.4486L148.777 15.0256L148.103 15.1384L147.974 15.6347L147.592 15.8773L147.03 15.6291L147.373 14.9861L148.007 14.5236L148.052 14.0047L147.277 14.0668L147.036 14.5857L146.457 14.7887L145.862 14.5857L145.064 14.7549L144.183 14.298L143.497 14.4052L143.554 15.0369L144.143 15.4148L144.576 16.1198L144.261 16.7741L143.846 16.8192L143.368 16.4695L143.548 15.7758L143.301 15.4712L142.812 14.7379L142.234 14.1965L141.655 13.7904L141.049 14.0216L139.779 13.7283L140.06 13.373L138.92 13.1305L138.342 12.6285C138.386 12.6059 139.251 12.1265 139.532 12.1942C139.819 12.2619 139.779 12.1378 139.774 12.1322L140.65 12.1152L141.52 12.6736L141.29 13.0064L142.144 13.4463L142.728 13.3335L143.57 12.8654L144.222 12.6398L145.036 13.1474L145.744 12.73L145.71 12.871L146.749 13.1192L147.249 13.3448L148.097 13.3843L148.889 13.6889L150.057 13.7171L150.068 13.7001Z",
    fill: "#1D244A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M152.725 16.8756L152.72 19.6054L152.551 19.0245L152.557 16.2946L152.725 16.8756Z",
    fill: "#050823"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M134.449 16.3454L134.444 19.0696L134.303 19.848L134.309 17.1181L134.449 16.3454Z",
    fill: "#050823"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M153.618 16.9376L153.607 19.6619L153.051 20.3105L153.056 17.5806L153.618 16.9376Z",
    fill: "#050823"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M148.035 17.2197L148.03 19.9495L147.654 20.4854L147.665 17.7611L148.035 17.2197Z",
    fill: "#050823"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7839 17.6201L85.7783 20.35L85.739 19.9608L85.7502 17.2366L85.7839 17.6201Z",
    fill: "#050823"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M134.309 17.1181L134.304 19.848L133.972 20.5192L133.983 17.7893L134.309 17.1181Z",
    fill: "#050823"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M145.076 18.2011L145.07 20.9309L144.486 20.0059L144.497 17.2761L145.076 18.2011Z",
    fill: "#050823"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M153.056 17.5806L153.051 20.3105L151.641 21.0212L151.647 18.2913L153.056 17.5806Z",
    fill: "#050823"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M133.983 17.7893L133.972 20.5192L133.017 21.0042L133.023 18.2744L133.983 17.7893Z",
    fill: "#050823"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M154.404 17.8908L154.399 20.615L153.742 21.2016L153.747 18.4718L154.404 17.8908Z",
    fill: "#050823"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M150.945 18.7087L150.933 21.4329L150.304 21.3144L150.316 18.5902L150.945 18.7087Z",
    fill: "#050823"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M145.137 18.703L145.132 21.4329L144.744 21.1904L144.75 18.4661L145.137 18.703Z",
    fill: "#050823"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6436 18.5394L85.638 21.2693L85.3179 21.196L85.3235 18.4661L85.6436 18.5394Z",
    fill: "#050823"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M133.579 18.562L133.573 21.2919L133.41 21.5965L133.422 18.8722L133.579 18.562Z",
    fill: "#050823"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M133.422 18.8723L133.41 21.5965L132.911 21.6585L132.916 18.9343L133.422 18.8723Z",
    fill: "#050823"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M132.916 18.9343L132.911 21.6585H132.158L132.164 18.9286L132.916 18.9343Z",
    fill: "#050823"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M150.316 18.5902L150.304 21.3144L150.063 21.7544L150.069 19.0245L150.316 18.5902Z",
    fill: "#050823"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M151.461 19.1881L151.456 21.918L150.933 21.4329L150.945 18.7087L151.461 19.1881Z",
    fill: "#050823"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M85.054 19.126L85.0484 21.8503L84.9473 21.478L84.9585 18.7538L85.054 19.126Z",
    fill: "#050823"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M132.164 18.9286L132.158 21.6585L131.653 22.0421L131.658 19.3122L132.164 18.9286Z",
    fill: "#050823"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3742 19.3855L84.3685 22.1154L83.6721 22.0646L83.6777 19.3404L84.3742 19.3855Z",
    fill: "#050823"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M155.045 19.6675L155.039 22.3974L154.331 22.4143L154.337 19.6844L155.045 19.6675Z",
    fill: "#050823"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M156.735 19.267L156.73 21.9913L156.555 22.4763L156.567 19.7464L156.735 19.267Z",
    fill: "#050823"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M156.567 19.7465L156.555 22.4763L155.831 22.6117L155.836 19.8875L156.567 19.7465Z",
    fill: "#050823"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M155.837 19.8874L155.831 22.6117L155.039 22.3974L155.045 19.6675L155.837 19.8874Z",
    fill: "#050823"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M152.304 20.0229L152.293 22.7527L151.456 21.918L151.461 19.1881L152.304 20.0229Z",
    fill: "#050823"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M153.904 20.2203L153.893 22.9502L153.601 23.0573L153.607 20.3274L153.904 20.2203Z",
    fill: "#1D244A"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M153.607 20.3274L153.601 23.0573L152.292 22.7527L152.304 20.0228L153.607 20.3274Z",
    fill: "#050823"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2967 19.9608L80.2911 22.6851L79.9485 23.0404L79.9597 20.3105L80.2967 19.9608Z",
    fill: "#050823"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8466 20.5305L82.841 23.2604L82.094 22.9953L82.0996 20.2654L82.8466 20.5305Z",
    fill: "#050823"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M154.803 20.8125L154.792 23.5424L153.893 22.9502L153.905 20.2203L154.803 20.8125Z",
    fill: "#050823"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M155.224 20.3838L155.213 23.1137L154.792 23.5423L154.803 20.8124L155.224 20.3838Z",
    fill: "#050823"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3016 20.9761L83.296 23.7059L82.8074 23.6213L82.8186 20.8971L83.3016 20.9761Z",
    fill: "#050823"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9599 20.3105L79.9486 23.0404L79.2522 23.7003L79.2634 20.9704L79.9599 20.3105Z",
    fill: "#050823"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8014 21.1057L83.7958 23.8356L83.2959 23.7059L83.3015 20.976L83.8014 21.1057Z",
    fill: "#050823"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2635 20.9704L79.2523 23.7003L78.9097 24.2587L78.9153 21.5288L79.2635 20.9704Z",
    fill: "#050823"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M151.383 21.7657L151.377 24.4899L150.591 24.332L150.602 21.6021L151.383 21.7657Z",
    fill: "#050823"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M151.973 21.1622L151.967 23.8864L151.377 24.4899L151.383 21.7657L151.973 21.1622Z",
    fill: "#050823"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M144.166 21.9687L144.16 24.6986L143.531 23.7849L143.537 21.055L144.166 21.9687Z",
    fill: "#050823"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M138.212 21.6359L138.201 24.3658L137.948 24.8227L137.954 22.0928L138.212 21.6359Z",
    fill: "#050823"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M145.918 22.2733L145.907 25.0032L144.16 24.6986L144.166 21.9688L145.918 22.2733Z",
    fill: "#050823"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9152 21.5288L78.9095 24.2587L78.2805 24.9299L78.2861 22.2L78.9152 21.5288Z",
    fill: "#050823"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M149.524 22.5158L149.518 25.2457L148.973 25.1611L148.979 22.4312L149.524 22.5158Z",
    fill: "#050823"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M150.602 21.6021L150.591 24.332L149.518 25.2457L149.524 22.5158L150.602 21.6021Z",
    fill: "#050823"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2066 22.403L81.201 25.1329L80.8584 25.2231L80.8696 22.4989L81.2066 22.403Z",
    fill: "#050823"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M146.828 22.7584L146.822 25.4826L145.907 25.0032L145.918 22.2733L146.828 22.7584Z",
    fill: "#050823"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8641 22.4989L80.8585 25.2231L80.2576 25.3867L80.2632 22.6568L80.8641 22.4989Z",
    fill: "#050823"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4256 22.6963L81.4144 25.4262L81.2009 25.1329L81.2065 22.403L81.4256 22.6963Z",
    fill: "#050823"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M148.243 22.9332L148.232 25.6631L146.822 25.4826L146.828 22.7584L148.243 22.9332Z",
    fill: "#050823"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M153.264 16.3228L153.618 16.9376L153.056 17.5806L151.647 18.2913L152.607 18.1728L153.461 17.6652L154.404 17.8908L153.747 18.4718L155.118 19.0245L156.044 18.8948L156.735 19.267L156.567 19.7464L155.836 19.8875L155.044 19.6675L154.337 19.6844L155.224 20.3838L154.803 20.8125L153.904 20.2202L153.607 20.3274L152.304 20.0228L151.461 19.1881L150.945 18.7086L150.316 18.5902L150.068 19.0245L150.843 19.3742L151.18 20.4571L151.972 21.1621L151.383 21.7657L150.602 21.6021L149.524 22.5158L148.979 22.4312L148.243 22.9332L146.828 22.7583L145.918 22.2733L144.166 21.9687L143.537 21.055L144.84 20.9704L145.053 20.1413L145.137 18.703L144.75 18.4661L145.075 18.201L144.497 17.276L145.317 17.0222L145.935 17.2196L147.58 17.056L148.035 17.2196L147.665 17.7611L148.254 18.3871L149.209 18.2179L150.068 18.2405L150.815 17.8006L151.461 17.6652L152.725 16.8756L152.556 16.2946L153.264 16.3228Z",
    fill: "#1D244A"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M148.979 22.4312L148.973 25.1611L148.232 25.6631L148.243 22.9332L148.979 22.4312Z",
    fill: "#050823"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M135.708 22.9389L135.696 25.6687L134.354 25.5277L134.36 22.7979L135.708 22.9389Z",
    fill: "#050823"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M136.685 22.8373L136.679 25.5672L135.696 25.6687L135.708 22.9389L136.685 22.8373Z",
    fill: "#050823"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M137.746 22.9727L137.741 25.7026L136.679 25.5672L136.685 22.8373L137.746 22.9727Z",
    fill: "#050823"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M138.314 22.5215L138.308 25.2457L137.741 25.7026L137.746 22.9727L138.314 22.5215Z",
    fill: "#050823"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1966 22.8994L77.1854 25.6236L76.8821 25.1837L76.8877 22.4538L77.1966 22.8994Z",
    fill: "#050823"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M134.36 22.7979L134.354 25.5277L134 25.7928L134.006 23.0686L134.36 22.7979Z",
    fill: "#050823"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M134.006 23.0685L134 25.7928L133.231 25.742L133.242 23.0121L134.006 23.0685Z",
    fill: "#050823"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2631 22.6569L80.2575 25.3867L79.5723 25.8944L79.5835 23.1645L80.2631 22.6569Z",
    fill: "#050823"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M126.132 23.2998L126.126 26.0297H124.2L124.205 23.2998H126.132Z",
    fill: "#050823"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M127.508 23.3449L127.502 26.0748L126.126 26.0297L126.132 23.2998L127.508 23.3449Z",
    fill: "#050823"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M132.085 23.486L132.079 26.2158L129.676 25.6518L129.681 22.9219L132.085 23.486Z",
    fill: "#050823"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5835 23.1644L79.5722 25.8943L78.4995 26.1086L78.5107 23.3788L79.5835 23.1644Z",
    fill: "#050823"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5897 23.6608L77.5785 26.3907L77.1853 25.6236L77.1965 22.8994L77.5897 23.6608Z",
    fill: "#050823"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0223 23.6777L78.0167 26.4076L77.5786 26.3906L77.5898 23.6608L78.0223 23.6777Z",
    fill: "#050823"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5108 23.3788L78.4996 26.1087L78.0166 26.4076L78.0222 23.6777L78.5108 23.3788Z",
    fill: "#050823"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2968 19.9608L79.9598 20.3105L79.2634 20.9704L78.9152 21.5288L78.2862 22.2L78.8478 22.6907L79.7633 22.5779L80.8641 22.4989L80.2631 22.6569L79.5835 23.1645L78.5108 23.3788L78.0222 23.6777L77.5897 23.6608L77.1966 22.8994L76.8877 22.4538L77.2022 21.9518L77.6571 21.3765L78.6119 20.7505L79.0051 20.3049L79.6004 19.9326L80.2968 19.9608Z",
    fill: "#1D244A"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M129.681 22.9219L129.676 25.6518L129.625 26.5655L129.631 23.8357L129.681 22.9219Z",
    fill: "#050823"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M129.631 23.8356L129.625 26.5655L128.934 26.6727L128.94 23.9484L129.631 23.8356Z",
    fill: "#050823"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M128.94 23.9485L128.934 26.6727L127.502 26.0748L127.508 23.345L128.94 23.9485Z",
    fill: "#050823"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M133.798 24.0331L133.787 26.7629L132.079 26.2158L132.085 23.486L133.798 24.0331Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 24,
    width: 1,
    height: 3
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M134.455 24.0782V26.8081L134.444 26.8193V24.0895C134.444 24.0895 134.455 24.0838 134.455 24.0782Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.455 24.0782V26.8081L134.444 26.8193V24.0895C134.444 24.0895 134.455 24.0838 134.455 24.0782Z",
    fill: "#050823"
  }))), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M124.205 23.2998L124.2 26.0297L122.897 26.9885L122.902 24.2586L124.205 23.2998Z",
    fill: "#050823"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M134.876 24.9976L134.865 27.7218L133.787 26.763L133.798 24.0331L134.876 24.9976Z",
    fill: "#050823"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0615 24.9242L78.0503 27.6541L78.0166 26.4076L78.0222 23.6777L78.0615 24.9242Z",
    fill: "#050823"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1458 24.9073L78.1402 27.6372L78.0503 27.6541L78.0615 24.9242L78.1458 24.9073Z",
    fill: "#050823"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M136.033 24.8396L136.022 27.5695L135.651 27.8853L135.657 25.1555L136.033 24.8396Z",
    fill: "#050823"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M135.657 25.1555L135.652 27.8854L134.865 27.7218L134.876 24.9976L135.657 25.1555Z",
    fill: "#050823"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M141.734 25.0258L141.723 27.7556L141.245 27.9192L141.257 25.195L141.734 25.0258Z",
    fill: "#050823"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M141.257 25.1949L141.245 27.9192L140.364 28.032L140.375 25.3021L141.257 25.1949Z",
    fill: "#050823"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M140.375 25.3021L140.364 28.032H138.988L138.993 25.3021H140.375Z",
    fill: "#050823"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M138.993 25.3021L138.987 28.032L136.022 27.5695L136.033 24.8396L138.993 25.3021Z",
    fill: "#050823"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5108 23.3788L78.5558 25.1498L78.2356 25.2175L78.1458 24.9073L78.0615 24.9242L78.0222 23.6777L78.5108 23.3788Z",
    fill: "#1D244A"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5557 25.1498L78.5501 27.8797L78.23 27.9474L78.2356 25.2175L78.5557 25.1498Z",
    fill: "#050823"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2356 25.2175L78.23 27.9474L78.1401 27.6372L78.1457 24.9073L78.2356 25.2175Z",
    fill: "#050823"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1854 25.6067L77.1742 28.3366L76.7529 28.0997L76.7585 25.3698L77.1854 25.6067Z",
    fill: "#050823"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7132 25.6744L77.7076 28.4042L77.1741 28.3366L77.1853 25.6067L77.7132 25.6744Z",
    fill: "#050823"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7134 25.6744L77.7078 28.4043L77.6404 28.7765L77.646 26.0466L77.7134 25.6744Z",
    fill: "#050823"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2022 26.2271L77.1909 28.957L77.1741 28.3366L77.1853 25.6067L77.2022 26.2271Z",
    fill: "#050823"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M159.133 25.8041L159.128 28.534L158.173 29.2164L158.184 26.4865L159.133 25.8041Z",
    fill: "#050823"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6458 26.0466L77.6402 28.7765L77.3201 29.0585L77.3313 26.3286L77.6458 26.0466Z",
    fill: "#050823"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7132 25.6744L77.6458 26.0466L77.3313 26.3286L77.2022 26.2271L77.1853 25.6067L77.7132 25.6744Z",
    fill: "#1D244A"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3313 26.3286L77.3201 29.0585L77.1909 28.957L77.2022 26.2271L77.3313 26.3286Z",
    fill: "#050823"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M157.291 26.9773L157.285 29.7015L157.01 29.2898L157.016 26.5599L157.291 26.9773Z",
    fill: "#050823"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M157.016 26.5599L157.01 29.2898L156.466 30.0173L156.471 27.2875L157.016 26.5599Z",
    fill: "#050823"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M123.79 26.808L123.784 29.5379L123.133 30.1527L123.138 27.4228L123.79 26.808Z",
    fill: "#050823"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M157.825 27.671L157.813 30.4009L157.246 30.2599L157.252 27.5356L157.825 27.671Z",
    fill: "#050823"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M158.319 27.1972L158.313 29.9214L157.813 30.4009L157.825 27.671L158.319 27.1972Z",
    fill: "#050823"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M156.471 27.2875L156.466 30.0174L155.309 30.8352L155.314 28.111L156.471 27.2875Z",
    fill: "#050823"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M117.836 28.5396L117.831 31.2695L116.786 31.0552L116.792 28.3309L117.836 28.5396Z",
    fill: "#050823"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M156.477 28.2802L156.465 31.0044L155.859 31.4387L155.864 28.7145L156.477 28.2802Z",
    fill: "#050823"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M155.865 28.7145L155.859 31.4387L154.489 31.45L154.5 28.7201L155.865 28.7145Z",
    fill: "#050823"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M152.882 28.7257L152.877 31.4556L152.781 31.2018L152.792 28.4719L152.882 28.7257Z",
    fill: "#050823"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M113.995 28.7032L113.984 31.4331L112.057 31.4162L112.063 28.6863L113.995 28.7032Z",
    fill: "#050823"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M116.792 28.3309L116.786 31.0552L116.399 31.7038L116.41 28.9796L116.792 28.3309Z",
    fill: "#050823"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M116.41 28.9796L116.399 31.7038L114.916 31.7489L114.922 29.019L116.41 28.9796Z",
    fill: "#050823"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M114.922 29.019L114.916 31.7489L113.984 31.4331L113.995 28.7032L114.922 29.019Z",
    fill: "#050823"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M154.5 28.7201L154.489 31.45L153.225 31.8956L153.23 29.1657L154.5 28.7201Z",
    fill: "#1D244A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 28,
    width: 3,
    height: 4
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M119.139 29.2108V31.9407C119.027 31.873 118.943 31.8222 118.836 31.7715C118.449 31.5741 117.865 31.2864 117.831 31.2695V28.5396C117.87 28.5565 118.454 28.8442 118.842 29.0416C118.948 29.098 119.038 29.1431 119.139 29.2108Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.139 29.2108V31.9407C119.027 31.873 118.943 31.8222 118.836 31.7715C118.449 31.5741 117.865 31.2864 117.831 31.2695V28.5396C117.87 28.5565 118.454 28.8442 118.842 29.0416C118.948 29.098 119.038 29.1431 119.139 29.2108Z",
    fill: "#050823"
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M112.063 28.6863L112.057 31.4162L110.951 31.9576L110.962 29.2277L112.063 28.6863Z",
    fill: "#050823"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M150.58 29.2672L150.574 31.9971L150.523 32.1945L150.529 29.4646L150.58 29.2672Z",
    fill: "#050823"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M153.231 29.1656L153.225 31.8955L152.562 32.3862L152.568 29.662L153.231 29.1656Z",
    fill: "#050823"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M152.568 29.662L152.562 32.3862L151.753 32.719L151.759 29.9891L152.568 29.662Z",
    fill: "#050823"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M127.598 30.0061L127.586 32.7303L126.306 32.296L126.317 29.5662L127.598 30.0061Z",
    fill: "#050823"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M128.67 30.0456L128.665 32.7698L127.586 32.7303L127.598 30.0061L128.67 30.0456Z",
    fill: "#050823"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M129.328 29.4815L129.322 32.2114L128.665 32.7698L128.67 30.0455L129.328 29.4815Z",
    fill: "#050823"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M144.84 29.7861L144.834 32.5104L144.486 33.0067L144.491 30.2768L144.84 29.7861Z",
    fill: "#050823"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M144.492 30.2768L144.486 33.0067L144.003 33.0292L144.009 30.2994L144.492 30.2768Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 29,
    width: 7,
    height: 5
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M125.767 30.4742V33.2041C125.43 33.1421 119.156 31.952 119.134 31.9407V29.2108C119.162 29.2221 125.435 30.4122 125.767 30.4742Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.767 30.4742V33.2041C125.43 33.1421 119.156 31.952 119.134 31.9407V29.2108C119.162 29.2221 125.435 30.4122 125.767 30.4742Z",
    fill: "#050823"
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M126.429 30.085L126.424 32.8149L125.755 33.2041L125.767 30.4742L126.429 30.085Z",
    fill: "#050823"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M110.962 29.2277L110.951 31.9576L108.597 33.3846L108.609 30.6603L110.962 29.2277Z",
    fill: "#050823"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M151.759 29.9891L151.754 32.719L150.114 33.5256L150.119 30.8013L151.759 29.9891Z",
    fill: "#050823"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M150.119 30.8013L150.114 33.5256L148.895 33.7061L148.906 30.9762L150.119 30.8013Z",
    fill: "#050823"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M144.009 30.2994L144.003 33.0293L143.902 33.7061L143.907 30.9762L144.009 30.2994Z",
    fill: "#050823"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M110.973 30.9029L110.962 33.6328L109.816 33.4974L109.822 30.7675L110.973 30.9029Z",
    fill: "#050823"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M111.007 30.9706L111.001 33.6948L110.962 33.6328L110.973 30.9029L111.007 30.9706Z",
    fill: "#050823"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M108.609 30.6603L108.597 33.3846L107.25 33.7004L107.255 30.9762L108.609 30.6603Z",
    fill: "#050823"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M109.822 30.7675L109.816 33.4974L108.614 33.8415L108.62 31.1172L109.822 30.7675Z",
    fill: "#050823"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M108.62 31.1172L108.614 33.8414L108.597 33.3846L108.609 30.6603L108.62 31.1172Z",
    fill: "#050823"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M110.962 29.2277L111.007 30.9706L110.973 30.9029L109.822 30.7675L108.62 31.1172L108.609 30.6603L110.962 29.2277Z",
    fill: "#1D244A"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M135.107 31.3372L135.101 34.067L134.365 34.0106L134.371 31.2808L135.107 31.3372Z",
    fill: "#050823"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M134.371 31.2808L134.365 34.0106L133.787 34.2419L133.792 31.512L134.371 31.2808Z",
    fill: "#050823"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M133.792 31.512L133.787 34.2419L131.81 34.0388L131.815 31.309L133.792 31.512Z",
    fill: "#050823"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M135.371 31.5684L135.359 34.2983L135.101 34.067L135.107 31.3372L135.371 31.5684Z",
    fill: "#050823"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M136.819 31.574L136.808 34.3039L136.016 34.1065L136.022 31.3823L136.819 31.574Z",
    fill: "#050823"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M67.66 31.3879L67.6543 34.1178L67.4353 33.7512L67.4465 31.0213L67.66 31.3879Z",
    fill: "#050823"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M135.837 31.591L135.831 34.3209L135.359 34.2983L135.371 31.5684L135.837 31.591Z",
    fill: "#050823"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M136.022 31.3823L136.016 34.1065L135.831 34.3208L135.837 31.591L136.022 31.3823Z",
    fill: "#050823"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M148.906 30.9762L148.895 33.7061L147.878 34.3603L147.884 31.6305L148.906 30.9762Z",
    fill: "#050823"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0814 31.4951L68.0701 34.225L67.6545 34.1178L67.6602 31.3879L68.0814 31.4951Z",
    fill: "#050823"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M147.884 31.6305L147.878 34.3604L146.688 34.5578L146.699 31.8279L147.884 31.6305Z",
    fill: "#050823"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M146.699 31.8279L146.688 34.5578L146.334 34.6311L146.339 31.9012L146.699 31.8279Z",
    fill: "#050823"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M137.218 31.9971L137.207 34.7269L136.808 34.3039L136.82 31.574L137.218 31.9971Z",
    fill: "#050823"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M140.959 32.0309L140.953 34.7608L140.296 34.7439L140.302 32.014L140.959 32.0309Z",
    fill: "#050823"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M144.89 32.0422L144.879 34.772L143.829 34.7326L143.834 32.0027L144.89 32.0422Z",
    fill: "#050823"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M145.334 31.8956L145.323 34.6198L144.879 34.7721L144.89 32.0422L145.334 31.8956Z",
    fill: "#050823"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M146.339 31.9012L146.334 34.6311L145.413 34.8059L145.424 32.0817L146.339 31.9012Z",
    fill: "#050823"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M145.424 32.0817L145.413 34.8059L145.323 34.6198L145.334 31.8956L145.424 32.0817Z",
    fill: "#050823"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M143.834 32.0027L143.829 34.7326L141.975 34.8341L141.987 32.1042L143.834 32.0027Z",
    fill: "#050823"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M141.987 32.1043L141.975 34.8341L140.953 34.7608L140.959 32.0309L141.987 32.1043Z",
    fill: "#050823"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M138.796 32.4257L138.791 35.1556L137.207 34.7269L137.218 31.9971L138.796 32.4257Z",
    fill: "#050823"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M159.133 25.8041L158.179 26.4866L158.319 27.1916L157.819 27.6654L157.246 27.53L157.285 26.9716L157.01 26.5542L156.466 27.2818L155.309 28.1053L156.173 28.1222L156.471 28.2745L155.859 28.7088H154.494L153.231 29.16L152.568 29.6564L151.753 29.9835L150.119 30.7957L148.9 30.9706L147.884 31.6248L146.693 31.8222L146.334 31.8956L145.418 32.076L145.328 31.8899L144.885 32.0422L143.829 31.9971L141.975 32.0986L140.953 32.0253L140.296 32.0084L140.891 32.3975C140.891 32.3975 140.347 32.4427 140.234 32.4314C140.122 32.4257 138.858 32.4145 138.791 32.4145L137.213 31.9858L136.814 31.5628L136.016 31.3654L135.831 31.5741L135.359 31.5515L135.101 31.3203L134.365 31.2638L133.787 31.4951L131.81 31.292L131.838 30.9593L132.63 30.886L133.22 30.5419L134.562 30.587L135.556 30.4235L137.185 30.5081L137.505 30.3388L138.785 30.2486L139.757 30.1189L140.178 30.2881L141.195 30.3276L141.852 30.3388L142.026 30.0512L142.706 30.0343L143.745 30.1358L143.992 29.9046L144.671 29.7015L144.834 29.7805L144.486 30.2712L144.003 30.2937L143.902 30.9649L144.89 31.5459L145.171 31.2018L147.283 30.9085L147.861 30.446L148.075 29.9948L148.676 30.0399L149.619 29.6677L150.574 29.2616L150.523 29.4646L151.029 29.38L152.141 29.0698L152.871 28.7257L152.781 28.4719L153.73 28.1222L154.567 27.7331L155.69 27.0901L156.398 26.3794L157.156 26.2045L157.606 25.7872L158.364 25.4149L159.122 25.8097L159.133 25.8041Z",
    fill: "#1D244A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 32,
    width: 3,
    height: 4
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M140.897 32.4088V35.1387C140.863 35.1387 140.341 35.1838 140.234 35.1725C140.122 35.1669 138.858 35.1556 138.791 35.1556V32.4257C138.864 32.4257 140.128 32.437 140.246 32.4427C140.358 32.4483 140.875 32.4088 140.903 32.4088H140.897Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.897 32.4088V35.1387C140.863 35.1387 140.341 35.1838 140.234 35.1725C140.122 35.1669 138.858 35.1556 138.791 35.1556V32.4257C138.864 32.4257 140.128 32.437 140.246 32.4427C140.358 32.4483 140.875 32.4088 140.903 32.4088H140.897Z",
    fill: "#050823"
  }))), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1936 32.6739L68.1824 35.4038L68.0701 34.225L68.0813 31.4951L68.1936 32.6739Z",
    fill: "#050823"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M112.029 32.7585L112.018 35.4827L111.355 36.4472L111.361 33.7173L112.029 32.7585Z",
    fill: "#050823"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1076 33.7963L93.102 36.5206L92.2314 36.3796L92.2371 33.6553L93.1076 33.7963Z",
    fill: "#050823"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0292 34.146L73.018 36.8759L72.1531 36.6277L72.1643 33.8978L73.0292 34.146Z",
    fill: "#050823"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1812 34.4901L72.1699 37.2199L72.1531 36.6277L72.1643 33.8978L72.1812 34.4901Z",
    fill: "#050823"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1643 33.8978L72.1531 36.6277L70.895 36.5375L70.9006 33.8132L72.1643 33.8978Z",
    fill: "#050823"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2371 33.6553L92.2315 36.3796L92.136 36.8252L92.1416 34.0953L92.2371 33.6553Z",
    fill: "#050823"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8041 34.1799L93.7985 36.9097L93.1021 36.5206L93.1077 33.7963L93.8041 34.1799Z",
    fill: "#050823"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6938 34.428L67.6826 37.1523V36.5995L67.6882 33.8753L67.6938 34.428Z",
    fill: "#050823"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1417 34.0953L92.1361 36.8252L91.6138 37.2425L91.6194 34.5127L92.1417 34.0953Z",
    fill: "#050823"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2822 34.4957L72.271 37.2199H72.1699L72.1812 34.4901L72.2822 34.4957Z",
    fill: "#050823"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0293 34.146L73.0181 36.8759L72.8215 37.3045L72.8328 34.5747L73.0293 34.146Z",
    fill: "#050823"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6194 34.5126L91.6137 37.2425L90.4736 37.4174L90.4793 34.6875L91.6194 34.5126Z",
    fill: "#050823"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0187 34.3547L71.0131 37.0846L70.3447 37.5583L70.3503 34.8285L71.0187 34.3547Z",
    fill: "#050823"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0462 34.8679L73.0406 37.5922L72.8215 37.3045L72.8328 34.5746L73.0462 34.8679Z",
    fill: "#050823"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6529 34.9413L72.6417 37.6712L72.271 37.22L72.2822 34.4957L72.6529 34.9413Z",
    fill: "#050823"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8326 34.5747L73.0405 34.7269L73.0461 34.8679L72.6529 34.9413L72.2822 34.4957L72.1812 34.4901L72.1643 33.8978L73.0292 34.146L72.8326 34.5747Z",
    fill: "#1D244A"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0462 34.868L73.0406 37.5922L72.6418 37.6712L72.6531 34.9413L73.0462 34.868Z",
    fill: "#050823"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9238 34.9864L68.9126 37.7163L67.6826 37.1523L67.6938 34.428L68.9238 34.9864Z",
    fill: "#050823"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9187 34.9857L68.9111 37.7156L69.6076 37.7175L69.6151 34.9877L68.9187 34.9857Z",
    fill: "#050823"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3502 34.8285L70.3446 37.5584L69.6089 37.7163L69.6201 34.9921L70.3502 34.8285Z",
    fill: "#050823"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7052 35.133L86.6939 37.8573L86.3569 37.6204L86.3626 34.8905L86.7052 35.133Z",
    fill: "#050823"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8095 35.1782L94.8039 37.9024L93.7986 36.9098L93.8042 34.1799L94.8095 35.1782Z",
    fill: "#050823"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3625 34.8905L86.3569 37.6204L85.4695 37.9475L85.4807 35.2176L86.3625 34.8905Z",
    fill: "#050823"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6478 35.0316L90.6422 37.7614L90.2546 37.9758L90.2603 35.2459L90.6478 35.0316Z",
    fill: "#050823"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2601 35.2458L90.2545 37.9757L89.8501 37.9814L89.8613 35.2515L90.2601 35.2458Z",
    fill: "#050823"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8848 35.3812L86.8736 38.1055L86.6938 37.8573L86.7051 35.1331L86.8848 35.3812Z",
    fill: "#050823"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7094 35.3643L71.7038 38.0942L70.9231 37.6881L70.9343 34.9582L71.7094 35.3643Z",
    fill: "#050823"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2486 35.4828L72.243 38.207L71.7039 38.0942L71.7095 35.3643L72.2486 35.4828Z",
    fill: "#050823"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3283 35.5166L88.3226 38.2465L87.6543 38.3649L87.6599 35.635L88.3283 35.5166Z",
    fill: "#050823"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6598 35.635L87.6542 38.3649L86.8735 38.1055L86.8848 35.3812L87.6598 35.635Z",
    fill: "#050823"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7943 35.6745L88.7887 38.3988L88.3225 38.2465L88.3281 35.5166L88.7943 35.6745Z",
    fill: "#050823"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6978 35.6294L72.6922 38.3593L72.2429 38.207L72.2485 35.4827L72.6978 35.6294Z",
    fill: "#050823"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7615 35.4884L85.7559 38.2183L85.6997 38.4383L85.7053 35.7084L85.7615 35.4884Z",
    fill: "#050823"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8614 35.2515L89.8501 37.9814L89.7041 38.4552L89.7153 35.7253L89.8614 35.2515Z",
    fill: "#050823"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7155 35.7253L89.7043 38.4551L88.7888 38.3987L88.7944 35.6745L89.7155 35.7253Z",
    fill: "#050823"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7052 35.7084L85.6996 38.4383L84.9246 38.5285L84.9358 35.7986L85.7052 35.7084Z",
    fill: "#050823"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6978 35.6294L72.6922 38.3593L72.2542 38.5623L72.2598 35.8324L72.6978 35.6294Z",
    fill: "#050823"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6978 35.6294L72.2598 35.8324L72.2485 35.4827L72.6978 35.6294Z",
    fill: "#1D244A"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2598 35.8324L72.2541 38.5623L72.2429 38.207L72.2485 35.4827L72.2598 35.8324Z",
    fill: "#050823"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2092 35.4714L72.2485 35.4827L72.2598 35.8324L72.2205 35.855L72.2092 35.4714Z",
    fill: "#1D244A"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2598 35.8325L72.2542 38.5623L72.2092 38.5849L72.2205 35.855L72.2598 35.8325Z",
    fill: "#050823"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2205 35.855L72.2092 38.5849L72.198 38.2013L72.2092 35.4714L72.2205 35.855Z",
    fill: "#050823"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2442 36.1483L87.2386 38.8782L86.7163 38.912L86.7275 36.1822L87.2442 36.1483Z",
    fill: "#050823"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1667 36.2272L83.1611 38.9571L82.1895 39.0022L82.1951 36.2724L83.1667 36.2272Z",
    fill: "#050823"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M111.529 34.4337L111.524 37.1579L110.03 39.0869L110.041 36.357L111.529 34.4337Z",
    fill: "#050823"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4981 36.4472L83.4869 39.1771L83.1611 38.9571L83.1667 36.2272L83.4981 36.4472Z",
    fill: "#050823"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3419 36.6221L80.3306 39.3519L79.9824 39.2279L79.988 36.498L80.3419 36.6221Z",
    fill: "#050823"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8438 36.6559L92.8382 39.3858L92.6697 38.9797L92.6753 36.2498L92.8438 36.6559Z",
    fill: "#050823"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M82.195 36.2724L82.1894 39.0023L81.1729 39.3858L81.1785 36.6616L82.195 36.2724Z",
    fill: "#050823"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1786 36.6616L81.173 39.3858L80.3306 39.3519L80.3418 36.6221L81.1786 36.6616Z",
    fill: "#050823"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M87.525 36.5939L87.5194 39.3238L86.969 39.4196L86.9746 36.6954L87.525 36.5939Z",
    fill: "#050823"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5426 36.7123L85.5369 39.4422L85.1719 39.3576L85.1775 36.6334L85.5426 36.7123Z",
    fill: "#050823"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1774 36.6334L85.1718 39.3576L84.3687 39.5042L84.3799 36.7744L85.1774 36.6334Z",
    fill: "#050823"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3798 36.7743L84.3686 39.5042L83.4868 39.1771L83.4981 36.4472L84.3798 36.7743Z",
    fill: "#050823"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4769 36.7743L79.4657 39.5042L78.7468 39.4253L78.7524 36.6954L79.4769 36.7743Z",
    fill: "#050823"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9879 36.498L79.9823 39.2279L79.4656 39.5042L79.4768 36.7744L79.9879 36.498Z",
    fill: "#050823"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9746 36.6954L86.969 39.4196L86.9409 39.6057L86.9465 36.8759L86.9746 36.6954Z",
    fill: "#050823"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7523 36.6954L78.7466 39.4253L78.4602 39.617L78.4658 36.8871L78.7523 36.6954Z",
    fill: "#050823"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9466 36.8759L86.941 39.6058L86.604 39.6509L86.6096 36.921L86.9466 36.8759Z",
    fill: "#050823"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6095 36.921L86.6038 39.6509L86.1658 39.4704L86.1714 36.7462L86.6095 36.921Z",
    fill: "#050823"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7615 37.1071L85.7559 39.837L85.4021 39.6847L85.4077 36.9548L85.7615 37.1071Z",
    fill: "#050823"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1715 36.7462L86.1658 39.4704L85.7559 39.837L85.7615 37.1071L86.1715 36.7462Z",
    fill: "#050823"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6779 37.0169L83.6667 39.7468L82.8186 39.837L82.8242 37.1072L83.6779 37.0169Z",
    fill: "#050823"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8242 37.1071L82.8186 39.837L82.7681 40.0513L82.7737 37.3214L82.8242 37.1071Z",
    fill: "#050823"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M110.041 36.357L110.03 39.0869L109.182 40.2093L109.193 37.485L110.041 36.357Z",
    fill: "#050823"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4422 37.5189L82.4309 40.2487L81.0269 40.4292L81.0325 37.6993L82.4422 37.5189Z",
    fill: "#050823"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2397 37.7332L83.2284 40.4631L82.4309 40.2487L82.4421 37.5189L83.2397 37.7332Z",
    fill: "#050823"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6983 37.8516L71.6926 40.5759L71.6196 39.837L71.6252 37.1071L71.6983 37.8516Z",
    fill: "#050823"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3633 37.9588L83.3577 40.6887L83.2285 40.4631L83.2398 37.7332L83.3633 37.9588Z",
    fill: "#050823"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7732 37.7896L83.7676 40.5139L83.6384 40.7225L83.644 37.9927L83.7732 37.7896Z",
    fill: "#050823"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6287 38.0152L78.6175 40.7451L78.3479 40.6154L78.3535 37.8855L78.6287 38.0152Z",
    fill: "#1D244A"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3536 37.8855L78.348 40.6154L78.0278 40.7451L78.0335 38.0152L78.3536 37.8855Z",
    fill: "#050823"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0325 37.6993L81.0269 40.4292L79.7576 40.7902L79.7632 38.0603L81.0325 37.6993Z",
    fill: "#050823"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7633 38.0604L79.7577 40.7902H79.2297L79.241 38.0604H79.7633Z",
    fill: "#050823"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7017 38.2013L78.6961 40.9256L78.6174 40.7451L78.6287 38.0152L78.7017 38.2013Z",
    fill: "#050823"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0333 38.0152L78.0277 40.7451L77.4548 40.9538L77.4604 38.2239L78.0333 38.0152Z",
    fill: "#1D244A"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M79.241 38.0604L79.2298 40.7902L79.0557 40.9707L79.0669 38.2409L79.241 38.0604Z",
    fill: "#050823"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0667 38.2408L79.0555 40.9707L78.696 40.9256L78.7017 38.2014L79.0667 38.2408Z",
    fill: "#050823"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4012 38.6808L88.3955 41.4106L88.199 41.1286L88.2046 38.3987L88.4012 38.6808Z",
    fill: "#050823"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1666 38.5679L84.1553 41.2978L83.8127 41.5009L83.824 38.771L84.1666 38.5679Z",
    fill: "#050823"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8239 38.771L83.8126 41.5009L83.1387 41.546L83.1443 38.8161L83.8239 38.771Z",
    fill: "#050823"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6964 38.7033L77.6908 41.4332L77.3032 41.5404L77.3088 38.8105L77.6964 38.7033Z",
    fill: "#050823"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9852 38.9233L88.9796 41.6532L88.3955 41.4107L88.4011 38.6808L88.9852 38.9233Z",
    fill: "#050823"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1442 38.8162L83.1386 41.546L82.4365 41.7209L82.4478 38.9966L83.1442 38.8162Z",
    fill: "#050823"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4478 38.9966L82.4366 41.7208L82.1052 41.5121L82.1108 38.7879L82.4478 38.9966Z",
    fill: "#050823"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3089 38.8105L77.3032 41.5404L77.1909 41.7265L77.2022 38.9966L77.3089 38.8105Z",
    fill: "#050823"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2021 38.9966L77.1909 41.7265L76.0002 42.0988L76.0115 39.3745L77.2021 38.9966Z",
    fill: "#050823"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9063 39.5042L70.9006 42.2285L70.8445 41.7998L70.8557 39.0756L70.9063 39.5042Z",
    fill: "#050823"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6785 39.6001L81.6729 42.3243L81.6448 41.969L81.6504 39.2391L81.6785 39.6001Z",
    fill: "#050823"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0115 39.3745L76.0003 42.0988L75.9048 42.3638L75.9104 39.634L76.0115 39.3745Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 39,
    width: 1,
    height: 4
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5837 42.5048V39.775C59.5894 39.8032 59.6062 39.837 59.6343 39.8652V42.5951C59.6006 42.5669 59.5837 42.5387 59.5837 42.5048Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6289 39.8652V42.5951C59.5952 42.5669 59.5784 42.5387 59.5784 42.5048V39.775C59.584 39.8032 59.6008 39.837 59.6289 39.8652Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 39,
    width: 1,
    height: 4
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M115.36 39.1094V41.8393C115.348 42.2736 115.343 42.7418 115.343 42.7869V40.057C115.348 40.0119 115.36 39.5437 115.36 39.1094Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.36 39.1094V41.8393C115.348 42.2736 115.343 42.7418 115.343 42.7869V40.057C115.348 40.0119 115.36 39.5437 115.36 39.1094Z",
    fill: "#050823"
  }))), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7766 39.9442L72.771 42.6684L71.6589 42.533L71.6646 39.8032L72.7766 39.9442Z",
    fill: "#050823"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9376 40.1585L59.9263 42.8828L59.623 42.5895L59.6287 39.8652L59.9376 40.1585Z",
    fill: "#050823"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7267 40.2036L70.7154 42.9335L70.165 42.7474L70.1707 40.0175L70.7267 40.2036Z",
    fill: "#050823"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6645 39.8032L71.6589 42.533L70.7153 42.9335L70.7266 40.2036L71.6645 39.8032Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 40,
    width: 1,
    height: 3
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9768 40.2431V42.973C59.9712 42.9448 59.9544 42.911 59.9263 42.8828V40.1529C59.96 40.1811 59.9768 40.2093 59.9768 40.2431Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9768 40.2431V42.973C59.9712 42.9448 59.9544 42.911 59.9263 42.8828V40.1529C59.96 40.1811 59.9768 40.2093 59.9768 40.2431Z",
    fill: "#050823"
  }))), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6463 39.9442L76.6407 42.674L76.4329 43.0858L76.4385 40.3559L76.6463 39.9442Z",
    fill: "#050823"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4674 40.6323L73.4618 43.3565L72.771 42.6684L72.7766 39.9442L73.4674 40.6323Z",
    fill: "#050823"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4383 40.3559L76.4327 43.0858L75.9329 43.4975L75.9441 40.7676L76.4383 40.3559Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 41,
    width: 1,
    height: 4
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7974 43.9995V41.2697C58.7974 41.2697 58.8086 41.3091 58.8198 41.3261V44.0559C58.8198 44.0559 58.7974 44.0165 58.7974 43.9995Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8252 41.3261V44.0559C58.8252 44.0559 58.8027 44.0165 58.8027 43.9995V41.2697C58.8027 41.2697 58.814 41.3091 58.8252 41.3261Z",
    fill: "#050823"
  }))), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8706 41.405L58.865 44.1293L58.8145 44.0559L58.8257 41.326L58.8706 41.405Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 41,
    width: 1,
    height: 4
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8875 41.4614V44.1913C58.8875 44.1913 58.8762 44.1518 58.8594 44.1349V41.405C58.8594 41.405 58.8875 41.4445 58.8875 41.4614Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8875 41.4614V44.1913C58.8875 44.1913 58.8762 44.1518 58.8594 44.1349V41.405C58.8594 41.405 58.8875 41.4445 58.8875 41.4614Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 42,
    width: 1,
    height: 3
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8708 44.7891V42.0593C57.8765 42.1044 57.9102 42.1495 57.9663 42.1834C57.9776 42.1834 57.9888 42.1946 58 42.2003V44.9302C58 44.9302 57.9719 44.9189 57.9607 44.9132C57.9045 44.8794 57.8765 44.8343 57.8765 44.7891H57.8708Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9998 42.2003V44.9302C57.9998 44.9302 57.9717 44.9189 57.9605 44.9132C57.9043 44.8794 57.8762 44.8343 57.8762 44.7891V42.0593C57.8818 42.1044 57.9155 42.1495 57.9717 42.1834C57.9829 42.1834 57.9942 42.1946 58.0054 42.2003H57.9998Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 42,
    width: 1,
    height: 3
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5752 42.1608V44.8906C69.5752 44.8906 69.5527 44.947 69.5303 44.9696V42.2397C69.564 42.2172 69.5752 42.189 69.5752 42.1608Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5752 42.1608V44.8906C69.5752 44.8906 69.5527 44.947 69.5303 44.9696V42.2397C69.564 42.2172 69.5752 42.189 69.5752 42.1608Z",
    fill: "#050823"
  }))), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0635 42.2623L71.0579 44.9922L70.968 44.7384L70.9792 42.0085L71.0635 42.2623Z",
    fill: "#050823"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2415 42.1157L77.2359 44.8399L76.8933 45.0712L76.9045 42.3413L77.2415 42.1157Z",
    fill: "#050823"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3299 42.3977L63.3187 45.1219L62.8301 45.1614L62.8357 42.4315L63.3299 42.3977Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 42,
    width: 1,
    height: 4
  }, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5994 42.4597V45.1896C63.5994 45.1896 63.577 45.1783 63.5657 45.1727C63.5039 45.1388 63.4141 45.1163 63.3242 45.1276V42.3977C63.4197 42.392 63.5096 42.409 63.577 42.4428C63.5882 42.4428 63.5938 42.4541 63.605 42.4597H63.5994Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5994 42.4597V45.1896C63.5994 45.1896 63.577 45.1783 63.5657 45.1727C63.5039 45.1388 63.4141 45.1163 63.3242 45.1276V42.3977C63.4197 42.392 63.5096 42.409 63.577 42.4428C63.5882 42.4428 63.5938 42.4541 63.605 42.4597H63.5994Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 42,
    width: 1,
    height: 4
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8357 42.4315V45.1614C62.729 45.167 62.6448 45.2065 62.6055 45.2573V42.5274C62.656 42.4766 62.7403 42.4428 62.8357 42.4315Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8357 42.4315V45.1614C62.729 45.167 62.6448 45.2065 62.6055 45.2573V42.5274C62.656 42.4766 62.7403 42.4428 62.8357 42.4315Z",
    fill: "#050823"
  }))), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7694 42.533L58.7638 45.2629L57.9888 44.9245L58 42.2003L58.7694 42.533Z",
    fill: "#050823"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8086 42.5556L58.803 45.2855L58.7637 45.263L58.7693 42.5331L58.8086 42.5556Z",
    fill: "#050823"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0916 42.6571L71.086 45.387L70.8501 45.2629L70.8557 42.5387L71.0916 42.6571Z",
    fill: "#050823"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M71.378 42.7079L71.3724 45.4378L71.0859 45.387L71.0916 42.6572L71.378 42.7079Z",
    fill: "#050823"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9307 42.7135L63.9195 45.4378L63.5881 45.1896L63.5994 42.4597L63.9307 42.7135Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 42,
    width: 1,
    height: 4
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9871 42.8151V45.545C63.9815 45.5111 63.959 45.4716 63.9197 45.4434V42.7136C63.9702 42.7418 63.9871 42.7812 63.9871 42.8151Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.9871 42.8151V45.545C63.9815 45.5111 63.959 45.4716 63.9197 45.4434V42.7136C63.9702 42.7418 63.9871 42.7812 63.9871 42.8151Z",
    fill: "#050823"
  }))), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M69.536 42.2397L69.5304 44.9696L68.9294 45.6013L68.9351 42.8715L69.536 42.2397Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 42,
    width: 1,
    height: 4
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9351 42.8715V45.6013C68.9351 45.6013 68.9014 45.6295 68.8789 45.6408V42.9109C68.8789 42.9109 68.9238 42.8884 68.9351 42.8715Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9351 42.8715V45.6013C68.9351 45.6013 68.9014 45.6295 68.8789 45.6408V42.9109C68.8789 42.9109 68.9238 42.8884 68.9351 42.8715Z",
    fill: "#050823"
  }))), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9889 42.6515L76.9833 45.3814L76.5283 45.6803L76.5396 42.9504L76.9889 42.6515Z",
    fill: "#050823"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M71.659 42.9504L71.6534 45.6803L71.3726 45.4378L71.3782 42.7079L71.659 42.9504Z",
    fill: "#050823"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6109 42.5274L62.6053 45.2573L62.2515 45.6803L62.2571 42.9504L62.6109 42.5274Z",
    fill: "#050823"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5165 42.9899L59.5109 45.7198L58.8032 45.2855L58.8088 42.5556L59.5165 42.9899Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 42,
    width: 1,
    height: 4
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2234 45.7536V43.0238C62.2234 43.0238 62.2402 42.973 62.2571 42.9504V45.6803C62.2571 45.6803 62.2234 45.7311 62.2234 45.7536Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2571 42.9504V45.6803C62.2571 45.6803 62.2234 45.7311 62.2234 45.7536V43.0238C62.2234 43.0238 62.2402 42.973 62.2571 42.9504Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 42,
    width: 1,
    height: 4
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6568 43.0351V45.7649C59.595 45.7593 59.5501 45.7424 59.5107 45.7198V42.9899C59.5613 43.0125 59.6062 43.0294 59.6568 43.0351Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6568 43.0351V45.7649C59.595 45.7593 59.5501 45.7424 59.5107 45.7198V42.9899C59.5613 43.0125 59.6062 43.0294 59.6568 43.0351Z",
    fill: "#050823"
  }))), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1756 43.0971L72.17 45.8213L71.6533 45.6803L71.6589 42.9504L72.1756 43.0971Z",
    fill: "#050823"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5396 42.9504L76.5284 45.6803L76.2812 45.8834L76.2925 43.1535L76.5396 42.9504Z",
    fill: "#050823"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3363 43.1366L60.3307 45.8664L59.6511 45.7649L59.6567 43.035L60.3363 43.1366Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 43,
    width: 1,
    height: 4
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5611 43.3057V46.0356C60.5555 45.9905 60.5218 45.9454 60.4656 45.9115C60.4319 45.889 60.387 45.8777 60.3308 45.8664V43.1365C60.3926 43.1422 60.4375 43.1591 60.4712 43.1817C60.5274 43.2155 60.5611 43.2606 60.5611 43.3057Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5611 43.3057V46.0356C60.5555 45.9905 60.5218 45.9454 60.4656 45.9115C60.4319 45.889 60.387 45.8777 60.3308 45.8664V43.1365C60.3926 43.1422 60.4375 43.1591 60.4712 43.1817C60.5274 43.2155 60.5611 43.2606 60.5611 43.3057Z",
    fill: "#050823"
  }))), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2923 43.1535L76.2811 45.8834L76.0002 46.1485L76.0059 43.4186L76.2923 43.1535Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 43,
    width: 1,
    height: 4
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2568 46.0639V43.334C63.2625 43.3622 63.2793 43.396 63.3074 43.4242V46.1541C63.2681 46.1259 63.2568 46.0977 63.2568 46.0639Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3074 43.4242V46.1541C63.2681 46.1259 63.2568 46.0977 63.2568 46.0639V43.334C63.2625 43.3622 63.2793 43.396 63.3074 43.4242Z",
    fill: "#050823"
  }))), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5687 43.5314L72.5631 46.2613L72.1699 45.8213L72.1755 43.0971L72.5687 43.5314Z",
    fill: "#050823"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8901 42.9053L68.8789 45.6352L67.6826 46.3459L67.6882 43.616L68.8901 42.9053Z",
    fill: "#050823"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1185 43.6442L75.1129 46.374L74.759 46.4474L74.7646 43.7175L75.1185 43.6442Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 43,
    width: 1,
    height: 4
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6882 43.616V46.3458C67.6321 46.374 67.5984 46.4135 67.5984 46.453V43.7231C67.6096 43.6836 67.6377 43.6442 67.6882 43.616Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6882 43.616V46.3458C67.6321 46.374 67.5984 46.4135 67.5984 46.453V43.7231C67.6096 43.6836 67.6377 43.6442 67.6882 43.616Z",
    fill: "#050823"
  }))), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2474 43.6385L76.2361 46.3628L75.9497 46.5376L75.9553 43.8078L76.2474 43.6385Z",
    fill: "#050823"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4669 43.8247L75.4612 46.5545L75.113 46.374L75.1187 43.6442L75.4669 43.8247Z",
    fill: "#050823"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9554 43.8077L75.9498 46.5376L75.4612 46.5545L75.4668 43.8247L75.9554 43.8077Z",
    fill: "#050823"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4393 43.819L73.428 46.5489L73.2202 46.673L73.2314 43.9488L73.4393 43.819Z",
    fill: "#050823"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7646 43.7175L74.759 46.4474L74.7366 46.6843L74.7422 43.9544L74.7646 43.7175Z",
    fill: "#050823"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2315 43.9487L73.2203 46.673L72.8496 46.7407L72.8608 44.0108L73.2315 43.9487Z",
    fill: "#050823"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8609 44.0108L72.8497 46.7407L72.5464 46.5602L72.552 43.8303L72.8609 44.0108Z",
    fill: "#050823"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9139 43.9995L63.9083 46.7294L63.3018 46.1541L63.3074 43.4242L63.9139 43.9995Z",
    fill: "#050823"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7423 43.9544L74.7367 46.6843L74.2986 46.8253L74.3042 44.0954L74.7423 43.9544Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 43,
    width: 2,
    height: 4
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1106 44.0785V46.8084C64.0432 46.8027 63.9927 46.7858 63.9534 46.7576C63.9365 46.7463 63.9253 46.7407 63.9141 46.7294V43.9995C63.9141 43.9995 63.9478 44.0221 63.9646 44.0277C64.0039 44.0503 64.0601 44.0672 64.1163 44.0785H64.1106Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1106 44.0785V46.8084C64.0432 46.8027 63.9927 46.7858 63.9534 46.7576C63.9365 46.7463 63.9253 46.7407 63.9141 46.7294V43.9995C63.9141 43.9995 63.9478 44.0221 63.9646 44.0277C64.0039 44.0503 64.0601 44.0672 64.1163 44.0785H64.1106Z",
    fill: "#050823"
  }))), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M67.604 43.7231L67.5928 46.453L67.5535 46.8535L67.5647 44.1236L67.604 43.7231Z",
    fill: "#050823"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6273 44.1405L64.6217 46.8648L64.0994 46.8084L64.1106 44.0785L64.6273 44.1405Z",
    fill: "#050823"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7369 44.1744L73.7313 46.8986L73.428 46.5489L73.4392 43.819L73.7369 44.1744Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 44,
    width: 1,
    height: 3
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5645 44.1236V46.8535C67.5532 46.893 67.5252 46.9324 67.4746 46.9606V44.2308C67.5308 44.2026 67.5645 44.1631 67.5645 44.1236Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5645 44.1236V46.8535C67.5532 46.893 67.5252 46.9324 67.4746 46.9606V44.2308C67.5308 44.2026 67.5645 44.1631 67.5645 44.1236Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 44,
    width: 1,
    height: 4
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8631 44.2871V47.017C64.8462 46.9775 64.8182 46.9437 64.7732 46.9155C64.7339 46.8929 64.6834 46.876 64.6216 46.8704V44.1405C64.689 44.1461 64.7395 44.1631 64.7788 44.1856C64.8238 44.2138 64.8575 44.2477 64.8631 44.2871Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8631 44.2871V47.017C64.8462 46.9775 64.8182 46.9437 64.7732 46.9155C64.7339 46.8929 64.6834 46.876 64.6216 46.8704V44.1405C64.689 44.1461 64.7395 44.1631 64.7788 44.1856C64.8238 44.2138 64.8575 44.2477 64.8631 44.2871Z",
    fill: "#050823"
  }))), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2591 44.3267L74.2479 47.0565L73.7312 46.8986L73.7368 44.1744L74.2591 44.3267Z",
    fill: "#050823"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3042 44.0954L74.2986 46.8253L74.248 47.0565L74.2593 44.3266L74.3042 44.0954Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 44,
    width: 2,
    height: 4
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0484 44.4226V47.1524C65.0034 47.1412 64.9697 47.1299 64.9417 47.113C64.8967 47.0848 64.863 47.0509 64.8574 47.0114V44.2816C64.8743 44.321 64.9024 44.3549 64.9529 44.3831C64.981 44.4 65.0147 44.4113 65.054 44.4226H65.0484Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0484 44.4226V47.1524C65.0034 47.1412 64.9697 47.1299 64.9417 47.113C64.8967 47.0848 64.863 47.0509 64.8574 47.0114V44.2816C64.8743 44.321 64.9024 44.3549 64.9529 44.3831C64.981 44.4 65.0147 44.4113 65.054 44.4226H65.0484Z",
    fill: "#050823"
  }))), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1856 44.4677L76.1744 47.1919L75.916 46.6956L75.9273 43.9713L76.1856 44.4677Z",
    fill: "#050823"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4867 44.5241L65.481 47.2539L65.0374 47.1524L65.0486 44.4225L65.4867 44.5241Z",
    fill: "#050823"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4804 44.2308L67.4691 46.9607L66.7166 47.4062L66.7278 44.6764L67.4804 44.2308Z",
    fill: "#050823"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5894 44.665L59.5837 47.3949L59.5669 47.237L59.5781 44.5128L59.5894 44.665Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 44,
    width: 1,
    height: 4
  }, _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6719 44.6876V47.4175C65.6663 47.3724 65.6326 47.3272 65.5764 47.2934C65.5484 47.2765 65.5147 47.2652 65.4753 47.2539V44.524C65.5203 44.5353 65.554 44.5466 65.582 44.5635C65.6382 44.5974 65.6719 44.6369 65.6719 44.6876Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6719 44.6876V47.4175C65.6663 47.3724 65.6326 47.3272 65.5764 47.2934C65.5484 47.2765 65.5147 47.2652 65.4753 47.2539V44.524C65.5203 44.5353 65.554 44.5466 65.582 44.5635C65.6382 44.5974 65.6719 44.6369 65.6719 44.6876Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 44,
    width: 1,
    height: 4
  }, _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8633 44.524V47.2539C63.8577 47.3216 63.7903 47.3836 63.6724 47.4118V44.682C63.7959 44.6538 63.8633 44.5917 63.8633 44.524Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.8633 44.524V47.2539C63.8577 47.3216 63.7903 47.3836 63.6724 47.4118V44.682C63.7959 44.6538 63.8633 44.5917 63.8633 44.524Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 44,
    width: 1,
    height: 4
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5894 44.6763V47.4062H59.5837V44.6763L59.5894 44.682V44.6763Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5894 44.6763V47.4062H59.5837V44.6763L59.5894 44.682V44.6763Z",
    fill: "#050823"
  }))), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M63.678 44.682L63.6724 47.4119L63.4253 47.4683L63.4309 44.7384L63.678 44.682Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 44,
    width: 1,
    height: 4
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7278 44.6763V47.4062C66.6829 47.4288 66.6604 47.4513 66.6492 47.4795V44.7497C66.6492 44.7497 66.6941 44.6989 66.7278 44.6763Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7278 44.6763V47.4062C66.6829 47.4288 66.6604 47.4513 66.6492 47.4795V44.7497C66.6492 44.7497 66.6941 44.6989 66.7278 44.6763Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 44,
    width: 1,
    height: 4
  }, _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4309 44.7384V47.4683C63.3748 47.4796 63.3298 47.4965 63.2961 47.5247V44.7948C63.3355 44.7722 63.3804 44.7497 63.4309 44.7384Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4309 44.7384V47.4683C63.3748 47.4796 63.3298 47.4965 63.2961 47.5247V44.7948C63.3355 44.7722 63.3804 44.7497 63.4309 44.7384Z",
    fill: "#050823"
  }))), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3075 44.7948L63.3019 47.519L62.5493 48.0831L62.5549 45.3588L63.3075 44.7948Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 45,
    width: 1,
    height: 4
  }, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8145 47.9364V45.2065C58.8201 45.2517 58.8481 45.2911 58.9043 45.325C58.9268 45.3363 58.9549 45.3475 58.9886 45.3588V48.0887C58.9492 48.0774 58.9212 48.0661 58.8987 48.0549C58.8425 48.021 58.8145 47.9815 58.8145 47.9364Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9886 45.3588V48.0887C58.9492 48.0774 58.9212 48.0661 58.8987 48.0549C58.8425 48.021 58.8145 47.9815 58.8145 47.9364V45.2065C58.8201 45.2517 58.8481 45.2911 58.9043 45.325C58.9268 45.3363 58.9549 45.3475 58.9886 45.3588Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 45,
    width: 1,
    height: 4
  }, _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5547 45.3588V48.0887C62.5547 48.0887 62.5154 48.1169 62.5098 48.1338V45.4039C62.5098 45.4039 62.5435 45.3757 62.5547 45.3588Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5547 45.3588V48.0887C62.5547 48.0887 62.5154 48.1169 62.5098 48.1338V45.4039C62.5098 45.4039 62.5435 45.3757 62.5547 45.3588Z",
    fill: "#050823"
  }))), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6548 44.7497L66.6492 47.4796L66.3291 48.1508L66.3403 45.4209L66.6548 44.7497Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 45,
    width: 1,
    height: 4
  }, _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6382 48.0887V45.3588C65.6438 45.4039 65.6775 45.4491 65.7337 45.4773C65.773 45.4998 65.8179 45.5168 65.8741 45.5224V48.2523C65.8123 48.2466 65.7674 48.2297 65.728 48.2072C65.6719 48.1733 65.6438 48.1338 65.6438 48.0887H65.6382Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8685 45.528V48.2579C65.8067 48.2522 65.7617 48.2353 65.7224 48.2128C65.6663 48.1789 65.6382 48.1394 65.6382 48.0943V45.3644C65.6438 45.4096 65.6775 45.4547 65.7337 45.4829C65.773 45.5054 65.8179 45.5224 65.8741 45.528H65.8685Z",
    fill: "#050823"
  }))), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M65.992 45.5449L65.9807 48.2692L65.8628 48.2523L65.8684 45.528L65.992 45.5449Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 45,
    width: 2,
    height: 4
  }, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3402 45.4208V48.1507C66.2896 48.2353 66.138 48.2917 65.9863 48.2692V45.5393C66.1492 45.5618 66.3008 45.5054 66.3402 45.4208Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3402 45.4208V48.1507C66.2896 48.2353 66.138 48.2917 65.9863 48.2692V45.5393C66.1492 45.5618 66.3008 45.5054 66.3402 45.4208Z",
    fill: "#050823"
  }))), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7187 45.5675L59.7074 48.2918L58.9829 48.0887L58.9885 45.3588L59.7187 45.5675Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 45,
    width: 1,
    height: 4
  }, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8477 45.6352V48.3651C59.8477 48.3651 59.8084 48.3369 59.7859 48.3256C59.7634 48.3143 59.7354 48.3031 59.7073 48.2918V45.5619C59.741 45.5675 59.7691 45.5788 59.7915 45.5957C59.814 45.607 59.8308 45.6239 59.8421 45.6352H59.8477Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8477 45.6352V48.3651C59.8477 48.3651 59.8084 48.3369 59.7859 48.3256C59.7634 48.3143 59.7354 48.3031 59.7073 48.2918V45.5619C59.741 45.5675 59.7691 45.5788 59.7915 45.5957C59.814 45.607 59.8308 45.6239 59.8421 45.6352H59.8477Z",
    fill: "#050823"
  }))), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M76.326 46.0469L76.3204 48.7768L75.8206 48.3707L75.8262 45.6408L76.326 46.0469Z",
    fill: "#050823"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3194 46.1485L60.3138 48.8727L59.8364 48.3651L59.8477 45.6352L60.3194 46.1485Z",
    fill: "#050823"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9721 46.2782L76.9608 49.0081L76.3206 48.7768L76.3262 46.0469L76.9721 46.2782Z",
    fill: "#050823"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7914 46.6673L60.7857 49.3972L60.314 48.8727L60.3196 46.1484L60.7914 46.6673Z",
    fill: "#050823"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5155 45.3983L62.5099 48.1282L61.6731 49.4085L61.6787 46.6787L62.5155 45.3983Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 46,
    width: 2,
    height: 4
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0103 46.7576V49.4875C60.9373 49.4875 60.8811 49.4649 60.8362 49.4367C60.8137 49.4254 60.7969 49.4142 60.7856 49.3972V46.6674C60.7856 46.6674 60.825 46.6956 60.8418 46.7068C60.8867 46.735 60.9429 46.752 61.0103 46.7576Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0103 46.7576V49.4875C60.9373 49.4875 60.8811 49.4649 60.8362 49.4367C60.8137 49.4254 60.7969 49.4142 60.7856 49.3972V46.6674C60.7856 46.6674 60.825 46.6956 60.8418 46.7068C60.8867 46.735 60.9429 46.752 61.0103 46.7576Z",
    fill: "#050823"
  }))), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3697 46.7858L61.3641 49.5156L61.0046 49.4874L61.0103 46.7576L61.3697 46.7858Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 46,
    width: 1,
    height: 4
  }, _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6788 46.6786V49.4085C61.6226 49.4818 61.4934 49.527 61.3586 49.5157V46.7858C61.5047 46.7971 61.6282 46.752 61.6788 46.6786Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6788 46.6786V49.4085C61.6226 49.4818 61.4934 49.527 61.3586 49.5157V46.7858C61.5047 46.7971 61.6282 46.752 61.6788 46.6786Z",
    fill: "#050823"
  }))), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6935 40.982C68.7272 40.9989 68.7496 41.0271 68.7665 41.0497L69.0698 41.6024L69.0978 41.6363L69.5359 42.0649C69.5865 42.1157 69.5921 42.1834 69.5359 42.2341L68.935 42.8658C68.935 42.8658 68.9069 42.894 68.89 42.9053L67.6881 43.616C67.6376 43.6442 67.6095 43.6837 67.6039 43.7232L67.5646 44.1236C67.5646 44.1631 67.5309 44.2026 67.4803 44.2308L66.7278 44.6764C66.6941 44.6989 66.6716 44.7215 66.6547 44.7497L66.3402 45.4209C66.3009 45.5055 66.1437 45.5619 65.992 45.5393L65.8685 45.5224C65.8123 45.5168 65.7674 45.4998 65.728 45.4773C65.6719 45.4434 65.6382 45.3983 65.6438 45.3532L65.6719 44.682C65.6719 44.6369 65.6382 44.5918 65.582 44.5579C65.5539 44.541 65.5202 44.5297 65.4809 44.5184L65.0429 44.4169C65.0035 44.4056 64.9698 44.3944 64.9418 44.3774C64.8968 44.3492 64.8631 44.3154 64.8575 44.2759C64.8519 44.2364 64.8182 44.2026 64.7733 44.1744C64.734 44.1518 64.6834 44.1349 64.6216 44.1293L64.0993 44.0729C64.0431 44.0672 63.987 44.0503 63.9477 44.0221C63.9308 44.0108 63.9196 44.0052 63.9084 43.9939L63.3018 43.4186C63.2288 43.3509 63.2512 43.255 63.3579 43.2043L63.8859 42.9335C63.9982 42.8771 64.0151 42.7756 63.9252 42.7023L63.5938 42.4541C63.5938 42.4541 63.577 42.4428 63.5658 42.4372C63.504 42.4033 63.4141 42.3808 63.3243 42.3921L62.83 42.4316C62.7345 42.4372 62.6503 42.4767 62.6054 42.5274L62.2515 42.9505C62.2122 43.0012 62.2122 43.0576 62.2628 43.1084L62.7514 43.6104L63.8016 44.4226C63.9196 44.5128 63.8578 44.6425 63.6781 44.682L63.431 44.7384C63.3804 44.7497 63.3411 44.7666 63.3074 44.7948L62.5548 45.3588C62.5548 45.3588 62.5267 45.387 62.5155 45.404L61.6787 46.6843C61.6337 46.7576 61.5046 46.8027 61.3698 46.7915L61.0103 46.7633C60.9429 46.7633 60.8868 46.7407 60.8418 46.7125C60.8194 46.7012 60.8025 46.6899 60.7913 46.673L60.3195 46.1485L59.8421 45.6408C59.8421 45.6408 59.8084 45.6126 59.7916 45.6014C59.7691 45.5901 59.741 45.5788 59.7129 45.5675L58.9828 45.3645C58.9491 45.3532 58.9267 45.3419 58.8986 45.3306C58.7806 45.263 58.7806 45.1501 58.9154 45.0825L59.4771 44.8061C59.5445 44.7723 59.5838 44.7215 59.5782 44.6707L59.5669 44.5128V44.4733L59.7017 44.039C59.713 44.0165 59.7298 43.9883 59.7579 43.9657L60.4936 43.4017C60.5835 43.3283 60.561 43.2325 60.4655 43.1761C60.4318 43.1535 60.3869 43.1422 60.3307 43.1309L59.6512 43.0294C59.595 43.0238 59.5501 43.0069 59.5108 42.9843L58.8031 42.55L58.7638 42.5274L57.9887 42.189C57.9887 42.189 57.9663 42.1777 57.955 42.1721C57.8933 42.1383 57.8596 42.0819 57.8708 42.0311L57.9326 41.704C57.955 41.5855 58.1685 41.5235 58.3482 41.5686L58.4605 41.6024C58.6964 41.6645 58.9491 41.5347 58.8593 41.3937L58.8143 41.3204C58.775 41.2584 58.8031 41.1907 58.8817 41.1456L59.1625 40.9764L59.1962 40.9538L59.9151 40.3334C59.9769 40.277 59.9825 40.2093 59.9208 40.1529L59.6175 39.8596C59.5613 39.8032 59.5613 39.7355 59.6175 39.6848L59.668 39.634C59.7691 39.5325 59.9994 39.5268 60.1286 39.6001C60.151 39.6114 60.1735 39.634 60.1903 39.6509L60.4655 40.0062L60.5049 40.0514C60.5049 40.0514 60.5386 40.0852 60.561 40.1021C60.6846 40.1755 60.898 40.1698 61.0047 40.0796L61.19 39.9216C61.2743 39.8483 61.4372 39.8314 61.572 39.8709L62.3077 40.1134C62.3077 40.1134 62.3526 40.1303 62.3695 40.1416C62.42 40.1698 62.4481 40.2093 62.4537 40.2544L62.4874 40.5872C62.4874 40.6323 62.5267 40.6718 62.5773 40.7C62.6054 40.7169 62.6391 40.7282 62.6728 40.7395L64.1611 41.0779C64.1948 41.0835 64.2285 41.0892 64.2622 41.0892L65.7842 41.1061C65.846 41.1061 65.9022 41.1174 65.9471 41.1399L66.5705 41.3994C66.6884 41.4445 66.8457 41.4389 66.9468 41.3825L67.778 40.8974C67.8566 40.8523 67.969 40.8354 68.0701 40.8579L68.5587 40.9482C68.6036 40.9538 68.6429 40.9707 68.6766 40.9876L68.6935 40.982Z",
    fill: "#1D244A"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1797 46.9607L77.1685 49.6849L76.9607 49.0081L76.9719 46.2782L77.1797 46.9607Z",
    fill: "#050823"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M122.054 45.889L122.049 48.6132L121.813 50.0515L121.824 47.3216L122.054 45.889Z",
    fill: "#050823"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0843 48.365L77.0787 51.0949L76.5227 50.6099L76.5283 47.8856L77.0843 48.365Z",
    fill: "#050823"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3305 48.7542L99.3193 51.4841L98.3364 51.4446L98.342 48.7204L99.3305 48.7542Z",
    fill: "#050823"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3422 48.7204L98.3366 51.4446L97.5278 51.9974L97.5391 49.2675L98.3422 48.7204Z",
    fill: "#050823"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4662 49.2732L77.4605 52.003L76.9832 51.5124L76.9944 48.7825L77.4662 49.2732Z",
    fill: "#050823"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M100.083 49.3634L100.078 52.0933L99.3193 51.4841L99.3306 48.7543L100.083 49.3634Z",
    fill: "#050823"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8987 49.4931L96.8931 52.2174L95.4666 51.9805L95.4778 49.2506L96.8987 49.4931Z",
    fill: "#050823"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5389 49.2675L97.5277 51.9974L96.8931 52.2174L96.8987 49.4931L97.5389 49.2675Z",
    fill: "#1D244A"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M100.566 50.1023L100.561 52.8265L100.078 52.0933L100.083 49.3634L100.566 50.1023Z",
    fill: "#050823"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4778 49.2506L95.4666 51.9805L94.0007 52.8265L94.012 50.0966L95.4778 49.2506Z",
    fill: "#050823"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M124.469 49.5326L124.464 52.2625L123.711 53.1029L123.717 50.3786L124.469 49.5326Z",
    fill: "#050823"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M102.133 50.373L102.128 53.0972L100.561 52.8265L100.566 50.1022L102.133 50.373Z",
    fill: "#050823"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M104.413 50.4125L104.408 53.1423L102.127 53.0972L102.133 50.373L104.413 50.4125Z",
    fill: "#050823"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4153 50.8186L78.4096 53.5428L77.292 52.6178L77.3032 49.8936L78.4153 50.8186Z",
    fill: "#050823"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M106.435 50.8975L106.424 53.6274L104.408 53.1424L104.413 50.4125L106.435 50.8975Z",
    fill: "#050823"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0892 50.8749L79.078 53.6048L78.4097 53.5428L78.4153 50.8185L79.0892 50.8749Z",
    fill: "#050823"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M94.012 50.0966L94.0008 52.8265L93.7424 53.7628L93.748 51.0329L94.012 50.0966Z",
    fill: "#050823"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5724 51.2247L79.5667 53.9546L79.0781 53.6049L79.0894 50.875L79.5724 51.2247Z",
    fill: "#050823"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7479 51.0329L93.7423 53.7628L93.4165 54.1463L93.4277 51.4164L93.7479 51.0329Z",
    fill: "#050823"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3136 51.3826L80.308 54.1125L79.5667 53.9546L79.5723 51.2247L80.3136 51.3826Z",
    fill: "#050823"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M108.536 51.924L108.525 54.6539L106.424 53.6274L106.435 50.8975L108.536 51.924Z",
    fill: "#1D244A"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4278 51.4164L93.4166 54.1463L91.7542 54.6652L91.7654 51.941L93.4278 51.4164Z",
    fill: "#050823"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7654 51.941L91.7542 54.6652L91.6362 55.2123L91.6418 52.4824L91.7654 51.941Z",
    fill: "#050823"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M108.609 52.646L108.603 55.3759L108.524 54.654L108.536 51.9241L108.609 52.646Z",
    fill: "#050823"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5886 52.6121L81.583 55.3364L80.3081 54.1124L80.3137 51.3826L81.5886 52.6121Z",
    fill: "#050823"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0211 52.8209L82.0099 55.5451L81.583 55.3364L81.5886 52.6122L82.0211 52.8209Z",
    fill: "#1D244A"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6417 52.4824L91.6361 55.2123L90.906 55.8891L90.9116 53.1592L91.6417 52.4824Z",
    fill: "#050823"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4703 53.2044L82.4647 55.9343L82.0098 55.5451L82.021 52.8209L82.4703 53.2044Z",
    fill: "#050823"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9116 53.1593L90.906 55.8892L87.4351 56.0076L87.4407 53.2777L90.9116 53.1593Z",
    fill: "#050823"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5029 53.289L86.4973 56.0189L85.3403 55.6918L85.3516 52.9675L86.5029 53.289Z",
    fill: "#050823"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4409 53.2777L87.4352 56.0076L86.4973 56.0189L86.5029 53.289L87.4409 53.2777Z",
    fill: "#050823"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4309 53.3172L83.4252 56.0414L82.4648 55.9343L82.4705 53.2044L83.4309 53.3172Z",
    fill: "#050823"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3515 52.9675L85.3402 55.6918L83.425 56.0415L83.4307 53.3172L85.3515 52.9675Z",
    fill: "#050823"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M110.569 53.9376L110.563 56.6619L108.603 55.3759L108.609 52.646L110.569 53.9376Z",
    fill: "#050823"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M113.688 54.4594L113.68 57.1893L114.528 57.1916L114.536 54.4618L113.688 54.4594Z",
    fill: "#050823"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M113.692 54.4622L113.686 57.192L110.563 56.6619L110.569 53.9376L113.692 54.4622Z",
    fill: "#050823"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M125.823 53.7458L125.812 56.4757L125.491 57.3951L125.497 54.6652L125.823 53.7458Z",
    fill: "#050823"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M115.831 55.1052L115.826 57.8351L114.534 57.1921L114.54 54.4678L115.831 55.1052Z",
    fill: "#1D244A"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M125.497 54.6652L125.491 57.3951L124.245 57.9591L124.256 55.2292L125.497 54.6652Z",
    fill: "#050823"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M117.454 55.5959L117.443 58.3201L115.826 57.835L115.831 55.1052L117.454 55.5959Z",
    fill: "#050823"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M124.256 55.2292L124.245 57.9591L123.492 58.7939L123.503 56.0696L124.256 55.2292Z",
    fill: "#050823"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M120.83 56.143L120.824 58.8672L117.443 58.3201L117.455 55.5959L120.83 56.143Z",
    fill: "#050823"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M121.274 56.5716L121.268 59.3015L120.824 58.8672L120.83 56.1429L121.274 56.5716Z",
    fill: "#050823"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M127.496 2.65089C127.614 2.71857 127.727 2.79754 127.845 2.88778C127.171 3.339 126.704 3.84098 125.856 3.89174C125.379 3.91995 124.89 3.8861 124.407 3.88046L123.75 3.60973V3.38412L122.857 2.94418L122.796 2.47604L122.127 2.42528L122.335 2.99495L121.953 3.16415L121.262 2.99495L120.291 3.41232L120.751 3.89174L121.728 3.95379L120.88 4.56857L119.942 4.8111L119.521 5.45409L118.387 5.84327L117.252 6.63854L118.067 7.28153L118.302 7.95272L118.943 7.51278L119.83 7.4733L120.313 7.19129L121.936 6.85287L121.61 6.69494L121.369 6.5765L122.166 6.47498L124.312 6.42421L126.485 6.31141L127.3 6.35653L126.345 6.61034L126.862 6.83031L127.569 6.74007L128.973 6.62726L128.99 6.80775L128.58 6.99952L128.625 7.28717L127.395 7.27025L126.418 7.04464C126.362 7.039 125.317 6.91492 125.267 6.94312C125.216 6.97132 123.975 6.85851 123.908 6.85851L123.879 7.14616L125.727 7.39434L126.918 7.97528L128.019 8.8044L127.772 9.68991L127.047 9.75196L127.03 10.1863L127.575 10.457L127.991 10.6544L127.766 11.021L128.204 11.1225L129.266 10.942L130.72 10.9928L131.911 11.2917L131.591 11.6076L131.714 12.0645L130.995 12.448L129.872 11.9911L129.024 11.743L128.631 12.166L127.957 12.1547L127.232 11.7937L126.62 11.8388L125.946 12.4085L125.789 12.9331L126.306 12.8146L127.249 12.5721L127.805 12.6736L127.502 12.9218L127.609 13.6945L128.109 13.514L129.176 13.655L130.288 13.5478C130.338 13.5478 131.237 13.6324 131.315 13.6719C131.389 13.7114 131.827 13.8806 131.933 13.8806C132.046 13.8806 132.422 13.9314 132.439 13.937L133.09 14.3488L133.495 14.9015L134.416 15.161L134.444 15.6065V16.3736L134.303 17.1463L133.978 17.8175L133.023 18.3026L133.579 18.5902L133.422 18.8948L132.916 18.9568H132.164L131.658 19.3347L131.821 20.1751L132.574 20.0792L133.551 20.2485L134.758 20.1187L136.393 20.2879L137.842 20.8971L138.207 21.6585L137.948 22.1154L138.308 22.5384L137.741 22.9952L136.679 22.8599L135.696 22.9614L134.354 22.8204L134 23.0911L133.231 23.0347L133.955 23.7172C133.955 23.7172 134.506 24.0387 134.444 24.112C134.539 24.1684 135.382 24.1007 135.427 24.1007L135.82 24.3038L136.505 24.3997L137.01 24.2079L138.437 24.0838L139.195 24.3489L140.122 24.7606L141.492 24.8396L141.717 25.0539L141.24 25.2175L140.358 25.3247H138.982L136.022 24.8622L135.646 25.178L134.865 25.0201L133.787 24.0556L132.074 23.5085L129.67 22.9445L129.619 23.8582L128.929 23.9654L127.496 23.3619L126.12 23.3167H124.194L122.891 24.2756L123.329 24.7494L123.481 25.9846L123.784 26.825L123.132 27.4398L124.548 28.0658L125.682 28.8611L126.418 28.7709L128.44 28.9175L129.322 29.4984L128.665 30.0625L127.586 30.023L126.306 29.5831L126.424 30.102L125.755 30.4911C125.424 30.4291 119.156 29.239 119.134 29.2277C119.033 29.16 118.943 29.1093 118.836 29.0585C118.448 28.8611 117.864 28.5735 117.831 28.5565L116.786 28.3478L116.404 28.9965L114.921 29.0416L113.989 28.7257L112.063 28.7088L110.956 29.2503L108.603 30.6829L107.25 30.9988L108.283 31.2356L108.614 31.1398L109.816 30.7957L110.962 30.9254L112.018 32.7811L111.349 33.7399L111.518 34.4562L110.03 36.3795L109.182 37.5076L110.018 37.7332L111.209 37.1297L112.478 35.6125L113.467 36.0299C113.557 36.1483 115.298 38.3536 115.331 38.3931C115.365 38.427 115.343 39.9949 115.343 40.0739L115.556 42.0818L116.342 43.4468L117.241 43.6893C117.292 43.7119 118.229 44.1631 118.28 44.1913C118.331 44.2195 119.162 44.3323 119.207 44.3379L121.549 45.3081L122.054 45.9172L121.818 47.3498V48.3143C121.908 48.3425 123.453 48.9291 123.599 49.0024C123.644 49.0475 124.424 49.5382 124.464 49.5608L123.711 50.4068C123.745 50.4238 124.357 50.717 124.407 50.7453C124.464 50.7791 125.233 51.9579 125.272 52.0199L125.817 53.7741L125.491 54.6934L124.245 55.2574L123.492 56.0922L122.616 56.7239L121.262 56.5998L120.819 56.1655L117.438 55.6184L115.814 55.1334L114.523 54.4904H113.675L110.552 53.9602L108.592 52.6742L108.513 51.9523L106.413 50.9257L104.396 50.4407L102.116 50.3956L100.549 50.1248L100.066 49.3916L99.308 48.7824L98.3251 48.743L97.522 49.2957L96.8817 49.5157L95.4608 49.2788L93.9949 50.1192L93.7366 51.0555L93.4109 51.439L91.7484 51.9579L91.6249 52.505L90.8947 53.1818L87.4238 53.3003L86.4859 53.3116L85.3346 52.9901L83.4138 53.3398L82.4534 53.2326L81.9985 52.8434L81.566 52.6347L80.2911 51.4108L79.5497 51.2529L79.0667 50.9032L78.3984 50.8411L77.2864 49.9161L77.4492 49.2957L76.9775 48.805L77.0729 48.3876L76.5169 47.9082L77.1628 46.9832L76.955 46.3064L76.3147 46.0751L75.8149 45.669L76.1743 44.4902L75.916 43.9939L76.4944 43.7401L76.955 43.3622L77.5559 43.2268L77.9603 42.5782L78.404 41.8562L79.2521 41.2358L79.7912 40.9933L80.19 40.542L80.9201 40.2657L81.0942 39.7411L81.6671 39.6227L81.639 39.2674L82.2006 39.3181L82.5489 39.6283L83.206 39.837L83.2902 40.3616L83.762 40.3898L84.8628 40.2262L85.211 39.8201L86.1714 39.5832L86.9464 39.775L87.4968 39.6565L88.0697 39.3802L88.8223 39.2956L88.9796 38.9459L88.3955 38.7033L88.1989 38.4213L88.9627 37.7163L89.5524 37.6768L90.2376 37.3553L90.8329 37.4061L92.8436 36.6785L92.6751 36.2724L93.2367 35.8155L94.0062 35.7986L94.8093 35.2007L93.804 34.2024L93.1076 33.8189L92.237 33.6779L92.1416 34.1178L91.6192 34.5352L90.4791 34.71L90.6476 35.0541L90.2601 35.2684H89.8557L89.7097 35.7478L88.7942 35.6971L88.3281 35.5392L87.6597 35.6576L86.8847 35.4038L86.7049 35.1556L86.3624 34.9131L85.475 35.2402L85.7558 35.5109L85.6996 35.7309L84.9302 35.8212L85.3458 35.934L86.4466 35.8832L87.1318 35.8042L87.2441 36.1709L86.7218 36.2047L86.8903 36.419L87.5249 36.6221L86.9745 36.718L86.9464 36.8984L86.6095 36.9436L86.1714 36.7687L85.7614 37.1353L85.4076 36.9831L85.5424 36.7405L85.1829 36.6559L84.3798 36.7969L83.498 36.4698L83.1723 36.2498L82.2006 36.3006L81.1841 36.6841L80.3416 36.6446L79.9934 36.5206L79.4767 36.7969L78.7522 36.718L78.4658 36.9097L78.6904 37.0225L78.9207 37.2425L79.926 37.0902L80.2855 37.3158L81.156 37.141L81.7008 36.842L81.7963 37.1015L82.2793 37.0169L83.3071 36.7349L83.6103 36.8533L83.6665 37.0451L82.8184 37.1353L82.7679 37.3497L83.2734 37.2651L83.5598 37.3271L83.7676 37.8122L83.6384 38.0152L83.6777 38.3706L84.1607 38.5962L83.8182 38.7992L83.1442 38.8443L82.4421 39.0248L82.1052 38.8161L82.2456 38.63L82.869 38.4721L83.1161 38.2183L83.3576 37.9927L83.2284 37.7614L82.4309 37.5471L81.0212 37.7276L79.7519 38.0885H79.224L79.0499 38.269L78.6904 38.2239L78.6174 38.0434L78.3478 37.9137L78.0277 38.0434L77.4548 38.2521L77.6907 38.7315L77.3032 38.8387L77.1909 39.0248L76.0002 39.4027L75.8991 39.6678L76.6349 39.978L76.4271 40.3898L75.9328 40.8015L76.2642 40.9425L76.3203 41.4783L76.8202 41.4896L76.9606 41.6814L76.9943 41.9239L77.2358 42.1439L76.8988 42.3695L76.9831 42.6797L76.5281 42.9786L76.281 43.1817L75.9946 43.4468L76.2361 43.6667L75.944 43.8359L75.4554 43.8529L75.1072 43.6724L74.7534 43.7457L74.7309 43.9826L74.2928 44.1236L74.2479 44.3549L73.7256 44.1969L73.4279 43.8416L73.2201 43.9713L72.8495 44.039L72.5462 43.8585L72.5574 43.5596L72.1699 43.1253L71.6532 42.9843L71.3724 42.7417L71.0859 42.691L70.85 42.5725L71.0578 42.3018L70.968 42.048L71.7655 41.8393L72.827 41.2753L73.456 40.6661L72.7652 39.978L71.6532 39.8427L70.7152 40.2431L70.1648 40.057L70.9006 39.5437L70.8444 39.1151L71.6251 38.4495L71.6925 37.8911L71.6195 37.1523L71.7823 36.4416L71.9621 36.0129L72.2148 35.8945L72.6978 35.6689L72.2485 35.5166L71.7093 35.3981L70.9287 34.992L71.3892 34.5013L72.1755 34.5239L72.6473 34.9751L73.046 34.9018L72.8326 34.6085L73.0292 34.1799L72.1643 33.9317L70.9006 33.8414L71.0185 34.3885L70.3502 34.8623L69.6144 35.0202H68.918L67.688 34.4562V33.9035L68.1879 32.7077L68.0756 31.5289L67.66 31.4218L67.4409 31.0552L68.1654 30.0343L69.3392 28.9626L70.5187 27.9079L72.1923 27.4905L73.0067 27.2536L73.7705 26.8983L76.4607 25.9338L76.9775 26.0917L77.1965 26.2666L77.6402 26.0861L77.7076 25.7138L77.1796 25.6462L76.7528 25.4093L77.219 25.1329L78.0558 24.9637L78.2299 25.257L78.5556 25.1893L78.9039 25.116L79.0049 24.8114L79.4093 24.0331L79.6958 23.6834L80.1395 23.4295L80.482 23.5818L81.4256 22.7358L81.2122 22.4425L80.8696 22.5327L81.083 22.2507L81.6783 22.1492L82.3579 21.6472L83.8069 21.1453L83.3071 21.0155L82.8241 20.9309L82.8521 20.5643L82.1052 20.2992L82.5432 19.8875L83.2284 19.6901L83.8687 19.7183L84.3742 19.7295V19.4193L83.6777 19.3686L84.1158 19.1599L84.7673 19.1768L85.0537 19.1542L84.9583 18.782L85.6435 18.5733L85.3233 18.4943L85.7333 17.936L85.7895 17.6539L85.7502 17.2648L86.7892 16.2721L87.334 15.5106L88.2157 15.3471L88.7437 14.8225C88.7437 14.8225 88.9402 14.3544 88.9515 14.2811C88.9571 14.2077 89.4457 13.8637 89.4682 13.8468L90.7375 13.4745L91.3553 12.9274L93.3322 12.386L93.7366 12.6849L94.8992 12.4029L96.2022 11.5286L97.1457 11.3933L97.9095 11.0267L98.3251 10.8236L97.8983 10.677L98.0219 10.4626L99.0721 10.1806L99.117 9.96065L99.8359 9.68427L101.1 9.52635L101.88 9.36842L102.622 9.18793L102.56 8.889L103.301 8.53366L104.132 8.04296L103.975 7.82299L103.694 7.60302L104.717 7.22513L105.924 6.6047L107.446 5.7361L108.339 5.57254L109.339 5.29616L109.889 4.65882L111.821 3.77894L112.647 3.85226L115.14 2.57193L114.888 2.36324L115.135 2.08687L116.05 2.0643L115.921 1.73717C115.91 1.70333 117.32 1.03214 117.421 0.981378C118.179 0.603482 118.836 -0.0620671 119.707 0.0450975C121.122 0.219945 122.52 0.496317 123.891 0.874213C124.031 0.913695 124.183 0.953177 124.306 1.0265C124.902 1.52848 124.497 2.05866 124.795 2.23351C124.885 2.28427 125.031 2.30684 125.284 2.27863C126.092 2.27863 126.806 2.29555 127.474 2.67909L127.496 2.65089Z",
    fill: "#1D244A"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.511 6.33817C106.511 5.60032 106.254 5.08048 105.845 4.83453L110.548 7.63498C110.958 7.88093 111.214 8.40077 111.214 9.13861C111.214 10.6255 110.193 12.4421 108.931 13.1856L104.228 10.3851C105.49 9.64169 106.517 7.82503 106.511 6.33817Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.594 10.5472C103.01 10.7932 103.589 10.7596 104.228 10.3851L108.931 13.1856C108.292 13.5601 107.713 13.5992 107.298 13.3477C105.888 12.5092 104.004 11.3913 102.594 10.5472Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.845 4.83455L110.548 7.635C110.133 7.38905 109.554 7.42259 108.92 7.7971L104.217 4.99665C104.85 4.62214 105.429 4.58301 105.845 4.83455Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.298 13.3477L102.594 10.5472C102.185 10.3013 101.928 9.78144 101.928 9.0436C101.928 7.55114 102.944 5.74566 104.211 4.99664L108.915 7.79709C107.647 8.54611 106.626 10.3516 106.631 11.844C106.631 12.5819 106.882 13.1017 107.298 13.3477Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.92 7.79706C110.182 7.05363 111.214 7.64614 111.22 9.13859C111.22 10.6255 110.198 12.4421 108.936 13.1855C107.669 13.9346 106.637 13.3309 106.637 11.844C106.637 10.3516 107.653 8.54608 108.92 7.79706Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.789 1.35774L112.492 4.15819C111.558 3.59922 110.264 3.67747 108.833 4.52152L104.129 1.72107C105.555 0.877027 106.855 0.798771 107.789 1.35774Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.876 21L104.173 18.1995C103.911 17.9983 99 14.1638 99 10.8155C98.9891 7.47289 101.283 3.40357 104.129 1.72107L108.833 4.52152C105.987 6.20402 103.692 10.2733 103.703 13.616C103.703 16.9642 108.614 20.7988 108.871 21H108.876Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.832 4.52152C111.673 2.84461 113.989 4.19173 113.994 7.53997C114.005 10.877 109.127 20.4969 108.871 21C108.614 20.7988 103.703 16.9642 103.703 13.616C103.692 10.2789 105.986 6.20402 108.832 4.52152ZM108.931 13.1856C110.193 12.4421 111.22 10.6255 111.214 9.13863C111.214 7.64617 110.176 7.05366 108.914 7.79709C107.647 8.54611 106.626 10.3516 106.631 11.844C106.631 13.3309 107.663 13.9346 108.931 13.1856Z",
    fill: "#F7CE6C"
  }))), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M123.503 56.0696L123.492 58.7939L122.616 59.4256L122.627 56.7013L123.503 56.0696Z",
    fill: "#050823"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M122.627 56.7013L122.616 59.4256L121.268 59.3015L121.274 56.5716L122.627 56.7013Z",
    fill: "#050823"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M163.57 42.9053L163.564 46.4981L162.11 45.4434L162.121 41.8562L163.57 42.9053Z",
    fill: "#050823"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M165.923 44.4225L165.918 48.0097L163.564 46.4981L163.57 42.9053L165.923 44.4225Z",
    fill: "#050823"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M167.092 46.1146L167.08 49.7018L165.918 48.0097L165.923 44.4225L167.092 46.1146Z",
    fill: "#050823"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M153.669 48.9855L153.657 52.5727L152.849 50.9878L152.86 47.4006L153.669 48.9855Z",
    fill: "#050823"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M154.387 50.4745L154.376 54.0673L153.657 52.5727L153.668 48.9855L154.387 50.4745Z",
    fill: "#050823"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M152.113 57.5192L152.102 61.112L150.4 60.0065L150.411 56.4137L152.113 57.5192Z",
    fill: "#050823"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M190.691 56.6055L190.68 60.1983L187.973 61.8847L187.984 58.2975L190.691 56.6055Z",
    fill: "#050823"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M177.847 61.2361L177.836 64.8289L174.808 63.0071L174.814 59.4143L177.847 61.2361Z",
    fill: "#050823"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M182.014 60.0234L182.003 63.6106L177.836 64.8289L177.847 61.2361L182.014 60.0234Z",
    fill: "#050823"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M183.783 61.5012L183.772 65.0884L182.003 63.6106L182.014 60.0234L183.783 61.5012Z",
    fill: "#050823"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M185.828 60.8018L185.822 64.389L183.772 65.0883L183.783 61.5011L185.828 60.8018Z",
    fill: "#050823"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M174.814 59.4143L174.808 63.0071L168.479 65.6637L168.49 62.0709L174.814 59.4143Z",
    fill: "#050823"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M187.243 62.6236L187.232 66.2107L185.822 64.389L185.828 60.8018L187.243 62.6236Z",
    fill: "#050823"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M191.023 63.7516L191.011 67.3388L187.232 66.2108L187.243 62.6236L191.023 63.7516Z",
    fill: "#050823"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M192 62.3528L191.989 65.9457L191.011 67.3388L191.023 63.7516L192 62.3528Z",
    fill: "#050823"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M148.816 64.451L148.81 68.0382L148.142 66.4871L148.153 62.8943L148.816 64.451Z",
    fill: "#050823"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M168.49 62.0709L168.479 65.6637L168.147 68.5571L168.159 64.9643L168.49 62.0709Z",
    fill: "#050823"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M152.208 65.9457L152.203 69.5328L148.811 68.0382L148.816 64.451L152.208 65.9457Z",
    fill: "#050823"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M168.159 64.9643L168.148 68.5571L165.059 70.0236L165.07 66.4308L168.159 64.9643Z",
    fill: "#050823"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M157.561 68.2807L157.549 71.8736L152.203 69.5329L152.208 65.9457L157.561 68.2807Z",
    fill: "#050823"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M165.07 66.4307L165.058 70.0236L161.891 73.2723L161.896 69.6795L165.07 66.4307Z",
    fill: "#050823"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M184.485 44.5297L188.703 47.3272L188.861 50.1474L190.691 56.6054L187.984 58.2975L190.675 58.6416L191.832 59.9275L192 62.3528L191.023 63.7516L187.243 62.6236L185.828 60.8018L183.783 61.5012L182.014 60.0234L177.847 61.2361L174.814 59.4143L168.49 62.0708L168.159 64.9643L165.07 66.4307L161.896 69.6795L159.319 70.3789L157.476 70.2266L157.561 68.2807L152.208 65.9457L148.816 64.451L148.153 62.8943L149.372 60.3393L152.113 57.5192L150.411 56.4137L150.647 54.276L151.377 51.3769L154.387 50.4745L153.669 48.9855L152.86 47.4006L154.365 46.2782L156.572 45.6577L157.729 44.7384L158.729 44.3943L160.206 44.885L161.054 45.9341L161.728 47.0114L164.559 46.5996L167.092 46.1146L165.923 44.4225L163.57 42.9053L162.121 41.8562L162.127 40.8692L162.846 40.4518L165.805 41.7942L167.137 41.8224L169.647 42.0198L173.629 43.4862L176.701 43.0294L179.947 44.1236L184.485 44.5297Z",
    fill: "#1D244A"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M159.318 70.3789L159.307 73.9661L157.465 73.8138L157.476 70.2266L159.318 70.3789Z",
    fill: "#050823"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M161.897 69.6795L161.891 73.2723L159.307 73.9661L159.319 70.3789L161.897 69.6795Z",
    fill: "#050823"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0427 6.88666L65.0315 10.5528L63.9812 11.9234L63.9924 8.25724L65.0427 6.88666Z",
    fill: "#050823"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9925 8.25726L63.9813 11.9234L62.229 13.4858L62.2346 9.81961L63.9925 8.25726Z",
    fill: "#050823"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2344 9.81964L62.2288 13.4858L61.9648 14.4334L61.9761 10.7672L62.2344 9.81964Z",
    fill: "#050823"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2282 11.1959L64.217 14.862L63.1611 15.8209L63.1724 12.1547L64.2282 11.1959Z",
    fill: "#050823"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2056 13.8862L65.1944 17.5524L63.5713 18.562L63.5825 14.8958L65.2056 13.8862Z",
    fill: "#050823"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0882 18.3026L44.077 21.9687L43.7456 21.2524L43.7568 17.5862L44.0882 18.3026Z",
    fill: "#050823"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2449 16.8755L65.2337 20.5417L63.6387 23.3844L63.6499 19.7239L65.2449 16.8755Z",
    fill: "#050823"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7405 19.7859L41.7293 23.4521L41.4878 22.9614L41.499 19.2952L41.7405 19.7859Z",
    fill: "#050823"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6498 19.7239L63.6385 23.3844L61.8525 24.896L61.8638 21.2298L63.6498 19.7239Z",
    fill: "#050823"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M61.864 21.2298L61.8527 24.896L59.6287 26.4075L59.6399 22.747L61.864 21.2298Z",
    fill: "#050823"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8139 24.3602L59.8027 28.0263L57.7021 29.9722L57.7078 26.3061L59.8139 24.3602Z",
    fill: "#050823"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6249 26.7968L33.6136 30.4629L33.1138 29.521L33.125 25.8549L33.6249 26.7968Z",
    fill: "#050823"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7077 26.306L57.7021 29.9722L55.5566 31.7827L55.5679 28.1222L57.7077 26.306Z",
    fill: "#050823"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4879 28.173L41.4767 31.8391L39.7693 30.7111L39.7749 27.0449L41.4879 28.173Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 27,
    width: 5,
    height: 6
  }, _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7748 27.0449L39.7636 30.7111C39.7018 30.728 38.5954 31.1003 38.4606 31.1905C38.3258 31.2807 35.3828 32.3862 35.2256 32.4426L35.2368 28.7765C35.3941 28.7201 38.337 27.6146 38.4718 27.5243C38.6066 27.4397 39.713 27.0675 39.7748 27.0449Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7748 27.0449L39.7636 30.7111C39.7018 30.728 38.5954 31.1003 38.4606 31.1905C38.3258 31.2807 35.3828 32.3862 35.2256 32.4426L35.2368 28.7765C35.3941 28.7201 38.337 27.6146 38.4718 27.5243C38.6066 27.4397 39.713 27.0675 39.7748 27.0449Z",
    fill: "#050823"
  }))), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0435 29.1826L43.0323 32.8487L42.7908 32.6908L42.802 29.0247L43.0435 29.1826Z",
    fill: "#050823"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8019 29.0247L42.7907 32.6908L41.9033 33.221L41.9146 29.5548L42.8019 29.0247Z",
    fill: "#050823"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9146 29.5548L41.9034 33.221L41.4766 31.8391L41.4878 28.173L41.9146 29.5548Z",
    fill: "#050823"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2327 30.1414L30.2214 33.8076V33.2548L30.2327 29.5887V30.1414Z",
    fill: "#050823"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9628 30.1019L30.9516 33.7681L30.2214 33.8076L30.2327 30.1414L30.9628 30.1019Z",
    fill: "#050823"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2423 28.7765L35.2311 32.4426L33.2205 33.8809L33.2261 30.2148L35.2423 28.7765Z",
    fill: "#050823"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5318 30.305L44.5206 33.9655L42.8076 34.1629L42.8188 30.4968L44.5318 30.305Z",
    fill: "#050823"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3841 30.7336L31.3729 34.3998L30.9517 33.7681L30.9629 30.1019L31.3841 30.7336Z",
    fill: "#050823"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2262 30.2147L33.2206 33.8809L31.3728 34.3998L31.384 30.7336L33.2262 30.2147Z",
    fill: "#050823"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0653 32.8093L45.0541 36.4698L44.5037 35.0879L44.5149 31.4218L45.0653 32.8093Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 33,
    width: 2,
    height: 5
  }, _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3315 33.1025L57.3203 36.7687C57.2754 36.8025 56.3768 37.4004 56.1633 37.4455L56.1746 33.7794C56.3824 33.7342 57.281 33.1307 57.3315 33.1025Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3315 33.1025L57.3203 36.7687C57.2754 36.8025 56.3768 37.4004 56.1633 37.4455L56.1746 33.7794C56.3824 33.7342 57.281 33.1307 57.3315 33.1025Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 33,
    width: 3,
    height: 5
  }, _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1744 33.785L56.1632 37.4512C55.9497 37.502 54.5513 37.5076 54.4839 37.5076L54.4951 33.8414C54.5625 33.8414 55.961 33.8414 56.1744 33.785Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1744 33.785L56.1632 37.4512C55.9497 37.502 54.5513 37.5076 54.4839 37.5076L54.4951 33.8414C54.5625 33.8414 55.961 33.8414 56.1744 33.785Z",
    fill: "#050823"
  }))), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6425 34.2024L50.6312 37.8629L45.0542 36.4698L45.0654 32.8093L50.6425 34.2024Z",
    fill: "#050823"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4952 33.8358L54.484 37.5019L52.7822 38.2182L52.7935 34.5521L54.4952 33.8358Z",
    fill: "#050823"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0427 6.88669L63.9925 8.25163L62.2345 9.81961L61.9762 10.7672L64.2283 11.1902L63.1725 12.149L64.5316 12.9048L65.2112 13.8806L63.5881 14.8958L63.6948 16.0239L64.3463 16.1592L65.2505 16.8699L63.6555 19.7182L61.8695 21.2298L59.6454 22.7414L59.8195 24.3545L57.7134 26.3004L55.568 28.1109L56.3823 29.1487L56.68 30.6885L57.3315 33.0969C57.2866 33.1307 56.3879 33.7286 56.1745 33.7737C55.9611 33.8245 54.5626 33.8301 54.4952 33.8301L52.7935 34.5408L50.6424 34.1911L45.0654 32.798L44.515 31.4161L44.5319 30.2937L42.8133 30.4855L43.0379 29.1713L42.7964 29.019L41.909 29.5492L41.4822 28.1673L39.7748 27.0336C39.713 27.0506 38.6066 27.4228 38.4718 27.5131C38.337 27.6033 35.3941 28.7088 35.2368 28.7652L33.2262 30.2091L31.384 30.728L30.9628 30.0906L30.2327 30.1301V29.5774L32.4343 27.8064L33.6249 26.7855L33.1251 25.8435L35.2031 23.8638L38.0394 22.1041L40.2691 20.0059L41.7405 19.7746L41.499 19.2839L42.4931 18.6974L44.0882 18.2913L43.7568 17.5749L47.4074 15.4317L51.4849 13.0402L53.9561 11.6414L58.0897 9.75757L59.4769 9.41352L61.0832 8.97922L62.3019 7.67632L64.5316 6.85284L65.0483 6.87541L65.0427 6.88669Z",
    fill: "#1D244A"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7934 34.5521L52.7822 38.2182L50.6311 37.8629L50.6423 34.2024L52.7934 34.5521Z",
    fill: "#050823"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6712 40.3334L48.6599 43.2776L48.4915 43.8303L48.5027 40.8805L48.6712 40.3334Z",
    fill: "#050823"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7122 40.9482L42.701 43.8924L42.4482 43.3397L42.4539 40.3954L42.7122 40.9482Z",
    fill: "#050823"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2492 41.0836L51.2435 44.0278L50.5359 44.541L50.5471 41.5968L51.2492 41.0836Z",
    fill: "#050823"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3448 42.2341L50.3335 45.1783L48.8115 44.6256L48.8171 41.6814L50.3448 42.2341Z",
    fill: "#050823"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7379 41.8958L50.7323 44.84L50.3335 45.1784L50.3447 42.2342L50.7379 41.8958Z",
    fill: "#050823"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8172 41.6814L48.8116 44.6256L48.6375 45.1783L48.6487 42.2341L48.8172 41.6814Z",
    fill: "#050823"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5712 42.2567L44.56 45.2009L43.6558 45.0035L43.667 42.0593L44.5712 42.2567Z",
    fill: "#050823"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5765 42.3469L45.5652 45.2911L45.4023 45.5506L45.408 42.6064L45.5765 42.3469Z",
    fill: "#050823"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2169 42.6515L46.2113 45.5957L45.5654 45.2911L45.5767 42.3469L46.2169 42.6515Z",
    fill: "#050823"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4257 42.7925L42.4145 45.7367L41.5159 45.6578L41.5215 42.7136L42.4257 42.7925Z",
    fill: "#050823"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M43.667 42.0593L43.6558 45.0035L43.6333 45.8326L43.6389 42.8884L43.667 42.0593Z",
    fill: "#050823"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0717 42.9505L43.0604 45.8947L42.4146 45.7367L42.4258 42.7925L43.0717 42.9505Z",
    fill: "#050823"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M43.639 42.8884L43.6334 45.8326L43.0605 45.8947L43.0718 42.9505L43.639 42.8884Z",
    fill: "#050823"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M45.408 42.6064L45.4024 45.5506L45.2002 45.9905L45.2058 43.0463L45.408 42.6064Z",
    fill: "#050823"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5216 42.7136L41.516 45.6578L41.0442 46.0639L41.0498 43.1197L41.5216 42.7136Z",
    fill: "#050823"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0498 43.1196L41.0442 46.0638L40.9993 46.0977L41.0049 43.1535L41.0498 43.1196Z",
    fill: "#050823"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0049 43.1535L40.9993 46.0977L40.6848 46.1485L40.696 43.2043L41.0049 43.1535Z",
    fill: "#050823"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1793 43.2832L40.1681 46.2275L39.73 46.1767L39.7356 43.2325L40.1793 43.2832Z",
    fill: "#050823"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6959 43.2043L40.6847 46.1485L40.168 46.2275L40.1792 43.2832L40.6959 43.2043Z",
    fill: "#050823"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6458 43.2832L39.6402 46.2274L39.365 45.7142L39.3762 42.77L39.6458 43.2832Z",
    fill: "#050823"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7356 43.2325L39.73 46.1767L39.6401 46.2275L39.6457 43.2832L39.7356 43.2325Z",
    fill: "#050823"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9795 43.4355L50.9683 46.3797L49.5137 46.4756L49.5249 43.5314L50.9795 43.4355Z",
    fill: "#050823"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M45.206 43.0463L45.2004 45.9905L44.3523 46.5771L44.3635 43.6329L45.206 43.0463Z",
    fill: "#050823"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3634 43.6329L44.3522 46.5771L43.6277 46.2218L43.6389 43.2776L44.3634 43.6329Z",
    fill: "#1D244A"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8069 43.6724L45.7957 46.6166L45.7339 46.2444L45.7451 43.3002L45.8069 43.6724Z",
    fill: "#050823"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5359 44.0616L50.5247 47.0058L49.1543 47.1299L49.1655 44.1857L50.5359 44.0616Z",
    fill: "#050823"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1155 44.1631L47.1098 47.1073L45.9304 47.237L45.9417 44.2872L47.1155 44.1631Z",
    fill: "#050823"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1654 44.1857L49.1541 47.1299L48.761 47.4627L48.7722 44.5184L49.1654 44.1857Z",
    fill: "#050823"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7722 44.5184L48.7609 47.4626L47.7275 47.5021L47.7332 44.5579L48.7722 44.5184Z",
    fill: "#050823"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7333 44.5579L47.7277 47.5021L47.1099 47.1073L47.1155 44.1631L47.7333 44.5579Z",
    fill: "#050823"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9415 44.2872L45.9303 47.237L45.335 47.519L45.3462 44.5748L45.9415 44.2872Z",
    fill: "#050823"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0162 43.7288L41.0105 46.673L40.7915 47.5529L40.8027 44.6087L41.0162 43.7288Z",
    fill: "#050823"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M44.807 45.0373L44.7958 47.9815L44.1274 47.316L44.1387 44.3718L44.807 45.0373Z",
    fill: "#050823"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3463 44.5748L45.3351 47.519L44.7959 47.9815L44.8071 45.0373L45.3463 44.5748Z",
    fill: "#050823"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9571 40.6605L51.2492 41.0835L50.5471 41.5968L50.7381 41.8957L50.3449 42.2341L48.8173 41.6814L48.6488 42.2341L49.5755 42.3977L50.4123 42.7136L50.9796 43.4355L49.5249 43.5314L50.4685 43.7344L50.5359 44.0616L49.1655 44.1857L48.7723 44.5184L47.7333 44.5579L47.1155 44.1631L45.9417 44.2872L45.3464 44.5748L44.8072 45.0373L44.1389 44.3718L44.1557 44.3041L45.1891 43.9375L45.8069 43.6724L45.7451 43.3001L46.2169 42.6515L45.5767 42.3469L45.4082 42.6064L45.206 43.0463L44.3635 43.6329L43.639 43.2776L44.0434 42.6064L44.5713 42.2567L43.6671 42.0593L43.639 42.8884L43.0718 42.9505L42.4259 42.7925L41.5217 42.7136L41.0499 43.1197L41.005 43.1535L40.6961 43.2043L40.1794 43.2832L39.7357 43.2325L39.6458 43.2832L39.3762 42.77L39.3875 42.2511L39.5503 41.7942L40.2299 41.4107L40.8646 41.3261L40.9713 41.546L42.7123 40.9482L42.454 40.3954L43.6278 40.0062L44.2175 40.1642L45.2734 40.2149L46.0709 39.9216L46.874 40.0796L47.5143 39.713L48.6713 40.3334L48.5028 40.8805L49.3284 40.7564L50.9571 40.6605Z",
    fill: "#1D244A"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9621 44.4395L33.9565 47.3837L32.9399 48.0943L32.9456 45.1501L33.9621 44.4395Z",
    fill: "#050823"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2977 45.2235L38.2921 48.1677L37.7024 47.6093L37.7136 44.6651L38.2977 45.2235Z",
    fill: "#050823"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8071 45.0374L44.7958 47.9816L43.813 48.8671L43.8186 45.9172L44.8071 45.0374Z",
    fill: "#050823"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4902 45.5168L33.4846 48.461L33.4453 49.0307L33.4509 46.0865L33.4902 45.5168Z",
    fill: "#050823"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8187 45.9172L43.813 48.8671L43.5435 49.4649L43.5491 46.5207L43.8187 45.9172Z",
    fill: "#050823"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4217 46.7745L37.4105 49.7187L37.1521 48.9911L37.1633 46.0469L37.4217 46.7745Z",
    fill: "#050823"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M34.546 46.1485L34.5347 49.0927L34.1304 49.888L34.136 46.9438L34.546 46.1485Z",
    fill: "#050823"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1361 46.9437L34.1305 49.8879L33.4172 50.294L33.4285 47.3498L34.1361 46.9437Z",
    fill: "#050823"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4285 47.3499L33.4173 50.2941L32.0525 50.2659L32.0581 47.3217L33.4285 47.3499Z",
    fill: "#050823"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M32.058 47.3217L32.0523 50.2659L31.5581 50.9822L31.5637 48.038L32.058 47.3217Z",
    fill: "#050823"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6443 48.0549L25.6387 50.9991L25.5713 50.5986L25.5769 47.6544L25.6443 48.0549Z",
    fill: "#050823"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8356 47.3837L43.8244 50.3279L41.6902 51.2078L41.7014 48.2635L43.8356 47.3837Z",
    fill: "#050823"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7013 48.2636L41.6901 51.2078L41.134 50.4351L41.1453 47.4908L41.7013 48.2636Z",
    fill: "#050823"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5638 48.038L31.5581 50.9822L31.4065 51.2021L31.4121 48.2579L31.5638 48.038Z",
    fill: "#050823"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1452 47.4908L41.134 50.4351L40.2634 51.377L40.269 48.4328L41.1452 47.4908Z",
    fill: "#050823"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7054 48.4158L27.6942 51.3657L27.0989 51.1965L27.1101 48.2523L27.7054 48.4158Z",
    fill: "#050823"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4123 48.2579L31.4067 51.2021L30.5305 51.58L30.5418 48.6358L31.4123 48.2579Z",
    fill: "#050823"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1102 48.2523L27.0989 51.1965L26.8462 51.58L26.8518 48.6358L27.1102 48.2523Z",
    fill: "#050823"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5417 48.6358L30.5305 51.58L29.5981 51.9805L29.6094 49.0306L30.5417 48.6358Z",
    fill: "#050823"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8517 48.6358L26.846 51.58L26.3855 52.0312L26.3911 49.087L26.8517 48.6358Z",
    fill: "#050823"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M40.269 48.4327L40.2634 51.3769L39.1345 52.2061L39.1458 49.2619L40.269 48.4327Z",
    fill: "#050823"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6094 49.0306L29.5981 51.9805L28.4749 52.2117L28.4805 49.2675L29.6094 49.0306Z",
    fill: "#050823"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4804 49.2675L28.4748 52.2117L27.5088 52.0087L27.5144 49.0645L28.4804 49.2675Z",
    fill: "#050823"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5766 49.4706L45.5653 52.4204L44.8577 51.3149L44.8689 48.3707L45.5766 49.4706Z",
    fill: "#050823"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M25.532 49.3239L25.5207 52.2681L24.448 52.3584L24.4592 49.4142L25.532 49.3239Z",
    fill: "#050823"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9621 44.4395L32.9455 45.1501L33.4903 45.5167L33.451 46.0864L34.5462 46.1484L34.1362 46.9437L33.4285 47.3498L32.0581 47.3216L31.5639 48.0379L31.4123 48.2579L30.5417 48.6358L29.6094 49.0306L28.4805 49.2675L27.5145 49.0645L27.7055 48.4158L27.1101 48.2523L26.8518 48.6358L26.3912 49.087L25.7847 49.51L25.5319 49.3239L24.4592 49.4141L24.8074 48.743L25.6443 48.0548L25.5769 47.6544L26.043 47.1693L27.5033 46.6504L28.4244 46.5827L28.6265 46.6899L29.6375 46.5263L31.2269 46.0356L32.4176 45.1727L32.8613 44.462L33.9621 44.4395Z",
    fill: "#1D244A"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3912 49.087L26.3856 52.0312L25.7734 52.4543L25.7847 49.5101L26.3912 49.087Z",
    fill: "#050823"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7847 49.51L25.7735 52.4543L25.5208 52.2681L25.532 49.3239L25.7847 49.51Z",
    fill: "#050823"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1458 49.2619L39.1345 52.2061L37.781 53.1255L37.7866 50.1813L39.1458 49.2619Z",
    fill: "#050823"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8518 50.8693L45.8462 53.8192L44.5544 53.1085L44.5657 50.1643L45.8518 50.8693Z",
    fill: "#050823"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7866 50.1813L37.781 53.1255L36.6409 54.6653L36.6465 51.7211L37.7866 50.1813Z",
    fill: "#050823"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0227 50.9314L57.0115 53.8756L55.7983 54.7724L55.8096 51.8282L57.0227 50.9314Z",
    fill: "#050823"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8096 51.8282L55.7984 54.7724L55.54 55.5113L55.5457 52.5671L55.8096 51.8282Z",
    fill: "#050823"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5388 52.3414L59.5332 55.2856L58.4324 55.5846L58.4436 52.6404L59.5388 52.3414Z",
    fill: "#050823"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8414 52.1609L61.8301 55.1052L61.5044 55.703L61.5156 52.7588L61.8414 52.1609Z",
    fill: "#050823"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5158 52.7588L61.5045 55.703L59.5332 55.2856L59.5388 52.3414L61.5158 52.7588Z",
    fill: "#050823"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5456 52.5671L55.5399 55.5113L54.8267 55.9174L54.8379 52.9732L55.5456 52.5671Z",
    fill: "#050823"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4436 52.6404L58.4323 55.5846L57.3933 56.2445L57.3989 53.3003L58.4436 52.6404Z",
    fill: "#050823"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M57.399 53.3003L57.3934 56.2445L57.0002 55.4097L57.0115 52.4655L57.399 53.3003Z",
    fill: "#050823"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M54.838 52.9731L54.8267 55.9174L54.5347 56.9834L54.5403 54.0335L54.838 52.9731Z",
    fill: "#050823"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8351 54.0617L44.8239 57.0059L44.0825 55.6184L44.0881 52.6686L44.8351 54.0617Z",
    fill: "#050823"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7026 54.3043L56.6914 57.2485L54.4167 59.0533L54.4224 56.1091L56.7026 54.3043Z",
    fill: "#050823"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4222 56.1091L54.4166 59.0533L53.8044 59.1267L53.8101 56.1825L54.4222 56.1091Z",
    fill: "#050823"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8101 56.1825L53.8045 59.1267L53.3384 58.0268L53.344 55.0826L53.8101 56.1825Z",
    fill: "#050823"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3441 55.0826L53.3384 58.0268L51.7378 59.8881L51.749 56.9439L53.3441 55.0826Z",
    fill: "#050823"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15643 57.5023L3.15081 60.4465L2.2522 59.5384L2.26343 56.5942L3.15643 57.5023Z",
    fill: "#050823"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M51.749 56.9439L51.7378 59.8881L51.676 61.1064L51.6816 58.1622L51.749 56.9439Z",
    fill: "#050823"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6701 59.1548L13.6588 62.0991L11.6257 61.8227L11.6313 58.8785L13.6701 59.1548Z",
    fill: "#050823"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6815 58.1622L51.6758 61.1064L50.1145 62.6574L50.1257 59.7076L51.6815 58.1622Z",
    fill: "#050823"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6313 58.8785L11.6257 61.8227L9.20508 62.6123L9.21631 59.6681L11.6313 58.8785Z",
    fill: "#050823"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0858 60.4352L14.0745 63.3794L13.6589 62.0991L13.6702 59.1548L14.0858 60.4352Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 60,
    width: 1,
    height: 4
  }, _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M0 63.3851V60.4409C0 60.4409 0.0112327 60.4578 0.0112327 60.4691V63.4133C0.0112327 63.4133 0 63.3963 0 63.3851Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0112327 60.4634V63.4076C0.0112327 63.4076 0 63.3907 0 63.3794V60.4352C0 60.4352 0.0112327 60.4522 0.0112327 60.4634Z",
    fill: "#050823"
  }))), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21633 59.6682L9.20509 62.6124L6.6272 63.5092L6.63843 60.5649L9.21633 59.6682Z",
    fill: "#1D244A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 60,
    width: 1,
    height: 4
  }, _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M0.129176 60.6608V63.605C0.067396 63.5486 0.00561633 63.4922 0 63.4133V60.4691C0.016849 60.548 0.0786287 60.6044 0.129176 60.6608Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.129176 60.6608V63.605C0.067396 63.5486 0.00561633 63.4922 0 63.4133V60.4691C0.016849 60.548 0.0786287 60.6044 0.129176 60.6608Z",
    fill: "#050823"
  }))), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63841 60.5649L6.62718 63.5091L5.48145 63.9435L5.49268 60.9992L6.63841 60.5649Z",
    fill: "#050823"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0068 61.1064L15.0012 64.0562L14.0745 63.3794L14.0857 60.4352L15.0068 61.1064Z",
    fill: "#050823"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2592 61.2813L16.2536 64.2311L15.3213 63.9209L15.3269 60.9767L16.2592 61.2813Z",
    fill: "#050823"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1258 59.7076L50.1146 62.6575L49.7776 64.5244L49.7888 61.5802L50.1258 59.7076Z",
    fill: "#050823"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1073 62.1837L17.1017 65.1279L16.2537 64.2311L16.2593 61.2812L17.1073 62.1837Z",
    fill: "#050823"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49269 60.9992L5.48146 63.9434L5.41968 65.1448L5.43091 62.2006L5.49269 60.9992Z",
    fill: "#050823"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8942 62.2683L15.8829 65.2182L15.2539 65.393L15.2651 62.4488L15.8942 62.2683Z",
    fill: "#050823"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2653 62.4488L15.2541 65.393L14.2825 64.7725L14.2881 61.8227L15.2653 62.4488Z",
    fill: "#050823"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7889 61.5802L49.7777 64.5244L49.3396 65.8668L49.3452 62.9226L49.7889 61.5802Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 60,
    width: 6,
    height: 7
  }, _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43097 62.2006V65.1448C4.87495 65.3986 3.90333 66.0641 3.34169 66.1093C3.08334 66.1318 2.79691 66.0303 2.51048 65.8667C1.59501 65.3366 0.629005 64.0957 0.123535 63.5994V60.6552C0.634622 61.1515 1.60625 62.3923 2.51609 62.9225C2.80253 63.0917 3.08334 63.1876 3.34731 63.1651C3.90894 63.1199 4.88057 62.4487 5.43097 62.2006Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.43097 62.2006V65.1448C4.87495 65.3986 3.90333 66.0641 3.34169 66.1093C3.08334 66.1318 2.79691 66.0303 2.51048 65.8667C1.59501 65.3366 0.629005 64.0957 0.123535 63.5994V60.6552C0.634622 61.1515 1.60625 62.3923 2.51609 62.9225C2.80253 63.0917 3.08334 63.1876 3.34731 63.1651C3.90894 63.1199 4.88057 62.4487 5.43097 62.2006Z",
    fill: "#050823"
  }))), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M17.77 63.3569L17.7588 66.3011L16.6187 65.6017L16.6243 62.6575L17.77 63.3569Z",
    fill: "#050823"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6855 63.7404L18.6743 66.6846L17.7588 66.3011L17.77 63.3569L18.6855 63.7404Z",
    fill: "#050823"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3452 62.9225L49.3395 65.8668L48.4016 66.9835L48.4128 64.0337L49.3452 62.9225Z",
    fill: "#050823"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7417 65.5509L18.7361 68.4951L18.6743 66.6846L18.6855 63.7404L18.7417 65.5509Z",
    fill: "#050823"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4127 64.0337L48.4015 66.9835L47.6489 68.8392L47.6545 65.895L48.4127 64.0337Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 66,
    width: 5,
    height: 5
  }, _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8348 67.0343V69.9785C46.7224 69.9785 44.7455 69.9672 44.6332 69.9052C44.5264 69.8431 42.9932 70.4748 42.9089 70.5087V67.5645C42.9988 67.5306 44.5321 66.8989 44.6388 66.9609C44.7511 67.023 46.728 67.0343 46.8348 67.0343Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8348 67.0343V69.9785C46.7224 69.9785 44.7455 69.9672 44.6332 69.9052C44.5264 69.8431 42.9932 70.4748 42.9089 70.5087V67.5645C42.9988 67.5306 44.5321 66.8989 44.6388 66.9609C44.7511 67.023 46.728 67.0343 46.8348 67.0343Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 67,
    width: 2,
    height: 5
  }, _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2166 68.1398V71.084C47.0088 70.8922 46.8347 70.0236 46.8235 69.9785V67.0343C46.8403 67.0794 47.0144 67.9424 47.2166 68.1398Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2166 68.1398V71.084C47.0088 70.8922 46.8347 70.0236 46.8235 69.9785V67.0343C46.8403 67.0794 47.0144 67.9424 47.2166 68.1398Z",
    fill: "#050823"
  }))), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M42.92 67.5645L42.9087 70.5087L42.7122 71.225L42.7178 68.2808L42.92 67.5645Z",
    fill: "#050823"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9964 68.1398L50.9907 71.084L49.6316 71.3998L49.6372 68.4556L50.9964 68.1398Z",
    fill: "#050823"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6871 68.7376L51.6815 71.6818L50.9907 71.084L50.9963 68.1398L51.6871 68.7376Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 68,
    width: 3,
    height: 4
  }, _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2946 68.7771V71.7213C49.1935 71.6931 47.4187 71.2024 47.2109 71.084V68.1398C47.4244 68.2582 49.1991 68.7489 49.2946 68.7771Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2946 68.7771V71.7213C49.1935 71.6931 47.4187 71.2024 47.2109 71.084V68.1398C47.4244 68.2582 49.1991 68.7489 49.2946 68.7771Z",
    fill: "#050823"
  }))), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6373 68.4556L49.6317 71.3998L49.2834 71.7213L49.2947 68.7771L49.6373 68.4556Z",
    fill: "#050823"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1397 68.4387L41.1341 71.3829L39.4211 71.7383L39.4268 68.7941L41.1397 68.4387Z",
    fill: "#050823"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0046 68.8279L41.9933 71.7721L41.134 71.3829L41.1397 68.4387L42.0046 68.8279Z",
    fill: "#050823"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7179 68.2808L42.7123 71.225L41.9934 71.7721L42.0046 68.8279L42.7179 68.2808Z",
    fill: "#050823"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3051 68.9464L52.2994 71.8906L51.6816 71.6819L51.6873 68.7377L52.3051 68.9464Z",
    fill: "#050823"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4267 68.7941L39.4211 71.7383L38.2249 72.7986L38.2305 69.8544L39.4267 68.7941Z",
    fill: "#050823"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3087 70.5256L20.3031 73.4698L18.4216 71.2306L18.4329 68.2864L20.3087 70.5256Z",
    fill: "#050823"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6618 71.1178L22.6562 74.062L20.303 73.4698L20.3086 70.5256L22.6618 71.1178Z",
    fill: "#050823"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M24.139 71.1573L24.1277 74.1015L22.6562 74.062L22.6619 71.1178L24.139 71.1573Z",
    fill: "#050823"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0712 72.3474L25.0656 75.2916L24.1277 74.1015L24.1389 71.1573L25.0712 72.3474Z",
    fill: "#050823"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9353 72.7761L28.9297 75.7259H27.5032L27.5088 72.7817L28.9353 72.7761Z",
    fill: "#050823"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M26.144 72.7986L26.1384 75.7428L25.0657 75.2916L25.0713 72.3474L26.144 72.7986Z",
    fill: "#050823"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8126 73.3965L44.807 76.3407L44.0713 75.5398L44.0825 72.5956L44.8126 73.3965Z",
    fill: "#050823"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2605 73.9323L31.2549 76.8765L28.9297 75.7259L28.9353 72.7761L31.2605 73.9323Z",
    fill: "#1D244A"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1476 74.3553L33.1364 77.2995L31.2549 76.8765L31.2605 73.9323L33.1476 74.3553Z",
    fill: "#050823"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5707 74.3723L27.5651 77.3165L25.6331 76.4874L25.6387 73.5432L27.5707 74.3723Z",
    fill: "#050823"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6037 74.7671L29.5924 77.7113L27.5649 77.3165L27.5706 74.3723L29.6037 74.7671Z",
    fill: "#050823"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8594 75.4213L57.8538 78.3656L57.5393 77.6323L57.5505 74.6881L57.8594 75.4213Z",
    fill: "#050823"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6417 75.4496L34.6304 78.3938L33.1365 77.2996L33.1477 74.3553L34.6417 75.4496Z",
    fill: "#050823"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9737 75.2521L31.9681 78.202L31.429 78.5122L31.4346 75.568L31.9737 75.2521Z",
    fill: "#050823"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4347 75.568L31.4291 78.5122L29.5925 77.7113L29.6038 74.7671L31.4347 75.568Z",
    fill: "#050823"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5429 76.1433L45.5317 79.0875L43.4424 78.8845L43.448 75.9402L45.5429 76.1433Z",
    fill: "#050823"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6042 76.1828L47.5929 79.127L45.5317 79.0875L45.543 76.1433L47.6042 76.1828Z",
    fill: "#050823"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4911 76.1658L49.4799 79.11L47.5928 79.127L47.604 76.1828L49.4911 76.1658Z",
    fill: "#050823"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M35.456 76.3971L35.4504 79.3413L34.6304 78.3937L34.6416 75.4495L35.456 76.3971Z",
    fill: "#050823"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M43.448 75.9402L43.4424 78.8845L42.1506 79.3808L42.1619 76.4366L43.448 75.9402Z",
    fill: "#050823"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M42.162 76.4366L42.1507 79.3808L37.9834 79.5218L37.989 76.5776L42.162 76.4366Z",
    fill: "#050823"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M37.989 76.5776L37.9834 79.5218L35.4504 79.3413L35.4561 76.3971L37.989 76.5776Z",
    fill: "#050823"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9493 76.572L57.9437 79.5162L57.5112 80.0125L57.5225 77.0683L57.9493 76.572Z",
    fill: "#050823"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8784 77.1021L50.8728 80.0463L49.48 79.11L49.4912 76.1658L50.8784 77.1021Z",
    fill: "#050823"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1415 77.5421L54.1303 80.4863L50.8728 80.0463L50.8784 77.1021L54.1415 77.5421Z",
    fill: "#050823"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1008 77.6041L59.0896 80.554L57.9438 79.5162L57.9495 76.572L59.1008 77.6041Z",
    fill: "#050823"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5225 77.0683L57.5112 80.0125L56.2363 80.9431L56.2476 77.9989L57.5225 77.0683Z",
    fill: "#050823"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2477 77.9989L56.2365 80.9431L54.1304 80.4863L54.1416 77.5421L56.2477 77.9989Z",
    fill: "#050823"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2759 76.6284L94.2647 79.5726L94.1187 81.7215L94.1299 78.7773L94.2759 76.6284Z",
    fill: "#050823"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M59.432 79.0085L59.4263 81.9528L59.0894 80.554L59.1006 77.6041L59.432 79.0085Z",
    fill: "#050823"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1006 83.5489L59.0894 86.4932L58.8423 83.3008L58.8535 80.3566L59.1006 83.5489Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 83,
    width: 1,
    height: 4
  }, _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6848 83.8422V86.7864C97.6848 86.7864 97.6736 86.8146 97.668 86.8203V83.8761C97.668 83.8761 97.6848 83.8591 97.6848 83.8422Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6848 83.8422V86.7864C97.6848 86.7864 97.6736 86.8146 97.668 86.8203V83.8761C97.668 83.8761 97.6848 83.8591 97.6848 83.8422Z",
    fill: "#050823"
  }))), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6167 85.0323L61.6111 87.9765L59.0894 86.4932L59.1006 83.549L61.6167 85.0323Z",
    fill: "#050823"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M64.397 84.4457L64.3914 87.3899L61.6113 87.9765L61.6169 85.0323L64.397 84.4457Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 83,
    width: 3,
    height: 5
  }, _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6738 83.876V86.8202C97.5783 86.9274 95.4722 87.6155 95.3599 87.6494V84.7051C95.4778 84.6713 97.5839 83.9832 97.6738 83.876Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.6738 83.876V86.8202C97.5783 86.9274 95.4722 87.6155 95.3599 87.6494V84.7051C95.4778 84.6713 97.5839 83.9832 97.6738 83.876Z",
    fill: "#050823"
  }))), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3709 84.7052L95.3653 87.6494L93.8376 88.9692L93.8433 86.025L95.3709 84.7052Z",
    fill: "#050823"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1546 88.6816L67.1434 91.6258L64.3914 87.3899L64.397 84.4457L67.1546 88.6816Z",
    fill: "#050823"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4847 89.8547L71.4791 92.7989L67.1433 91.6257L67.1545 88.6815L71.4847 89.8547Z",
    fill: "#050823"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4438 88.8226L76.4326 91.7668L71.479 92.7989L71.4846 89.8547L76.4438 88.8226Z",
    fill: "#050823"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2408 93.4814L79.2352 96.4256L76.4326 91.7668L76.4439 88.8226L79.2408 93.4814Z",
    fill: "#050823"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0225 89.9675L96.0169 92.9117L95.8765 94.4064L95.8821 91.4566L96.0225 89.9675Z",
    fill: "#050823"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8822 91.4565L95.8765 94.4064L94.2085 94.9366L94.2141 91.9867L95.8822 91.4565Z",
    fill: "#050823"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1349 93.6055L96.1293 96.5497L94.1917 97.6721L94.2029 94.7279L96.1349 93.6055Z",
    fill: "#050823"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9132 95.98L85.9019 98.9242L79.2354 96.4256L79.241 93.4814L85.9132 95.98Z",
    fill: "#050823"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6016 95.3032L94.596 98.2474L94.1973 98.9637L94.2029 96.0195L94.6016 95.3032Z",
    fill: "#050823"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4803 97.4916L86.4747 100.436L85.9019 98.9242L85.9131 95.98L86.4803 97.4916Z",
    fill: "#050823"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8539 97.4352L95.8427 100.379L95.1968 101.192L95.208 98.2474L95.8539 97.4352Z",
    fill: "#050823"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3502 98.8735L89.3446 101.818L86.4746 100.436L86.4802 97.4916L89.3502 98.8735Z",
    fill: "#1D244A"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M91.288 100.041L91.2767 102.985L89.3447 101.818L89.3503 98.8735L91.288 100.041Z",
    fill: "#050823"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6341 99.6575L98.6229 102.602L98.2915 103.391L98.2971 100.447L98.6341 99.6575Z",
    fill: "#050823"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8495 100.814L91.8439 103.758L91.2766 102.985L91.2878 100.041L91.8495 100.814Z",
    fill: "#050823"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3711 101.947L95.3654 104.892L91.844 103.758L91.8496 100.814L95.3711 101.947Z",
    fill: "#050823"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M103.857 101.44L103.846 104.384L103.251 105.365L103.256 102.421L103.857 101.44Z",
    fill: "#050823"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 102,
    width: 5,
    height: 4
  }, _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M103.256 102.421V105.365C103.06 105.382 99.5103 105.693 99.4541 105.709V102.765C99.5159 102.748 103.065 102.438 103.256 102.421Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.256 102.421V105.365C103.06 105.382 99.5103 105.693 99.4541 105.709V102.765C99.5159 102.748 103.065 102.438 103.256 102.421Z",
    fill: "#050823"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_883_183857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 101,
    width: 5,
    height: 5
  }, _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4654 102.765V105.709C99.398 105.726 95.5677 104.931 95.3655 104.892V101.947C95.5733 101.993 99.4092 102.782 99.4654 102.765Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4654 102.765V105.709C99.398 105.726 95.5677 104.931 95.3655 104.892V101.947C95.5733 101.993 99.4092 102.782 99.4654 102.765Z",
    fill: "#050823"
  }))), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2361 48.9178L58.2639 49.5946L58.4661 50.8073L60.078 50.7622L60.3812 51.4164L61.8302 52.161L61.5045 52.7588L59.5276 52.3414L58.4268 52.6404L57.3877 53.3003L56.9946 52.4655L57.0058 50.9314L55.7927 51.8338L55.5343 52.5727L54.8211 52.9788L54.5234 54.0448L56.2476 53.7289L56.6857 54.3099L54.4055 56.1148L53.7933 56.1824L53.3271 55.0826L51.7265 56.9495L51.6647 58.1678L50.109 59.7189L49.772 61.5858L49.3339 62.9282L48.396 64.0393L47.6378 65.8949L49.8618 67.7901L50.5695 67.6265L51.3614 67.8126L51.85 68.5177L52.2881 68.9463L51.6703 68.7376L50.9795 68.1398L49.6203 68.4556L49.2777 68.7771C49.1823 68.7489 47.4075 68.2582 47.2053 68.1398C47.0087 67.948 46.829 67.0794 46.8234 67.0343C46.7223 67.0343 44.7397 67.023 44.6274 66.9609C44.5207 66.8989 42.9874 67.5306 42.9032 67.5645L42.701 68.2808L41.9877 68.8279L41.1284 68.4387L39.4155 68.7997L38.2192 69.86L38.5393 71.3773L39.73 72.9114L40.5893 74.0733L42.2012 74.564L43.1166 74.2199L44.5151 74.2425L44.8015 73.3965L44.0714 72.5956L45.2789 72.0541L46.683 71.6198L47.4637 74.4907L49.1598 73.8985L51.4288 74.2707L52.3723 75.7936L54.2482 76.8088L55.4782 75.7936L57.8539 75.4213L57.545 74.6881L58.8536 73.2667L60.1117 72.5786L62.5379 73.2047L67.1826 72.2064L69.2887 72.3361L71.9565 73.2498L73.4448 72.4997L76.9887 72.9565L80.6169 74.6542L82.6388 74.4456L84.7842 74.6937L87.7552 74.2594L89.94 74.6148L91.945 74.2481L93.3884 75.3085L94.2814 76.6227L94.1354 78.7716L96.9941 82.1106C97.0334 82.1952 97.7692 83.7632 97.6793 83.8704C97.5895 83.9776 95.4833 84.6657 95.3766 84.6995L93.849 86.0193L95.1857 87.3786L96.0281 89.9675L95.8877 91.4565L94.2197 91.9867L95.4553 92.844L96.1404 93.6055L94.2084 94.7279L94.6072 95.3032L94.2084 96.0195L95.854 97.4352L95.2081 98.2474L97.1345 98.332L97.7355 98.9073L98.6341 99.6574L98.2971 100.447L99.9539 101.135L102.728 101.022L103.857 101.44L103.256 102.427C103.071 102.444 99.5215 102.754 99.4653 102.771C99.4091 102.788 95.5732 101.993 95.371 101.953L91.8496 100.819L91.2879 100.047L89.3503 98.8791L86.4803 97.4972L85.9131 95.9856L79.2465 93.487L76.4496 88.8282L71.496 89.8603L67.1602 88.6872L64.4081 84.4513L61.6281 85.0379L59.1063 83.5545L58.8592 80.3678L59.4433 79.0198L59.1063 77.6154L57.955 76.5776L57.5281 77.0739L56.2532 78.0045L54.1471 77.542L50.884 77.1077L49.4912 76.1715L47.6041 76.1884L45.5429 76.1489L43.448 75.9459L42.1562 76.4422L37.9889 76.5832L35.4559 76.4027L34.6416 75.4552L33.1476 74.3609L31.2605 73.9379L28.9354 72.7817H27.5088L29.8003 74.2199L31.1033 74.5076L31.9682 75.2521L31.429 75.568L29.5981 74.767L27.565 74.3722L25.633 73.5431L26.1384 72.8042L25.0657 72.3474L24.1334 71.1573L22.6563 71.1178L20.3031 70.5256L18.4272 68.2864L18.7361 65.5509L18.6799 63.7404L17.7645 63.3568L16.6188 62.6574L17.1018 62.178L16.2537 61.2812L15.3214 60.9767L15.8886 62.2683L15.2596 62.4488L14.2824 61.8227L15.0012 61.1064L14.0802 60.4295L13.6646 59.1492L11.6258 58.8728L9.21081 59.6568L6.63291 60.5536L5.48718 60.9879L5.4254 62.1893C4.88062 62.4431 3.90899 63.1087 3.34174 63.1538C3.08339 63.1763 2.79695 63.0748 2.51052 62.9113C1.59506 62.3811 0.62905 61.1402 0.123579 60.6439C0.0730324 60.5875 0.0112527 60.5311 2.00744e-05 60.4521C-0.0112126 60.3506 0.0561834 60.2434 0.10673 60.1419C0.27522 59.8148 0.286453 59.4594 0.381931 59.1154C0.584119 58.4047 1.07836 58.1396 1.73547 57.8914C1.87026 57.8407 3.04407 57.4289 3.14517 57.4853L2.24655 56.5716L8.23357 53.351L11.6314 53.1311L16.4166 52.4204L18.2194 51.8677L22.1733 50.0684L22.617 50.2489L24.0885 49.7131L26.3856 49.6116L27.2954 49.7131L28.9522 49.3183L30.1429 48.8332L31.1763 48.5456L31.4122 48.3312L32.1872 48.3199L34.7876 47.9251L35.3324 47.2765L36.1018 46.6843L37.4104 46.7463L37.1521 46.0187L38.2866 45.1952L37.7025 44.6369L38.5393 43.8867L39.6345 43.255H40.168L40.915 43.3396L41.0049 43.7006L40.7858 44.5805L41.7912 45.0712C41.7912 45.0712 42.1338 44.6651 42.2461 44.4846L42.8414 44.3831C43.4255 44.3041 44.0489 44.3041 44.0826 44.3041L44.7959 45.0148L43.8074 45.9003L43.5378 46.4981L43.8187 47.3611L41.6845 48.241L41.1284 47.4683L40.2523 48.4102L39.129 49.2449L37.7699 50.1643L36.6298 51.7097L37.5452 52.7363L39.2975 52.3471L41.1284 52.7757L42.8414 52.7475L43.3806 54.355L44.8184 54.0561L44.0714 52.6629L45.2901 52.2174L45.8349 50.8637L44.5432 50.1587L45.5541 49.4649L44.8465 48.3651L45.7338 47.4175L47.5872 47.1411L49.2272 47.1581L50.5246 48.3087L52.114 47.6882L52.1982 46.8309L53.226 46.893L54.6582 48.4102L55.7646 48.4553L57.2249 48.9122L57.2361 48.9178Z",
    fill: "#1D244A"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5111 50.3382C31.5111 49.6003 31.2544 49.0805 30.8447 48.8345L35.5479 51.635C35.9576 51.8809 36.2143 52.4008 36.2143 53.1386C36.2143 54.6255 35.1928 56.4421 33.931 57.1856L29.2278 54.3851C30.4896 53.6417 31.5166 51.825 31.5111 50.3382Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5945 54.5472C28.0096 54.7932 28.5887 54.7596 29.2278 54.3851L33.931 57.1856C33.2919 57.5601 32.7128 57.5992 32.2977 57.3477C30.8884 56.5092 29.0038 55.3913 27.5945 54.5472Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8446 48.8345L35.5478 51.635C35.1327 51.389 34.5537 51.4226 33.92 51.7971L29.2168 48.9966C29.8504 48.6221 30.4295 48.583 30.8446 48.8345Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2976 57.3477L27.5944 54.5472C27.1847 54.3013 26.928 53.7814 26.928 53.0436C26.928 51.5511 27.944 49.7457 29.2113 48.9966L33.9145 51.7971C32.6472 52.5461 31.6257 54.3516 31.6312 55.844C31.6312 56.5819 31.8825 57.1017 32.2976 57.3477Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.92 51.7971C35.1819 51.0536 36.2143 51.6461 36.2197 53.1386C36.2197 54.6255 35.1983 56.4421 33.9364 57.1855C32.6691 57.9346 31.6367 57.3309 31.6367 55.844C31.6367 54.3516 32.6527 52.5461 33.92 51.7971Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7893 45.3577L37.4925 48.1582C36.5584 47.5992 35.2638 47.6775 33.8326 48.5215L29.1294 45.7211C30.5551 44.877 31.8552 44.7988 32.7893 45.3577Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8762 65L29.173 62.1995C28.9108 61.9983 24 58.1638 24 54.8155C23.9891 51.4729 26.2834 47.4036 29.1293 45.7211L33.8325 48.5215C30.9866 50.204 28.6923 54.2733 28.7032 57.616C28.7032 60.9642 33.614 64.7988 33.8708 65H33.8762Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8324 48.5215C36.6729 46.8446 38.989 48.1917 38.9945 51.54C39.0054 54.877 34.1274 64.4969 33.8707 65C33.6139 64.7988 28.7032 60.9642 28.7032 57.616C28.6922 54.2789 30.9865 50.204 33.8324 48.5215ZM33.9308 57.1856C35.1926 56.4421 36.2196 54.6255 36.2141 53.1386C36.2141 51.6462 35.1762 51.0537 33.9144 51.7971C32.6471 52.5461 31.6256 54.3516 31.6311 55.844C31.6311 57.3309 32.6635 57.9346 33.9308 57.1856Z",
    fill: "#F7CE6C"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.511 41.3382C173.511 40.6003 173.254 40.0805 172.845 39.8345L177.548 42.635C177.958 42.8809 178.214 43.4008 178.214 44.1386C178.214 45.6255 177.193 47.4421 175.931 48.1856L171.228 45.3851C172.49 44.6417 173.517 42.825 173.511 41.3382Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.594 45.5472C170.01 45.7932 170.589 45.7596 171.228 45.3851L175.931 48.1856C175.292 48.5601 174.713 48.5992 174.298 48.3477C172.888 47.5092 171.004 46.3913 169.594 45.5472Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.845 39.8345L177.548 42.635C177.133 42.389 176.554 42.4226 175.92 42.7971L171.217 39.9966C171.85 39.6221 172.429 39.583 172.845 39.8345Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.298 48.3477L169.594 45.5472C169.185 45.3013 168.928 44.7814 168.928 44.0436C168.928 42.5511 169.944 40.7457 171.211 39.9966L175.915 42.7971C174.647 43.5461 173.626 45.3516 173.631 46.844C173.631 47.5819 173.882 48.1017 174.298 48.3477Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.92 42.7971C177.182 42.0536 178.214 42.6461 178.22 44.1386C178.22 45.6255 177.198 47.4421 175.936 48.1855C174.669 48.9346 173.637 48.3309 173.637 46.844C173.637 45.3516 174.653 43.5461 175.92 42.7971Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.789 36.3577L179.492 39.1582C178.558 38.5992 177.264 38.6775 175.833 39.5215L171.129 36.7211C172.555 35.877 173.855 35.7988 174.789 36.3577Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.876 56L171.173 53.1995C170.911 52.9983 166 49.1638 166 45.8155C165.989 42.4729 168.283 38.4036 171.129 36.7211L175.833 39.5215C172.987 41.204 170.692 45.2733 170.703 48.616C170.703 51.9642 175.614 55.7988 175.871 56H175.876Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.832 39.5215C178.673 37.8446 180.989 39.1917 180.994 42.54C181.005 45.877 176.127 55.4969 175.871 56C175.614 55.7988 170.703 51.9642 170.703 48.616C170.692 45.2789 172.986 41.204 175.832 39.5215ZM175.931 48.1856C177.193 47.4421 178.22 45.6255 178.214 44.1386C178.214 42.6462 177.176 42.0537 175.914 42.7971C174.647 43.5461 173.626 45.3516 173.631 46.844C173.631 48.3309 174.663 48.9346 175.931 48.1856Z",
    fill: "#F7CE6C"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_883_183857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5111 74.3382C84.5111 73.6003 84.2544 73.0805 83.8447 72.8345L88.5479 75.635C88.9576 75.8809 89.2143 76.4008 89.2143 77.1386C89.2143 78.6255 88.1928 80.4421 86.931 81.1856L82.2278 78.3851C83.4896 77.6417 84.5166 75.825 84.5111 74.3382Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5945 78.5472C81.0096 78.7932 81.5887 78.7596 82.2278 78.3851L86.931 81.1856C86.2919 81.5601 85.7128 81.5992 85.2977 81.3477C83.8884 80.5092 82.0038 79.3913 80.5945 78.5472Z",
    fill: "#F7CE6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8446 72.8345L88.5478 75.635C88.1327 75.389 87.5537 75.4226 86.92 75.7971L82.2168 72.9966C82.8504 72.6221 83.4295 72.583 83.8446 72.8345Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2976 81.3477L80.5944 78.5472C80.1847 78.3013 79.928 77.7814 79.928 77.0436C79.928 75.5511 80.944 73.7457 82.2113 72.9966L86.9145 75.7971C85.6472 76.5461 84.6257 78.3516 84.6312 79.844C84.6312 80.5819 84.8825 81.1017 85.2976 81.3477Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.92 75.7971C88.1819 75.0536 89.2143 75.6461 89.2197 77.1386C89.2197 78.6255 88.1983 80.4421 86.9364 81.1855C85.6691 81.9346 84.6367 81.3309 84.6367 79.844C84.6367 78.3516 85.6527 76.5461 86.92 75.7971Z",
    fill: "#785617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7893 69.3577L90.4925 72.1582C89.5584 71.5992 88.2638 71.6775 86.8326 72.5215L82.1294 69.7211C83.5551 68.877 84.8552 68.7988 85.7893 69.3577Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8762 89L82.173 86.1995C81.9108 85.9983 77 82.1638 77 78.8155C76.9891 75.4729 79.2834 71.4036 82.1293 69.7211L86.8325 72.5215C83.9866 74.204 81.6923 78.2733 81.7032 81.616C81.7032 84.9642 86.614 88.7988 86.8708 89H86.8762Z",
    fill: "#B18635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8324 72.5215C89.6729 70.8446 91.989 72.1917 91.9945 75.54C92.0054 78.877 87.1274 88.4969 86.8707 89C86.6139 88.7988 81.7032 84.9642 81.7032 81.616C81.6922 78.2789 83.9865 74.204 86.8324 72.5215ZM86.9308 81.1856C88.1926 80.4421 89.2196 78.6255 89.2141 77.1386C89.2141 75.6462 88.1762 75.0537 86.9144 75.7971C85.6471 76.5461 84.6256 78.3516 84.6311 79.844C84.6311 81.3309 85.6635 81.9346 86.9308 81.1856Z",
    fill: "#F7CE6C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_183857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 111,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_883_183857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(99 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_883_183857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(24 45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_883_183857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(166 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_883_183857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white",
    transform: "translate(77 69)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsCountries);
export default __webpack_public_path__ + "static/media/stats_Countries.62af13198f8ceec9a041276699559c21.svg";
export { ForwardRef as ReactComponent };